var _desc, _defs, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebdev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.625 0 0 0.625 500 500)",
    id: 340226
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -432.3 -307.2)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 12.8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -405.1 -284.6)",
    id: "details"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    x: 0,
    y: 0,
    rx: 0,
    ry: 0,
    width: 0,
    height: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -226.2 193.6)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 9.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 416.4 -363.8)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 13.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -71.5 -371.5)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 5.6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -418 -354.6)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 9.1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -202.9 178)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.6 -400.4)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 5.9
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 384.7 -394.1)",
    id: "details"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    cx: 0,
    cy: 0,
    r: 3.4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 395.9793 12.9464)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1195.9793, -612.9464)",
    d: "M 1166.6 606.1 c 2.6 -5.2 8.7 1.5 10.5 3.5 c 1.8 2 4 4.2 6.8 4.7 c 5.3 1 7.8 -3.8 12 -5.6 c 5.9 -2.7 7.3 7.2 11.6 9.3 c 2 1 3.6 0.5 5.6 -0.1 c 2.3 -0.6 4 -2 6.5 -1.3 c 3 0.8 5.1 3.3 5.5 6.4 c 0.2 1.9 3.2 1.9 3 0 c -0.6 -6.1 -6.4 -11 -12.6 -9.4 c -2.6 0.7 -5.2 2.8 -7.6 0.9 c -1.4 -1.1 -2.2 -3.3 -3.2 -4.8 c -1.4 -2.1 -3 -4.1 -5.6 -4.5 c -3 -0.5 -5.3 1.2 -7.6 2.9 c -2.4 1.8 -3.9 3.4 -7 2.9 c -3.1 -0.6 -4.6 -2.9 -6.7 -5.1 c -3.3 -3.6 -10.8 -7.2 -13.8 -1.3 C 1163.2 606.3 1165.8 607.8 1166.6 606.1 L 1166.6 606.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 417.3498 35.6806)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1217.3498, -635.6806)",
    d: "M 1189.7 627.3 c 4.6 -0.7 9.4 0.6 12.9 3.6 c 2.5 2.1 3.3 4.7 5 7.3 c 3.5 5.3 7.9 0.7 12.5 0.2 c 7.1 -0.8 10.8 7.5 17.6 8.6 c 4 0.6 7.6 -1.1 9.1 -4.9 c 0.7 -1.8 -2.2 -2.6 -2.9 -0.8 c -3.4 8.5 -14.2 -3.2 -18.3 -5.1 c -1.8 -0.8 -3.8 -1.4 -5.7 -1.2 c -2.6 0.2 -7.3 4 -9.7 1.8 c -1.4 -1.3 -2 -4.2 -3.4 -5.8 c -1.3 -1.6 -2.9 -3 -4.7 -4 c -4.1 -2.5 -8.6 -3.2 -13.3 -2.5 C 1187 624.7 1187.8 627.6 1189.7 627.3 L 1189.7 627.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -490.4201 -167.4714)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-309.5799, -432.5286)",
    d: "M 290.6 459.9 c -1.1 -6.1 -1.3 -12.1 5.7 -14.5 c 2.8 -1 5.8 -1.5 8.1 -3.5 c 4.2 -3.6 3.9 -9.3 3.6 -14.4 c -0.2 -3.7 -1.1 -9.4 4.5 -7.9 c 1.8 0.5 3.7 1.2 5.5 0.3 c 1.4 -0.7 2 -1.9 2.4 -3.3 c 0.9 -3 0 -5.4 2.6 -7.9 c 2.1 -2.1 4.7 -2.7 7.6 -2.3 c 1.9 0.3 1.9 -2.7 0 -3 c -3.2 -0.4 -6.2 0.3 -8.7 2.3 c -3.2 2.5 -3.3 5.1 -4.3 8.7 c -1.5 5.1 -5.2 0.9 -8.9 1.6 c -2.3 0.4 -3.3 2 -3.8 4.1 c -0.9 4 0.4 8.3 0.3 12.3 c -0.3 7.5 -5.3 8.2 -11 10.5 c -7.8 3.1 -7.7 10.5 -6.4 17.7 C 288 462.6 290.9 461.8 290.6 459.9 L 290.6 459.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -462.9791 -179.2334)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-337.0209, -420.7667)",
    d: "M 324 440.1 c -6 -7.7 0.9 -15.3 9.2 -14.6 c 2.5 0.2 4.6 0 5.9 -2.3 c 1.8 -3 1.2 -7.1 2.6 -10.3 c 2.3 -5.5 6.8 -9.4 12.4 -11.2 c 1.8 -0.6 1 -3.5 -0.8 -2.9 c -5 1.6 -9.3 4.6 -12.3 9 c -1.7 2.5 -2.9 5.3 -3.4 8.3 c -0.2 1 -0.2 2.9 -0.5 3.8 c -0.8 2.6 -3.3 2.3 -5.6 2.4 c -10.6 0.6 -16.5 11.1 -9.6 20 C 323 443.8 325.1 441.7 324 440.1 L 324 440.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -186.5954 -411.8499)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-613.4047, -188.1501)",
    d: "M 607.1 190.5 c -1.7 -5.6 3.8 -11.4 9.4 -8.4 c 6.1 3.2 4 12.1 -2.7 12.8 c -1.9 0.2 -1.9 3.2 0 3 c 9 -0.9 13 -12.6 4.9 -17.9 c -7.8 -5.1 -17.2 2.8 -14.5 11.4 C 604.8 193.1 607.7 192.3 607.1 190.5 L 607.1 190.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 149.5596 174.8844)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-949.5595, -774.8845)",
    d: "M 938.6 758.4 c -4.1 4.9 1.5 9.1 5.8 10.8 c 3.3 1.3 5.5 3 6 6.7 c 0.2 1.7 0.2 3.4 0.6 5 c 0.4 1.3 0.9 2.5 1.8 3.4 c 1.4 1.5 6.8 2.9 6 5.7 c -0.5 1.9 2.4 2.7 2.9 0.8 c 0.7 -2.5 -0.1 -4.3 -2.2 -6 c -1.4 -1.1 -3.4 -1.4 -4.6 -2.7 c -1.9 -2 -1.3 -5.2 -1.7 -7.6 c -0.4 -2.3 -1.1 -4.3 -2.9 -5.9 c -1.9 -1.6 -12.9 -4.2 -9.6 -8.2 C 942 759 939.9 756.9 938.6 758.4 L 938.6 758.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 165.619 165.2521)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-965.619, -765.2521)",
    d: "M 951.8 748.4 c -0.9 2.2 -0.1 4.3 1.7 5.8 c 1.7 1.4 4.4 1.5 5.9 3.1 c 1.6 1.7 1.4 4 1.8 6.2 c 0.5 2.8 1.5 4.9 4.1 6.3 c 1.9 1 4 1.3 5.8 2.4 c 3.3 2.1 5.2 5.7 5.7 9.5 c 0.2 1.9 3.2 1.9 3 0 c -0.8 -7.1 -4.9 -11.5 -11.4 -14 c -5.1 -1.9 -3.6 -6.2 -5.3 -10.2 c -0.5 -1.3 -1.2 -2.2 -2.3 -3 c -1.7 -1.2 -7.4 -2.2 -6.1 -5.4 C 955.4 747.4 952.5 746.6 951.8 748.4 L 951.8 748.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 203.7075 -466.5204)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1003.7075, -133.4795)",
    d: "M 986.7 146.6 c -3.1 -4.1 3.1 -7 6.2 -7.4 c 2.3 -0.3 4.7 -0.1 7 -0.5 c 3.2 -0.6 6.1 -2.1 8.3 -4.6 c 2 -2.3 2.3 -4.6 3.2 -7.4 c 0.5 -1.7 1.8 -4.5 3.7 -5.3 c 0.7 -0.3 2.4 0.2 3.3 0.2 c 1.7 0.1 3.2 0.1 4.9 -0.3 c 1.9 -0.4 1.1 -3.3 -0.8 -2.9 c -4 0.8 -9.5 -1.7 -12.5 2 c -1.1 1.4 -1.2 3.1 -1.4 4.8 c -0.6 4.6 -2.8 8.6 -7.5 10 c -5.2 1.6 -11.3 -0.5 -15.6 3.8 c -2.5 2.5 -3.4 6 -1.3 8.9 C 985.3 149.6 987.9 148.1 986.7 146.6 L 986.7 146.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 231.2317 -464.1795)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1031.2317, -135.8205)",
    d: "M 1017 145.4 c 0.1 -5 2.6 -9.6 7 -12.2 c 3.3 -2 7 -1.8 10.8 -1.8 c 5.1 0.1 10 0 13.3 -4.4 c 1.1 -1.6 -1.5 -3.1 -2.6 -1.5 c -4.4 5.9 -15.5 1.5 -21.8 4.5 c -5.9 2.8 -9.5 8.9 -9.6 15.4 C 1014 147.3 1017 147.3 1017 145.4 L 1017 145.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -180.1853 -103.9996)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-619.8147, -496.0005)",
    d: "M 608 483.7 c 0.9 -0.2 1.8 -0.5 2.8 -0.7 c 0.4 0.9 0.8 1.9 1.2 2.8 c 0.2 1.3 -0.3 2.8 -0.5 4 c -0.2 1.5 -0.5 2.8 -0.4 4.3 c 0.2 2.2 1.1 4.6 3.1 5.7 c 3 1.6 6.4 -0.7 9.5 0.9 c 4.1 2 6.3 6.9 8.1 10.9 c 0.8 1.8 3.4 0.2 2.6 -1.5 c -1.9 -4.3 -4.4 -9.1 -8.6 -11.6 c -2.1 -1.2 -3.7 -1.2 -6 -1.4 c -2.4 -0.2 -3.2 2.6 -5.6 -2.3 c -0.7 -1.6 0.2 -4 0.4 -5.6 c 0.5 -3.5 0.7 -7.7 -3.2 -9.2 c -2.6 -1 -5.8 -0.1 -6.3 2.9 C 604.8 484.8 607.7 485.6 608 483.7 L 608 483.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -164.824 -106.5616)",
    id: "details"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-635.176, -493.4385)",
    d: "M 628.5 480 c -2.9 2 -1.7 5.2 0.3 7.6 c 2.2 2.6 4.7 4.7 6.7 7.6 c 2.3 3.4 3.9 7.1 5.1 10.9 c 0.6 1.8 3.5 1.1 2.9 -0.8 c -1.3 -4.1 -3 -8.1 -5.4 -11.7 c -1.1 -1.6 -9.3 -10.2 -8 -11.1 C 631.6 481.5 630.1 478.9 628.5 480 L 628.5 480 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -313.6128 -292.5693)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-486.3873, -307.4307)",
    d: "M 484.1 251.4 c 3.1 37.1 6 74.8 -1.6 111.6 c -0.4 1.9 2.5 2.7 2.9 0.8 c 7.7 -37.1 4.8 -75 1.7 -112.4 C 486.9 249.5 483.9 249.5 484.1 251.4 L 484.1 251.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -262.8664 -352.3314)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-537.1336, -247.6685)",
    d: "M 485.8 252.4 c 18.4 0.8 36.9 0.8 55.3 -0.1 c 15.9 -0.8 33.2 -0.8 48 -7.2 c 1.8 -0.8 0.2 -3.4 -1.5 -2.6 c -15.4 6.7 -33.9 6.3 -50.4 7 c -17.1 0.7 -34.3 0.7 -51.4 -0.1 C 483.9 249.3 483.9 252.3 485.8 252.4 L 485.8 252.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -207.2644 -299.15)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-592.7356, -300.85)",
    d: "M 586.6 244.7 c 9.6 36.6 11.9 74.8 6.6 112.3 c -0.3 1.9 2.6 2.7 2.9 0.8 c 5.3 -38.1 3.1 -76.7 -6.6 -113.9 C 589.1 242 586.2 242.8 586.6 244.7 L 586.6 244.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -260.982 -237.5196)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-539.0179, -362.4804)",
    d: "M 483.3 364.5 c 19.8 4.4 40.2 4.8 60.4 3.4 c 10.2 -0.7 20.5 -1.9 30.7 -3.1 c 7.3 -0.9 14.9 -1.3 20.9 -6 c 1.5 -1.2 -0.6 -3.3 -2.1 -2.1 c -6.8 5.3 -17.4 5 -25.5 5.9 c -9.2 1.1 -18.5 2 -27.8 2.6 c -18.7 1.1 -37.4 0.6 -55.7 -3.5 C 482.2 361.2 481.4 364.1 483.3 364.5 L 483.3 364.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -300.7193 -246.3033)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-499.2807, -353.6967)",
    d: "M 491.3 355.7 c 2.4 0.1 4.7 -0.7 7.1 -0.9 c 2.9 -0.2 5.6 0.1 8.4 0.8 c 1.9 0.5 2.7 -2.4 0.8 -2.9 c -2.6 -0.7 -5.3 -1.1 -8 -1 c -2.8 0.1 -5.5 1.1 -8.3 1 C 489.4 352.6 489.4 355.6 491.3 355.7 L 491.3 355.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -299.5 -252.7012)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-500.5, -347.2988)",
    d: "M 493.1 348.7 c 4.9 0.1 9.9 0.1 14.8 0.2 c 1.9 0 1.9 -3 0 -3 c -4.9 -0.1 -9.9 -0.1 -14.8 -0.2 C 491.2 345.6 491.2 348.6 493.1 348.7 L 493.1 348.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -299.35 -260)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-500.65, -340)",
    d: "M 494.1 341.2 c 4.4 0.2 8.7 0.4 13.1 0.6 c 1.9 0.1 1.9 -2.9 0 -3 c -4.4 -0.2 -8.7 -0.4 -13.1 -0.6 C 492.2 338.1 492.2 341.1 494.1 341.2 L 494.1 341.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -297.1 -279.699)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-502.9, -320.3011)",
    d: "M 495.5 322.2 c 4.9 -0.6 9.8 -0.9 14.8 -0.8 c 1.9 0 1.9 -3 0 -3 c -4.9 -0.1 -9.9 0.2 -14.8 0.8 C 493.6 319.5 493.6 322.5 495.5 322.2 L 495.5 322.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -296.45 -287.05)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-503.55, -312.95)",
    d: "M 496.5 314.3 c 4.7 0.1 9.4 0.2 14.1 0.3 c 1.9 0 1.9 -3 0 -3 c -4.7 -0.1 -9.4 -0.2 -14.1 -0.3 C 494.6 311.3 494.6 314.3 496.5 314.3 L 496.5 314.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -298.15 -294.0176)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-501.85, -305.9824)",
    d: "M 495.5 307.5 c 4.3 0.3 8.5 0.2 12.7 -0.2 c 1.9 -0.2 1.9 -3.2 0 -3 c -4.2 0.5 -8.5 0.5 -12.7 0.2 C 493.6 304.3 493.6 307.3 495.5 307.5 L 495.5 307.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -296.0948 -313.8874)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-503.9052, -286.1126)",
    d: "M 496.2 288.3 c 5.2 -1 10.4 -1.5 15.8 -1.4 c 1.9 0 1.9 -3 0 -3 c -5.6 -0.1 -11.1 0.4 -16.6 1.5 C 493.6 285.8 494.4 288.7 496.2 288.3 L 496.2 288.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -295.6875 -320.5713)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-504.3125, -279.4287)",
    d: "M 495.9 281 c 5.6 0.1 11.2 0.1 16.9 -0.2 c 1.9 -0.1 1.9 -3.1 0 -3 c -5.6 0.3 -11.2 0.4 -16.9 0.2 C 493.9 277.9 493.9 280.9 495.9 281 L 495.9 281 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -296.9 -328.624)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-503.1, -271.3761)",
    d: "M 493.8 273.2 c 6.2 0.2 12.4 -0.1 18.6 -0.7 c 1.9 -0.2 1.9 -3.2 0 -3 c -6.2 0.6 -12.4 0.9 -18.6 0.7 C 491.9 270.2 491.9 273.2 493.8 273.2 L 493.8 273.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -249.6807 -332.7007)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-550.3193, -267.2993)",
    d: "M 527.2 270.4 c 15.5 -2.3 31.1 -3.4 46.7 -3.2 c 1.9 0 1.9 -3 0 -3 c -15.9 -0.2 -31.8 0.9 -47.5 3.3 C 524.5 267.8 525.3 270.7 527.2 270.4 L 527.2 270.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -246.5375 -326.7964)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-553.4625, -273.2036)",
    d: "M 530.3 276 c 15.4 -1.3 30.9 -2.1 46.4 -2.6 c 1.9 -0.1 1.9 -3.1 0 -3 c -15.5 0.4 -31 1.3 -46.4 2.6 C 528.3 273.2 528.3 276.2 530.3 276 L 530.3 276 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -246.85 -319.0382)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-553.15, -280.9619)",
    d: "M 529.1 282.7 c 16 -0.8 32.1 1.1 48.1 -0.6 c 1.9 -0.2 1.9 -3.2 0 -3 c -16 1.8 -32.1 -0.2 -48.1 0.6 C 527.2 279.8 527.2 282.8 529.1 282.7 L 529.1 282.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -269.9375 -294.05)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-530.0625, -305.95)",
    d: "M 519.6 307.5 c 7 0 14 -0.1 21 -0.1 c 1.9 0 1.9 -3 0 -3 c -7 0 -14 0.1 -21 0.1 C 517.6 304.5 517.6 307.5 519.6 307.5 L 519.6 307.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -256.6094 -286.9074)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-543.3906, -313.0926)",
    d: "M 520.3 315.1 c 7.5 -0.2 15.1 -0.4 22.6 -0.5 c 2.1 0 22.1 -1.1 22.1 -0.9 c 0.6 1.8 3.5 1.1 2.9 -0.8 c -0.6 -2.1 -2.4 -1.8 -4.3 -1.8 c -4.6 0 -9.2 0.2 -13.8 0.3 c -9.8 0.2 -19.7 0.5 -29.5 0.7 C 518.3 312.1 518.3 315.1 520.3 315.1 L 520.3 315.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -270.7875 -278.7713)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-529.2125, -321.2287)",
    d: "M 520.3 322.6 c 6 0.3 11.9 0.3 17.9 0.2 c 1.9 -0.1 1.9 -3.1 0 -3 c -6 0.2 -11.9 0.1 -17.9 -0.2 C 518.3 319.5 518.3 322.5 520.3 322.6 L 520.3 322.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -253.1 -262.491)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-546.9, -337.509)",
    d: "M 516.8 339.8 c 20 -1.3 40.1 -1.8 60.2 -1.5 c 1.9 0 1.9 -3 0 -3 c -20.1 -0.3 -40.1 0.2 -60.2 1.5 C 514.9 336.9 514.9 339.9 516.8 339.8 L 516.8 339.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -272.55 -255.25)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-527.45, -344.75)",
    d: "M 519.9 346.4 c 5 -0.1 10.1 -0.2 15.1 -0.3 c 1.9 0 1.9 -3 0 -3 c -5 0.1 -10.1 0.2 -15.1 0.3 C 518 343.4 518 346.4 519.9 346.4 L 519.9 346.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -240.7188 -256.1964)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-559.2811, -343.8036)",
    d: "M 547.1 346.3 c 8.1 -0.8 16.3 -1.5 24.4 -2 c 1.9 -0.1 1.9 -3.1 0 -3 c -8.2 0.5 -16.3 1.2 -24.4 2 C 545.2 343.5 545.1 346.5 547.1 346.3 L 547.1 346.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -256.9 -246.1512)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-543.1, -353.8488)",
    d: "M 518.5 356 c 16.4 -0.2 32.8 -0.7 49.2 -1.3 c 1.9 -0.1 1.9 -3.1 0 -3 c -16.4 0.7 -32.8 1.1 -49.2 1.3 C 516.6 353 516.6 356 518.5 356 L 518.5 356 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.046 -234.9435)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-648.954, -365.0565)",
    d: "M 598.8 297.3 c 25.9 -4.8 52.2 -7.1 78.6 -6.9 c -0.5 -0.4 -1 -0.7 -1.4 -1.1 c 15.4 49.1 22.8 100.5 21.9 152 c 0 1.9 3 1.9 3 0 c 0.9 -51.7 -6.5 -103.4 -22 -152.8 c -0.2 -0.6 -0.8 -1.1 -1.4 -1.1 c -26.6 -0.2 -53.2 2.1 -79.4 7 C 596.1 294.7 596.9 297.6 598.8 297.3 L 598.8 297.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -258.7318 -191.874)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-541.2682, -408.1259)",
    d: "M 545.4 366.7 c 1.8 28.1 -2.1 56.1 -11.6 82.5 c -0.6 1.8 2.2 2.6 2.9 0.8 c 9.5 -26.7 13.5 -55 11.7 -83.3 C 548.3 364.8 545.3 364.7 545.4 366.7 L 545.4 366.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -182.9523 -150.0421)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-617.0477, -449.9579)",
    d: "M 534.3 451.4 c 25.2 10.7 52.8 9.6 79.5 7.1 c 29.1 -2.8 57.7 -7.5 85.7 -15.8 c 1.8 -0.5 1.1 -3.4 -0.8 -2.9 c -27.2 8 -54.9 12.8 -83.2 15.5 c -26.6 2.6 -54.5 4.2 -79.7 -6.5 C 534.1 448 532.6 450.6 534.3 451.4 L 534.3 451.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -237.5625 -217.4246)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-562.4375, -382.5754)",
    d: "M 569.5 375 c -5.4 2.9 -10.6 6.2 -15.7 9.7 c -1 0.7 -1 2.5 0.4 2.7 c 4.6 1 9.2 1.9 13.8 2.9 c 1.9 0.4 2.7 -2.5 0.8 -2.9 c -4.6 -1 -9.2 -1.9 -13.8 -2.9 c 0.1 0.9 0.2 1.8 0.4 2.7 c 5 -3.5 10.3 -6.8 15.7 -9.7 C 572.7 376.7 571.2 374.1 569.5 375 L 569.5 375 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -215.8 -217.4279)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-584.2, -382.5721)",
    d: "M 592.8 365.8 c -6.6 10.7 -13.2 21.4 -19.8 32 c -1 1.6 1.6 3.2 2.6 1.5 c 6.6 -10.7 13.2 -21.4 19.8 -32 C 596.4 365.7 593.8 364.2 592.8 365.8 L 592.8 365.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -194.1 -214.3)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-605.9, -385.7)",
    d: "M 597.4 388.5 c 5.9 -0.9 11.9 -1.8 17.8 -2.7 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -5.9 0.9 -11.9 1.8 -17.8 2.7 C 594.7 385.9 595.5 388.8 597.4 388.5 L 597.4 388.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -166.871 -217.2376)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-633.129, -382.7625)",
    d: "M 627.2 372.4 c -0.1 0 -0.2 0 -0.3 0 c -0.7 -0.1 -1.3 0.1 -1.7 0.7 c -0.1 0.1 -0.1 0.2 -0.2 0.3 c -0.3 0.4 -0.3 1.1 0 1.5 c 2.3 3.4 7.7 4.2 11.4 5 c 0.7 0.2 1.4 0.3 2.1 0.5 c -0.1 0.1 -0.3 0.2 -0.4 0.3 c 0 0.7 -3.2 3.1 -3.8 3.6 c -2.2 2.1 -4.4 4.2 -6.6 6.3 c -1.4 1.3 0.7 3.5 2.1 2.1 c 2.7 -2.5 5.3 -5.1 8 -7.6 c 1.4 -1.4 4.2 -3.2 3.6 -5.5 c -0.5 -1.9 -2.6 -2.1 -4.3 -2.6 c -2.7 -0.7 -7.9 -1.1 -9.6 -3.7 c 0 0.5 0 1 0 1.5 c 0.1 -0.1 0.1 -0.2 0.2 -0.3 c -0.6 0.2 -1.1 0.5 -1.7 0.7 c 0.1 0 0.2 0 0.3 0 C 628.3 375.6 629.1 372.7 627.2 372.4 L 627.2 372.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -185.6807 -294.6138)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-614.3193, -305.3862)",
    d: "M 606.7 307.4 c 5.2 -0.9 10.4 -1.2 15.7 -1 c 1.9 0.1 1.9 -2.9 0 -3 c -5.6 -0.2 -11.1 0.2 -16.5 1.2 C 604 304.9 604.8 307.7 606.7 307.4 L 606.7 307.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -183.45 -287.3964)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-616.55, -312.6036)",
    d: "M 605.9 315 c 7.1 -0.7 14.2 -1.3 21.3 -1.8 c 1.9 -0.1 1.9 -3.1 0 -3 c -7.1 0.5 -14.2 1.1 -21.3 1.8 C 604 312.2 604 315.2 605.9 315 L 605.9 315 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -183.9091 -273.9108)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-616.0908, -326.0891)",
    d: "M 609.1 326.3 c 0 0 0 0.1 0 0.1 c 0.5 -0.4 1 -0.7 1.4 -1.1 c -0.1 0 -0.1 0 -0.2 0 c 0.4 0.2 0.9 0.5 1.3 0.7 c 0 -0.1 -0.1 -0.1 -0.1 -0.2 c -0.1 0.6 -0.2 1.2 -0.2 1.8 c -0.7 0.2 -0.6 0.3 0.4 0.2 c 0.6 0 1.2 0 1.7 0 c 1 0 2 -0.1 3 -0.1 c 2 -0.2 4 -0.4 6 -0.8 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -2.6 0.5 -5.2 0.7 -7.8 0.8 c -1.6 0 -3.5 -0.5 -4.7 0.7 c -0.5 0.5 -0.5 1.3 -0.2 1.8 c 0.4 0.6 0.9 0.9 1.6 0.9 c 0.6 0 1.3 -0.5 1.4 -1.1 c 0 0 0 -0.1 0 -0.1 C 612.4 325.2 609.5 324.4 609.1 326.3 L 609.1 326.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -180.5807 -261.8566)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-619.4193, -338.1434)",
    d: "M 607 340.9 c 8.4 -1.2 16.8 -2.8 25.3 -2.5 c 1.9 0.1 1.9 -2.9 0 -3 c -8.8 -0.3 -17.5 1.4 -26.1 2.6 C 604.3 338.3 605.1 341.2 607 340.9 L 607 340.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -146 -298.4464)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-654, -301.5536)",
    d: "M 639.6 304.2 c 9.6 -1.3 19.2 -2 28.8 -2.3 c 1.9 -0.1 1.9 -3.1 0 -3 c -9.7 0.3 -19.3 1 -28.8 2.3 C 637.7 301.4 637.7 304.4 639.6 304.2 L 639.6 304.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.95 -286.1)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-655.05, -313.9)",
    d: "M 646.5 316.8 c 6 -1 11.9 -1.9 17.9 -2.9 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -6 1 -11.9 1.9 -17.9 2.9 C 643.8 314.2 644.6 317.1 646.5 316.8 L 646.5 316.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -143.75 -267.5452)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-656.25, -332.4548)",
    d: "M 648.5 334.3 c 5.1 -0.5 10.3 -0.7 15.5 -0.7 c 1.9 0 1.9 -3 0 -3 c -5.2 0 -10.3 0.2 -15.5 0.7 C 646.6 331.5 646.6 334.5 648.5 334.3 L 648.5 334.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -133.2807 -262.4461)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-666.7193, -337.5539)",
    d: "M 657.5 340 c 6.3 -0.9 12.5 -1.5 18.9 -1.9 c 1.9 -0.1 1.9 -3.1 0 -3 c -6.6 0.4 -13.1 1.1 -19.7 2 C 654.8 337.4 655.6 340.2 657.5 340 L 657.5 340 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -241.6 -185.2)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-558.4, -414.8)",
    d: "M 558.4 416.3 c 1.9 0 1.9 -3 0 -3 C 556.5 413.3 556.5 416.3 558.4 416.3 L 558.4 416.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -235.7418 -187.4859)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-564.2582, -412.5142)",
    d: "M 555.2 413.6 c 2.5 0.8 4.9 0.5 7.5 0.4 c 3.4 -0.1 6.8 0.1 10.2 0.4 c 1.9 0.2 1.9 -2.8 0 -3 c -2.9 -0.3 -5.9 -0.5 -8.8 -0.4 c -2.6 0 -5.5 0.6 -8 -0.3 C 554.2 410.1 553.4 413 555.2 413.6 L 555.2 413.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -232.95 -178.8122)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-567.05, -421.1878)",
    d: "M 558.8 422.6 c 5.5 -0.5 11 -0.4 16.5 0.4 c 1.9 0.2 1.9 -2.8 0 -3 c -5.5 -0.7 -11 -0.8 -16.5 -0.4 C 556.9 419.8 556.9 422.8 558.8 422.6 L 558.8 422.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -218.3533 -165.5422)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-581.6467, -434.4578)",
    d: "M 550.1 435.3 c 4.7 1.8 9.6 1.5 14.6 1.5 c 5.8 0 11.6 0 17.4 0 c 10.2 0 21.2 1.1 31.1 -1.9 c 1.8 -0.6 1.1 -3.5 -0.8 -2.9 c -9.6 3 -20.4 1.8 -30.3 1.8 c -5.2 0 -10.3 0 -15.5 0 c -5.3 0 -10.7 0.5 -15.8 -1.4 C 549 431.7 548.3 434.6 550.1 435.3 L 550.1 435.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -188.499 -180.6391)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-611.5009, -419.3609)",
    d: "M 601.8 421.1 c 3.2 -0.2 6.4 -0.3 9.6 -0.5 c 3.2 -0.2 6.5 -0.7 9.5 0.6 c 1.8 0.7 2.6 -2.2 0.8 -2.9 c -2.9 -1.2 -5.8 -0.9 -8.9 -0.7 c -3.7 0.2 -7.4 0.4 -11.1 0.6 C 599.8 418.2 599.8 421.2 601.8 421.1 L 601.8 421.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -186.5375 -154.5036)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-613.4625, -445.4964)",
    d: "M 589.4 448.4 c 16.1 -0.6 32.1 -1.5 48.2 -2.8 c 1.9 -0.2 1.9 -3.2 0 -3 c -16 1.3 -32.1 2.2 -48.2 2.8 C 587.4 445.5 587.4 448.5 589.4 448.4 L 589.4 448.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28.3073 -366.05)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-771.6927, -233.95)",
    d: "M 768.5 162.7 c 4.5 47.4 3.5 95 2.5 142.5 c 0 1.9 3 1.9 3 0 c 1.1 -47.5 2 -95.1 -2.5 -142.5 C 771.3 160.8 768.3 160.8 768.5 162.7 L 768.5 162.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.9125 -441.9836)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-830.9125, -158.0164)",
    d: "M 770.1 163.8 c 20.3 0.9 40.2 -4.8 60.3 -7 c 20.4 -2.2 41 -2.2 61.4 -0.1 c 1.9 0.2 1.9 -2.8 0 -3 c -20.4 -2.1 -41 -2.1 -61.4 0.1 c -20.1 2.2 -40 7.9 -60.3 7 C 768.1 160.8 768.1 163.8 770.1 163.8 L 770.1 163.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 95.6724 -376.9307)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-895.6724, -223.0693)",
    d: "M 890.5 155.9 c 2.7 10.5 3.1 21.3 3.3 32 c 0.3 11.5 0.7 23.1 1.1 34.6 c 0.8 22.7 1.8 45.5 3 68.2 c 0.1 1.9 3.1 1.9 3 0 c -1.2 -23.4 -2.3 -46.8 -3.1 -70.2 c -0.4 -11.5 -0.7 -23 -1 -34.4 c -0.3 -10.4 -0.8 -20.9 -3.4 -31 C 892.9 153.2 890 154 890.5 155.9 L 890.5 155.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36.1339 -298.8235)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-836.1338, -301.1765)",
    d: "M 772.4 307.4 c 21.5 6.2 44.6 3.9 66.5 1.7 c 21.1 -2.1 42 -6.1 61.3 -15.4 c 1.7 -0.8 0.2 -3.4 -1.5 -2.6 c -19.3 9.3 -40.4 13.1 -61.5 15.2 c -21.1 2 -43.3 4.2 -63.9 -1.8 C 771.3 303.9 770.5 306.8 772.4 307.4 L 772.4 307.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 135.108 -377.1808)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-935.108, -222.8192)",
    d: "M 895.7 182.8 c 12.2 -1.9 24.6 -2.5 37 -1.8 c 6.4 0.4 12.8 1.1 19.2 2.2 c 2.7 0.5 5.7 0.7 8.3 1.6 c 3.7 1.3 3.5 4 4.1 7.5 c 4.6 24.5 7.6 49.3 9.1 74.2 c 0.1 1.9 3.1 1.9 3 0 c -0.9 -14.1 -2.2 -28.2 -4 -42.2 c -0.8 -6.5 -1.8 -13 -2.9 -19.5 c -0.6 -3.5 -1.2 -7 -1.8 -10.5 c -0.5 -3 -0.7 -6.8 -1.9 -9.5 c -1.7 -3.9 -8.6 -3.8 -12.2 -4.4 c -6.3 -1.1 -12.6 -1.9 -19 -2.3 c -13.3 -0.9 -26.5 -0.2 -39.7 1.8 C 893 180.2 893.8 183.1 895.7 182.8 L 895.7 182.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100.5083 -281.1494)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-900.5084, -318.8505)",
    d: "M 858.1 306.2 c 1.8 5 2.9 10 3.1 15.3 c 0.1 2.6 -0.3 5.7 1.6 7.8 c 1.9 2.1 5.2 2.1 7.8 2.5 c 4.2 0.6 8.5 1.1 12.7 1.3 c 19.5 1.1 39 -1.4 58.3 -4 c 1.9 -0.2 1.9 -3.3 0 -3 c -16.5 2.2 -33 4.4 -49.7 4.2 c -3.8 0 -7.6 -0.2 -11.4 -0.5 c -2.5 -0.2 -4.9 -0.5 -7.4 -0.8 c -1.7 -0.2 -5.3 -0.1 -6.6 -1.1 c -3.4 -2.5 -2.3 -8.2 -2.9 -11.9 c -0.5 -3.7 -1.5 -7.2 -2.7 -10.7 C 860.3 303.6 857.4 304.3 858.1 306.2 L 858.1 306.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 141.2811 -274.4201)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-941.2811, -325.5799)",
    d: "M 936.8 268.1 c 2.2 9.6 2.6 19.5 3.1 29.4 c 0.5 9.4 1 18.9 1.4 28.3 c 0.8 19.2 1.3 38.4 1.5 57.7 c 0 1.9 3 1.9 3 0 c -0.2 -19.9 -0.8 -39.7 -1.6 -59.6 c -0.8 -18.6 -0.3 -38.3 -4.5 -56.5 C 939.3 265.4 936.4 266.2 936.8 268.1 L 936.8 268.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 170.1 -331.5734)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-970.1, -268.4266)",
    d: "M 938.8 269.9 c 20.9 -1.2 41.8 -0.9 62.6 0.8 c 1.9 0.2 1.9 -2.8 0 -3 c -20.8 -1.8 -41.7 -2 -62.6 -0.8 C 936.9 267.1 936.9 270.1 938.8 269.9 L 938.8 269.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 203.4888 -227.1625)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1003.4888, -372.8375)",
    d: "M 942.5 384.1 c 2.5 4.3 6.6 5.9 11.4 6.5 c 7.2 0.9 14.5 1.2 21.7 1.7 c 15.4 1 30.8 1.8 46.2 1.9 c 7.5 0 15.1 -0.1 22.6 -0.4 c 3.6 -0.2 7.2 -0.4 10.8 -0.6 c 1.9 -0.1 5.2 0.2 6.9 -1.2 c 1.1 -0.9 1.2 -2.2 1.4 -3.6 c 0.4 -3.9 0.3 -7.9 0.4 -11.8 c 0.3 -7.9 0.5 -15.8 0.8 -23.7 c 0.1 -1.9 -2.9 -1.9 -3 0 c -0.2 6.2 -0.4 12.5 -0.6 18.7 c -0.1 3 -0.2 5.9 -0.3 8.9 c -0.1 1.6 -0.1 3.3 -0.2 4.9 c -0.1 2.8 -0.4 3.8 -3.4 4.6 c -2.6 0.7 -6.1 0.4 -8.8 0.6 c -3.3 0.2 -6.5 0.3 -9.8 0.4 c -6.2 0.2 -12.4 0.2 -18.7 0.2 c -12.1 -0.1 -24.3 -0.6 -36.4 -1.4 c -6.2 -0.4 -12.4 -0.8 -18.7 -1.3 c -6.4 -0.5 -16 0.4 -19.7 -5.9 C 944.1 380.9 941.5 382.5 942.5 384.1 L 942.5 384.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 201.3215 -315.8948)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1001.3215, -284.1052)",
    d: "M 994.6 225.6 c 5.5 18.9 6.7 37.9 7.6 57.5 c 1 20 1.9 39.9 2.9 59.9 c 0.1 1.9 3.1 1.9 3 0 c -1 -20.6 -2 -41.2 -3 -61.9 c -0.9 -19.2 -2.3 -37.7 -7.7 -56.3 C 996.9 223 994.1 223.8 994.6 225.6 L 994.6 225.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 277.0507 -259.7725)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1077.0507, -340.2275)",
    d: "M 1005.8 345.4 c 11.7 4.1 24.1 4.8 36.3 5.9 c 12.7 1.2 24.8 2.5 37.5 0.4 c 12.7 -2.1 25.3 -4.6 37.9 -7.5 c 11.5 -2.7 22.1 -6.6 31.3 -14.1 c 1.5 -1.2 -0.6 -3.3 -2.1 -2.1 c -9.5 7.7 -20.9 11.2 -32.7 13.9 c -11.7 2.7 -23.4 5 -35.2 6.9 c -12.4 2 -24.3 0.6 -36.7 -0.6 c -11.9 -1.2 -24.1 -1.8 -35.5 -5.8 C 1004.8 341.8 1004 344.7 1005.8 345.4 L 1005.8 345.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 262.3693 -380.18)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1062.3693, -219.82)",
    d: "M 995.9 225.7 c 21.5 -6.1 44 -6.5 66.2 -7.6 c 22.5 -1.2 44.7 -1.9 67.2 -0.2 c 1.9 0.1 1.9 -2.9 0 -3 c -23.1 -1.8 -45.9 -0.9 -69 0.3 c -21.9 1.1 -44 1.7 -65.2 7.7 C 993.2 223.3 994 226.2 995.9 225.7 L 995.9 225.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 338.7394 -327.6552)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1138.7394, -272.3448)",
    d: "M 1127.8 216.3 c 0.3 19 2.8 37.9 6.2 56.6 c 1.7 9.5 3.7 18.9 5.8 28.3 c 2 9.3 3.7 18.7 6.9 27.6 c 0.6 1.8 3.5 1 2.9 -0.8 c -6.1 -17.2 -9 -36.1 -12.3 -54 c -3.6 -19.1 -6.1 -38.3 -6.5 -57.7 C 1130.7 214.4 1127.7 214.4 1127.8 216.3 L 1127.8 216.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.1964 -412.8)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-782.8036, -187.2)",
    d: "M 780.6 179.1 c 0.5 5.4 0.9 10.8 1.4 16.2 c 0.2 1.9 3.2 1.9 3 0 c -0.5 -5.4 -0.9 -10.8 -1.4 -16.2 C 783.5 177.2 780.5 177.2 780.6 179.1 L 780.6 179.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -12.3948 -413.176)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-787.6052, -186.8241)",
    d: "M 783.3 189.2 c 3 -0.8 6 -1.4 9 -1.8 c 1.9 -0.2 1.9 -3.2 0 -3 c -3.3 0.4 -6.6 1 -9.8 1.9 C 780.7 186.8 781.5 189.7 783.3 189.2 L 783.3 189.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.7094 -415.2784)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-793.2906, -184.7216)",
    d: "M 791.5 175.8 c 0 3.4 0 6.8 0.1 10.2 c 0 2.7 -0.3 5.5 0.5 8.1 c 0.6 1.8 3.5 1.1 2.9 -0.8 c -0.8 -2.7 -0.4 -5.9 -0.4 -8.6 c 0 -3 0 -5.9 -0.1 -8.9 C 794.5 173.8 791.5 173.8 791.5 175.8 L 791.5 175.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 6.9282 -424.8179)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-806.9283, -175.1821)",
    d: "M 800.8 177.1 c 3.9 0.6 7.8 -1.9 11.5 -0.7 c 1.8 0.6 2.6 -2.3 0.8 -2.9 c -4 -1.2 -7.6 1.3 -11.5 0.7 C 799.8 173.9 798.9 176.8 800.8 177.1 L 800.8 177.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.3311 -415.6307)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-808.3311, -184.3693)",
    d: "M 806.1 176.7 c 1 5.2 1.5 10.5 1.5 15.8 c 0 1.9 3 1.9 3 0 c 0 -5.6 -0.5 -11.1 -1.6 -16.6 C 808.6 174 805.7 174.8 806.1 176.7 L 806.1 176.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.6701 -416.2)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-821.6701, -183.8)",
    d: "M 820.3 173.3 c -0.3 7 -0.3 14 -0.2 21 c 0 1.9 3 1.9 3 0 c -0.1 -7 -0.1 -14 0.2 -21 C 823.3 171.4 820.3 171.4 820.3 173.3 L 820.3 173.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 31.9357 -416.998)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-831.9357, -183.0021)",
    d: "M 820.3 173.4 c 2.3 5.1 7.1 8.2 8.8 13.6 c 0.4 1.1 2.2 1.6 2.7 0.4 c 2.4 -5.2 4.9 -10.3 7.3 -15.5 c -0.9 -0.1 -1.8 -0.2 -2.7 -0.4 c 1.5 7.9 3 15.9 4.4 23.8 c 0.4 1.9 3.2 1.1 2.9 -0.8 c -1.5 -7.9 -3 -15.9 -4.4 -23.8 c -0.2 -1.2 -2.2 -1.5 -2.7 -0.4 c -2.4 5.2 -4.9 10.3 -7.3 15.5 c 0.9 0.1 1.8 0.2 2.7 0.4 c -1.8 -5.8 -6.6 -9 -9.1 -14.4 C 822.1 170.1 819.5 171.6 820.3 173.4 L 820.3 173.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 59.7884 -418.6932)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-859.7884, -181.3068)",
    d: "M 850.2 168.9 c 1.5 8.4 1.9 16.7 1.4 25.2 c 0 0.8 0.7 1.5 1.5 1.5 c 5.3 0 10.3 -0.9 15.3 -2.7 c 1.8 -0.7 1 -3.6 -0.8 -2.9 c -4.7 1.7 -9.5 2.6 -14.5 2.6 c 0.5 0.5 1 1 1.5 1.5 c 0.5 -8.8 0 -17.4 -1.6 -26 C 852.7 166.2 849.8 167 850.2 168.9 L 850.2 168.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.6 -387.4541)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-810.6, -212.5459)",
    d: "M 782 215 c 19 -1.4 38.1 -2 57.2 -1.9 c 1.9 0 1.9 -3 0 -3 c -19.1 -0.1 -38.2 0.5 -57.2 1.9 C 780.1 212.1 780.1 215.1 782 215 L 782 215 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -5.0875 -373.8517)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-794.9125, -226.1483)",
    d: "M 782.5 227.9 c 4.3 0.1 8.7 0.3 13 0 c 4 -0.2 7.9 -1 11.9 -0.5 c 1.9 0.2 1.9 -2.8 0 -3 c -4 -0.5 -7.9 0.3 -11.9 0.5 c -4.3 0.2 -8.7 0.1 -13 0 C 780.5 224.8 780.5 227.8 782.5 227.9 L 782.5 227.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.7068 -365.2307)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-793.2932, -234.7693)",
    d: "M 782.4 236.4 c 7.2 0.4 14.3 -1.1 21.4 0 c 1.9 0.3 2.7 -2.6 0.8 -2.9 c -7.4 -1.1 -14.8 0.3 -22.2 -0.1 C 780.4 233.3 780.4 236.3 782.4 236.4 L 782.4 236.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.1 -346)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-793.9, -254)",
    d: "M 784.1 255.5 c 6.5 0 13 0 19.6 0 c 1.9 0 1.9 -3 0 -3 c -6.5 0 -13 0 -19.6 0 C 782.2 252.5 782.2 255.5 784.1 255.5 L 784.1 255.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.5375 -339)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-792.4625, -261)",
    d: "M 785.4 262.5 c 4.7 0 9.5 0 14.2 0 c 1.9 0 1.9 -3 0 -3 c -4.7 0 -9.5 0 -14.2 0 C 783.4 259.5 783.4 262.5 785.4 262.5 L 785.4 262.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.5375 -327.9)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-792.4625, -272.1)",
    d: "M 782.5 273.6 c 6.7 0 13.4 0 20 0 c 1.9 0 1.9 -3 0 -3 c -6.7 0 -13.4 0 -20 0 C 780.5 270.6 780.5 273.6 782.5 273.6 L 782.5 273.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.25 -376.4)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-855.25, -223.6)",
    d: "M 834.1 225.1 c 14.1 0 28.2 0 42.3 0 c 1.9 0 1.9 -3 0 -3 c -14.1 0 -28.2 0 -42.3 0 C 832.2 222.1 832.2 225.1 834.1 225.1 L 834.1 225.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 48.85 -364.6)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-848.85, -235.4)",
    d: "M 835.1 236.9 c 9.2 0 18.4 0 27.5 0 c 1.9 0 1.9 -3 0 -3 c -9.2 0 -18.4 0 -27.5 0 C 833.2 233.9 833.2 236.9 835.1 236.9 L 835.1 236.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 76.8625 -365.1)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-876.8625, -234.9)",
    d: "M 872.8 236.4 c 2.7 0 5.5 0 8.2 0 c 1.9 0 1.9 -3 0 -3 c -2.7 0 -5.5 0 -8.2 0 C 870.8 233.4 870.8 236.4 872.8 236.4 L 872.8 236.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 54.55 -345.8)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-854.55, -254.2)",
    d: "M 838 255.7 c 11 0 22.1 0 33.1 0 c 1.9 0 1.9 -3 0 -3 c -11 0 -22.1 0 -33.1 0 C 836.1 252.7 836.1 255.7 838 255.7 L 838 255.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 40.6625 -332.2)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-840.6625, -267.8)",
    d: "M 826.2 269.3 c 9.7 0 19.3 0 29 0 c 1.9 0 1.9 -3 0 -3 c -9.7 0 -19.3 0 -29 0 C 824.2 266.3 824.2 269.3 826.2 269.3 L 826.2 269.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 49 -324.8)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-849, -275.2)",
    d: "M 838 276.7 c 7.3 0 14.6 0 22 0 c 1.9 0 1.9 -3 0 -3 c -7.3 0 -14.6 0 -22 0 C 836.1 273.7 836.1 276.7 838 276.7 L 838 276.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 76.2625 -332.7)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-876.2625, -267.3)",
    d: "M 865.8 268.8 c 7 0 14 0 21 0 c 1.9 0 1.9 -3 0 -3 c -7 0 -14 0 -21 0 C 863.8 265.8 863.8 268.8 865.8 268.8 L 865.8 268.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 110.15 -404)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-910.15, -196)",
    d: "M 900.5 197.5 c 6.4 0 12.9 0 19.3 0 c 1.9 0 1.9 -3 0 -3 c -6.4 0 -12.9 0 -19.3 0 C 898.6 194.5 898.6 197.5 900.5 197.5 L 900.5 197.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 134.0012 -403.5712)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-934.0011, -196.4288)",
    d: "M 925.7 191.8 c 5 2.1 10.6 2 15.4 4.5 c 0 -0.9 0 -1.7 0 -2.6 c -3.5 2.5 -7 5 -10.4 7.5 c -1.6 1.1 -0.1 3.7 1.5 2.6 c 3.5 -2.5 7 -5 10.4 -7.5 c 0.8 -0.6 1.1 -2 0 -2.6 c -5.1 -2.6 -10.9 -2.6 -16.1 -4.8 C 924.7 188.2 923.9 191.1 925.7 191.8 L 925.7 191.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 111.5853 -384.638)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-911.5853, -215.362)",
    d: "M 903.5 210.8 c 2.3 0.6 4.6 1.2 7 1.6 c 0.6 0.1 6.1 0.4 6.4 1 c -0.3 -0.6 -8 6.1 -8.8 7 c -1.3 1.4 0.8 3.5 2.1 2.1 c 2.4 -2.5 5 -4.6 8 -6.4 c 1.5 -0.9 3.2 -2.2 2.3 -4.2 c -0.9 -1.8 -3.6 -1.5 -5.3 -1.8 c -3.6 -0.5 -7.2 -1.3 -10.8 -2.3 C 902.4 207.4 901.6 210.3 903.5 210.8 L 903.5 210.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 118.35 -365.3)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-918.35, -234.7)",
    d: "M 902.9 236.2 c 10.3 0 20.6 0 30.9 0 c 1.9 0 1.9 -3 0 -3 c -10.3 0 -20.6 0 -30.9 0 C 901 233.2 901 236.2 902.9 236.2 L 902.9 236.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 142.5386 -366.8708)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-942.5386, -233.1292)",
    d: "M 934.2 226.5 c 2.1 1.1 4.3 1.8 6.6 2.4 c 2.4 0.7 6.5 1.3 8 3.6 c 0 -0.5 0 -1 0 -1.5 c -1 1.7 -3 3.2 -4.4 4.6 c -1.4 1.4 -2.9 2.9 -4.3 4.3 c -1.2 1.2 0.3 3.2 1.8 2.4 c 0.2 -0.1 0.5 -0.3 0.7 -0.4 c 1.7 -1 0.2 -3.5 -1.5 -2.6 c -0.2 0.1 -0.5 0.3 -0.7 0.4 c 0.6 0.8 1.2 1.6 1.8 2.4 c 1.7 -1.7 3.5 -3.4 5.2 -5.2 c 1.4 -1.4 3.1 -2.6 4 -4.3 c 0.3 -0.5 0.3 -1.1 0 -1.5 c -3.1 -4.8 -11 -4.7 -15.7 -7.1 C 934 223 932.5 225.6 934.2 226.5 L 934.2 226.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 113.55 -348.2)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-913.55, -251.8)",
    d: "M 902.7 253.3 c 7.2 0 14.5 0 21.7 0 c 1.9 0 1.9 -3 0 -3 c -7.2 0 -14.5 0 -21.7 0 C 900.8 250.3 900.8 253.3 902.7 253.3 L 902.7 253.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 148.3625 -348.9)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-948.3625, -251.1)",
    d: "M 936.8 252.6 c 7.7 0 15.5 0 23.2 0 c 1.9 0 1.9 -3 0 -3 c -7.7 0 -15.5 0 -23.2 0 C 934.8 249.6 934.8 252.6 936.8 252.6 L 936.8 252.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 117.2125 -328.4)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-917.2125, -271.6)",
    d: "M 905.4 273.1 c 7.9 0 15.8 0 23.7 0 c 1.9 0 1.9 -3 0 -3 c -7.9 0 -15.8 0 -23.7 0 C 903.4 270.1 903.4 273.1 905.4 273.1 L 905.4 273.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 91.1125 -291.2)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-891.1125, -308.8)",
    d: "M 872.8 310.3 c 12.2 0 24.5 0 36.7 0 c 1.9 0 1.9 -3 0 -3 c -12.2 0 -24.5 0 -36.7 0 C 870.8 307.3 870.8 310.3 872.8 310.3 L 872.8 310.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 103.05 -280.6)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-903.05, -319.4)",
    d: "M 886.5 320.9 c 11 0 22.1 0 33.1 0 c 1.9 0 1.9 -3 0 -3 c -11 0 -22.1 0 -33.1 0 C 884.6 317.9 884.6 320.9 886.5 320.9 L 886.5 320.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 179.1863 -271.0867)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-979.1863, -328.9133)",
    d: "M 982.1 285.5 c -5.3 -5.7 -12.1 7.4 -12.8 11.3 c -0.9 5.2 0.4 10.5 1.8 15.5 c 1.1 4.1 2.2 7.6 0.6 11.8 c -1.4 3.5 -4.2 6.7 -7.6 8.2 c -1.3 0.6 -0.7 2.9 0.8 2.8 c 12.1 -1.2 8.7 21.9 11.8 29.3 c 3 7 9.9 10.3 17.2 9.1 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -15.6 2.5 -14.8 -14.8 -16.2 -25 c -0.9 -6.3 -4.4 -14.3 -12.1 -13.5 c 0.3 0.9 0.5 1.9 0.8 2.8 c 6.3 -2.8 11 -10.6 9.8 -17.5 c -0.9 -5.5 -3.2 -10.6 -3.4 -16.2 c -0.1 -2.3 0.2 -4.7 1 -6.9 c 0.3 -0.7 4.9 -8.8 6.9 -6.6 C 981.3 289.1 983.4 286.9 982.1 285.5 L 982.1 285.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 229.1567 -236.2268)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1029.1567, -363.7732)",
    d: "M 1029.8 348.7 c -2.5 2.7 -1.7 5.9 -0.3 9.1 c 1.2 2.7 4.1 5.9 4 8.9 c 0 5.5 -6.4 8 -10.6 9.6 c -1.8 0.7 -1 3.6 0.8 2.9 c 5 -1.9 10.6 -4.3 12.3 -9.9 c 0.7 -2.1 0.5 -4.2 -0.3 -6.2 c -1.2 -3.1 -7 -9 -3.8 -12.3 C 1033.3 349.4 1031.1 347.3 1029.8 348.7 L 1029.8 348.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 233.3643 -316.8667)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1033.3643, -283.1333)",
    d: "M 1046.4 265.3 c -15.6 -6.4 -30.4 6.7 -28.1 22.9 c 2.3 16 21.1 19.4 30.1 6.6 c 1.1 -1.6 -1.5 -3.1 -2.6 -1.5 c -3.7 5.2 -9.9 8.1 -16.2 5.9 c -6.2 -2.2 -8.7 -8.4 -8.7 -14.7 c 0 -13.1 12.6 -21.1 24.6 -16.3 C 1047.4 268.9 1048.2 266 1046.4 265.3 L 1046.4 265.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 275.05 -322.813)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1075.05, -277.187)",
    d: "M 1066.8 279.3 c 5.4 -0.5 11 -1.4 16.5 -1.2 c 1.9 0.1 1.9 -2.9 0 -3 c -5.5 -0.2 -11.1 0.7 -16.5 1.2 C 1064.9 276.4 1064.9 279.4 1066.8 279.3 L 1066.8 279.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 275.3546 -322.35)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1075.3546, -277.65)",
    d: "M 1073.4 267.3 c 0.7 6.9 1 13.8 0.9 20.7 c 0 1.9 3 1.9 3 0 c 0.1 -6.9 -0.2 -13.8 -0.9 -20.7 C 1076.2 265.4 1073.2 265.4 1073.4 267.3 L 1073.4 267.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 301.7976 -327.6107)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1101.7977, -272.3893)",
    d: "M 1094.1 273.6 c 5 0.7 10.1 0.5 15.1 0.3 c 1.9 -0.1 1.9 -3.1 0 -3 c -4.8 0.2 -9.6 0.5 -14.3 -0.2 C 1093 270.5 1092.1 273.4 1094.1 273.6 L 1094.1 273.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 302.8 -326.25)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1102.8, -273.75)",
    d: "M 1100.9 262 c 0.3 7.8 0.5 15.6 0.8 23.5 c 0.1 1.9 3.1 1.9 3 0 c -0.3 -7.8 -0.5 -15.6 -0.8 -23.5 C 1103.8 260.1 1100.8 260.1 1100.9 262 L 1100.9 262 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 426.3714 -158.1193)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1226.3714, -441.8807)",
    d: "M 1221 377.8 c -4.8 43.1 -1.4 86.7 9.9 128.5 c 0.5 1.9 3.4 1.1 2.9 -0.8 c -11.3 -41.6 -14.6 -84.9 -9.8 -127.7 C 1224.2 375.9 1221.2 375.9 1221 377.8 L 1221 377.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 463.5932 -222.13)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1263.5932, -377.87)",
    d: "M 1223.8 378.3 c 26.3 1.8 54 5.9 80 -0.8 c 1.9 -0.5 1.1 -3.4 -0.8 -2.9 c -25.6 6.7 -53.1 2.5 -79.2 0.7 C 1221.8 375.2 1221.8 378.2 1223.8 378.3 L 1223.8 378.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 516.2915 -169.5705)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1316.2916, -430.4295)",
    d: "M 1301.8 376.3 c -3.3 38.2 6.2 76.7 26.8 109 c 1 1.6 3.6 0.1 2.6 -1.5 c -20.3 -31.9 -29.6 -69.8 -26.4 -107.5 C 1305 374.4 1302 374.4 1301.8 376.3 L 1301.8 376.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 481.1347 -102.9212)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1281.1347, -497.0788)",
    d: "M 1233.1 507.2 c 15.3 5.6 34.2 2.8 49.7 -0.7 c 16.6 -3.8 32.5 -10.6 46.7 -19.9 c 1.6 -1 0.1 -3.6 -1.5 -2.6 c -13.6 8.9 -28.5 15.4 -44.3 19.2 c -15.4 3.7 -34.5 6.7 -49.8 1.1 C 1232.1 503.6 1231.3 506.5 1233.1 507.2 L 1233.1 507.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 438.5994 -197.5792)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1238.5994, -402.4208)",
    d: "M 1241.6 394.9 c -5.5 3.8 -10.5 8 -15.2 12.7 c -0.9 0.9 -0.3 2.6 1.1 2.6 c 7.4 -0.2 14.9 -0.4 22.3 -0.5 c 1.9 0 1.9 -3 0 -3 c -7.4 0.2 -14.9 0.4 -22.3 0.5 c 0.4 0.9 0.7 1.7 1.1 2.6 c 4.5 -4.5 9.3 -8.6 14.6 -12.2 C 1244.7 396.5 1243.2 393.8 1241.6 394.9 L 1241.6 394.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 467.1 -202.5381)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1267.1, -397.4619)",
    d: "M 1255.5 399 c 7.8 -0.6 15.5 -0.5 23.2 0.3 c 1.9 0.2 1.9 -2.8 0 -3 c -7.7 -0.8 -15.5 -0.9 -23.2 -0.3 C 1253.6 396.1 1253.6 399.1 1255.5 399 L 1255.5 399 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 487.1963 -201.215)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1287.1963, -398.785)",
    d: "M 1279.7 394.2 c 4.8 1.1 9.5 2.5 14.2 4.2 c -0.2 -0.8 -0.4 -1.7 -0.7 -2.5 c -3.2 2.5 -6.3 5.1 -9.3 7.9 c -1.4 1.3 0.7 3.4 2.1 2.1 c 3 -2.7 6.1 -5.4 9.3 -7.9 c 1 -0.8 0.3 -2.2 -0.7 -2.5 c -4.6 -1.8 -9.3 -3.2 -14.2 -4.2 C 1278.6 390.9 1277.8 393.7 1279.7 394.2 L 1279.7 394.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 434.55 -172.4)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1234.55, -427.6)",
    d: "M 1228 428.7 c 4.4 0.3 8.7 0.5 13.1 0.8 c 1.9 0.1 1.9 -2.9 0 -3 c -4.4 -0.3 -8.7 -0.5 -13.1 -0.8 C 1226.1 425.6 1226.1 428.6 1228 428.7 L 1228 428.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 468.2 -175.6)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1268.2, -424.4)",
    d: "M 1250.2 428.7 c 12.3 -1.9 24.6 -3.8 36.8 -5.7 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -12.3 1.9 -24.6 3.8 -36.8 5.7 C 1247.5 426.1 1248.3 429 1250.2 428.7 L 1250.2 428.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 434.9 -163)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1234.9, -437)",
    d: "M 1230.2 438.5 c 3.1 0 6.3 0 9.4 0 c 1.9 0 1.9 -3 0 -3 c -3.1 0 -6.3 0 -9.4 0 C 1228.3 435.5 1228.3 438.5 1230.2 438.5 L 1230.2 438.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 435.9807 -156.0119)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1235.9807, -443.9882)",
    d: "M 1230.9 445.8 c 3.6 0.3 7.1 0 10.5 -0.8 c 1.9 -0.4 1.1 -3.3 -0.8 -2.9 c -3.2 0.7 -6.4 0.9 -9.7 0.7 C 1229 442.6 1229 445.6 1230.9 445.8 L 1230.9 445.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 449.8948 -145.5859)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1249.8948, -454.4142)",
    d: "M 1229.8 458.8 c 13.3 -1.4 27.9 -1.4 40.6 -5.8 c 1.8 -0.6 1 -3.5 -0.8 -2.9 c -12.5 4.3 -26.8 4.3 -39.8 5.7 C 1227.9 456 1227.9 459 1229.8 458.8 L 1229.8 458.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 474.4307 -162.9741)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1274.4307, -437.0259)",
    d: "M 1254.1 442.1 c 13.8 -1.5 27.5 -3.9 41 -7.2 c 1.9 -0.5 1.1 -3.4 -0.8 -2.9 c -13.2 3.3 -26.6 5.6 -40.2 7.1 C 1252.2 439.3 1252.2 442.3 1254.1 442.1 L 1254.1 442.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 437.4807 -130.6626)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1237.4807, -469.3374)",
    d: "M 1233.1 471.1 c 3.1 0.3 6.1 0.1 9.1 -0.7 c 1.9 -0.5 1.1 -3.4 -0.8 -2.9 c -2.7 0.7 -5.5 0.9 -8.3 0.6 C 1231.2 467.9 1231.2 470.9 1233.1 471.1 L 1233.1 471.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 469.8807 -136.2136)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1269.8807, -463.7864)",
    d: "M 1255.4 467.9 c 4.5 0.5 8.8 -0.8 13.2 -1.8 c 5.4 -1.2 10.8 -2.4 16.1 -3.6 c 1.9 -0.4 1.1 -3.3 -0.8 -2.9 c -4.7 1.1 -9.5 2.1 -14.2 3.2 c -4.7 1 -9.5 2.6 -14.3 2.1 C 1253.5 464.6 1253.5 467.6 1255.4 467.9 L 1255.4 467.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 451.4788 -112.2725)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1251.4788, -487.7275)",
    d: "M 1249.3 473.3 c -2.5 0.7 -4.5 2.4 -5.1 5 c -0.2 1 -0.1 2.2 0.2 3.2 c 0.3 0.8 4.5 6.1 2.3 6.7 c -0.9 0.2 -1.5 1.4 -0.9 2.2 c 2.4 3.3 2.1 8.1 5.7 10.6 c 2.3 1.6 4.8 1.7 6.9 -0.2 c 1.4 -1.3 -0.7 -3.4 -2.1 -2.1 c -3.6 3.4 -6.5 -7.8 -7.9 -9.8 c -0.3 0.7 -0.6 1.5 -0.9 2.2 c 1.8 -0.5 2.8 -1.5 3 -3.4 c 0.5 -3.1 -6.8 -9.8 -0.4 -11.5 C 1252 475.7 1251.2 472.8 1249.3 473.3 L 1249.3 473.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 470.4 -116.2536)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1270.4, -483.7464)",
    d: "M 1257 486.3 c 9 -0.4 17.9 -1.1 26.8 -2.1 c 1.9 -0.2 1.9 -3.2 0 -3 c -8.9 1 -17.8 1.7 -26.8 2.1 C 1255.1 483.4 1255.1 486.4 1257 486.3 L 1257 486.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 494.9123 -118.394)",
    id: "papers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1294.9123, -481.6061)",
    d: "M 1289.6 470.4 c 0.8 0.1 2.1 -0.2 2.9 0 c 4.3 1.2 2.5 2.2 2.8 4.4 c 0.2 1.7 0 3.2 0.5 4.9 c 0.5 1.8 1.5 3.5 2.1 5.3 c 0.9 2.6 1 3.1 -0.9 5.4 c -1.8 2.1 -1.8 2.1 -4.2 2.5 c -1.9 0.3 -1.1 3.2 0.8 2.9 c 3 -0.5 6 -1.6 7.4 -4.5 c 1.6 -3.4 -0.1 -6.7 -1.4 -9.9 c -1 -2.4 -1.4 -4.6 -1.3 -7.2 c 0 -1.4 0.2 -2.9 -0.4 -4.2 c -1.7 -3.5 -5.2 -2.2 -8.3 -2.6 C 1287.7 467.2 1287.7 470.2 1289.6 470.4 L 1289.6 470.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -551.6503 317.4193)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-248.3497, -917.4193)",
    d: "M 240 859 c 5.5 39 10 78.1 13.7 117.3 c 0.2 1.9 3.2 1.9 3 0 c -3.7 -39.5 -8.3 -78.8 -13.8 -118.1 C 242.6 856.3 239.8 857.1 240 859 L 240 859 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -494.7 382.6346)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-305.3, -982.6346)",
    d: "M 253.8 977.9 c 32.2 16 70.5 16.3 103 1.1 c 1.7 -0.8 0.2 -3.4 -1.5 -2.6 c -31.5 14.8 -68.9 14.3 -100 -1.1 C 253.6 974.4 252.1 977 253.8 977.9 L 253.8 977.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -440.7512 319.45)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-359.2488, -919.45)",
    d: "M 359 861.2 c -0.1 38.9 -0.9 77.7 -2.5 116.5 c -0.1 1.9 2.9 1.9 3 0 c 1.6 -38.8 2.4 -77.7 2.5 -116.5 C 362 859.3 359 859.3 359 861.2 L 359 861.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -499.0448 261.844)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-300.9552, -861.8441)",
    d: "M 240.8 859.5 c 39 11.8 80.1 7.6 119.9 3.1 c 1.9 -0.2 1.9 -3.2 0 -3 c -39.6 4.4 -80.3 8.7 -119.1 -3 C 239.8 856 239 858.9 240.8 859.5 L 240.8 859.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -493.7194 366.3713)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-306.2806, -966.3713)",
    d: "M 255.6 963 c 3.4 -6.8 11.1 2.8 13.8 5.2 c 2.5 2.2 5.4 3.5 8.8 3.3 c 8.4 -0.4 15.5 -8.7 24.1 -6.6 c 8.4 2.1 12.8 10.7 22.4 9.8 c 10.8 -1 21.8 -13.8 32.8 -7.4 c 1.7 1 3.2 -1.6 1.5 -2.6 c -10.5 -6.1 -20.2 2.7 -30 6 c -7.5 2.5 -12.4 -0.4 -18.3 -4.6 c -3.6 -2.5 -7.3 -4.7 -11.9 -4.4 c -10.5 0.6 -19.3 12.3 -28.9 2.9 c -2.8 -2.8 -5.1 -5.8 -9.3 -6.5 c -3.2 -0.5 -6.1 0.5 -7.6 3.4 C 252.1 963.2 254.7 964.7 255.6 963 L 255.6 963 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -494.6716 346.5125)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-305.3284, -946.5126)",
    d: "M 252.8 945.7 c 34.5 9.4 71 8.8 105.1 -2 c 1.8 -0.6 1.1 -3.5 -0.8 -2.9 c -33.6 10.6 -69.6 11.2 -103.5 2 C 251.7 942.3 250.9 945.1 252.8 945.7 L 252.8 945.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -496.3716 311.2658)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-303.6284, -911.2658)",
    d: "M 247.9 910.9 c 36.7 9 75.3 8.2 111.5 -2.5 c 1.8 -0.5 1.1 -3.4 -0.8 -2.9 c -35.8 10.6 -73.7 11.4 -109.9 2.5 C 246.8 907.5 246 910.4 247.9 910.9 L 247.9 910.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -496.9047 287.0447)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-303.0953, -887.0447)",
    d: "M 246.2 884.9 c 6 -4.5 11.9 2.1 16.5 5.4 c 3.6 2.6 7.5 3.9 11.9 3.4 c 9.1 -1.2 17.8 -10.6 27.3 -8.2 c 5.2 1.3 8.5 6.4 13.8 7.3 c 4 0.7 7.7 -1.2 10.9 -3.3 c 5.4 -3.4 9.8 -6.1 16.5 -5.6 c 6.1 0.4 11.8 1.9 18 0.9 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -6.9 1 -13.6 -1.4 -20.5 -1.1 c -5 0.2 -8.9 2.2 -13 5 c -2.3 1.5 -4.6 3.3 -7.3 3.9 c -4.1 1 -7.2 -1.4 -10.3 -3.6 c -3.6 -2.5 -7.2 -4.3 -11.8 -3.8 c -9.3 0.9 -17.8 10.4 -27.4 8.4 c -8.3 -1.7 -15.9 -15.5 -25.5 -8.4 C 243.2 883.5 244.7 886.1 246.2 884.9 L 246.2 884.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -532.9338 175.4988)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.0662, -775.4987)",
    d: "M 267.7 861.6 c -4.6 -4.7 -18.9 -20.1 -11 -26.7 c 0.5 -0.4 0.6 -1.3 0.2 -1.8 c -6.2 -8.9 -13 -18.4 -13.7 -29.6 c -0.3 -4.9 1.8 -8.8 2.2 -13.4 c 0.4 -4.4 -1.9 -9.3 -3 -13.5 c -5.4 -21.8 -9.2 -45.6 -7.1 -68.1 c 0.5 -5.5 1.5 -11.2 3.7 -16.3 c 4.2 -10 12.7 -0.8 16.3 4.2 c 6 8.4 10.1 17.9 13.6 27.6 c 7.5 20.9 13.5 42.4 18.4 64.1 c 5.7 25.2 9.6 50.8 11.8 76.6 c 0.2 1.9 3.2 1.9 3 0 c -2.2 -25.4 -6 -50.6 -11.5 -75.5 c -5.4 -24.7 -12.1 -49.7 -21.5 -73.1 c -3.8 -9.4 -8.5 -19.9 -16 -27 c -5.6 -5.4 -13.2 -6.4 -16.6 1.6 c -4.3 10 -4.7 21.4 -4.4 32.2 c 0.4 12.9 1.8 25.9 4.1 38.6 c 1.3 7 2.8 13.9 4.6 20.7 c 1.1 4.1 1.9 7.1 0.7 11.1 c -0.9 2.8 -1.3 5.7 -1.3 8.7 c 0 12.4 7.3 23.1 14.1 32.8 c 0.1 -0.6 0.2 -1.2 0.2 -1.8 c -9.8 8.3 5.1 25.1 11 31 C 267 865 269.1 862.9 267.7 861.6 L 267.7 861.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -484.9718 197.3805)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-315.0282, -797.3805)",
    d: "M 291.2 783.5 c 0.9 -8.8 1.8 -17.7 5 -26 c 1.9 -4.9 4.6 -8.9 7.9 -12.9 c 2.3 -2.8 3.9 -5.7 6 -8.6 c 6.1 -8.6 11.9 0.9 13 7.1 c 0.9 5.5 1.3 11.1 1.5 16.7 c 0.4 10.8 -0.2 21.7 -1.8 32.4 c -0.2 1.6 1.8 2.7 2.7 1.2 c 2.3 -3.7 9.4 -11.5 12.9 -3.2 c 1.1 2.6 0.4 6.4 0.3 9.1 c -0.4 7.7 -1.1 15.3 -2.2 22.9 c -2 13.9 -5.3 27.7 -9.7 41.1 c -0.6 1.8 2.3 2.6 2.9 0.8 c 6.3 -19.5 10.3 -39.7 11.7 -60.1 c 0.4 -5.7 2.6 -16.4 -4.2 -19.6 c -6.2 -2.9 -11.4 2.8 -14.4 7.5 c 0.9 0.4 1.8 0.8 2.7 1.2 c 2 -13.6 2.6 -27.2 1.4 -40.9 c -0.7 -7.5 -1.4 -23.6 -12.8 -22.5 c -4.2 0.4 -6.3 4.1 -8.3 7.3 c -3.1 5.2 -7.6 9.2 -10.4 14.6 c -5.2 9.9 -6.3 21.2 -7.4 32.1 C 288 785.4 291 785.4 291.2 783.5 L 291.2 783.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -535.2352 177.1859)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-264.7648, -777.1859)",
    d: "M 241.1 690.2 c 21.5 56.4 33.1 115.7 44.5 174.7 c 0.4 1.9 3.3 1.1 2.9 -0.8 c -11.4 -59 -23 -118.4 -44.5 -174.7 C 243.3 687.6 240.4 688.4 241.1 690.2 L 241.1 690.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -542.1791 191.4615)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-257.8209, -791.4615)",
    d: "M 239.7 774.7 c 14.6 8.5 26.3 20.7 34.2 35.6 c 0.9 1.7 3.5 0.2 2.6 -1.5 c -8.1 -15.3 -20.3 -28 -35.2 -36.7 C 239.5 771.1 238 773.7 239.7 774.7 L 239.7 774.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -532.6583 142)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-267.3417, -742)",
    d: "M 267 716.9 c -1.8 16.7 -3.4 33.5 -1.4 50.2 c 0.2 1.9 3.2 1.9 3 0 c -2 -16.8 -0.4 -33.5 1.4 -50.2 C 270.2 715 267.2 715 267 716.9 L 267 716.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -487 196.0125)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-313, -796.0125)",
    d: "M 314.9 733 c -2.3 42 -4.5 84.1 -6.8 126.1 c -0.1 1.9 2.9 1.9 3 0 c 2.3 -42 4.5 -84.1 6.8 -126.1 C 318 731 315 731 314.9 733 L 314.9 733 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -500.3474 205.8023)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-299.6527, -805.8023)",
    d: "M 288.5 781.8 c 5.2 16.9 11.7 33.3 19.6 49.1 c 0.9 1.7 3.5 0.2 2.6 -1.5 c -7.8 -15.6 -14.2 -31.8 -19.3 -48.4 C 290.8 779.2 287.9 779.9 288.5 781.8 L 288.5 781.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -476.0614 231.2221)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-323.9385, -831.2221)",
    d: "M 311.4 845.6 c 11.3 -6.4 20.5 -15.5 27.1 -26.7 c 1 -1.7 -1.6 -3.2 -2.6 -1.5 c -6.3 10.8 -15.2 19.5 -26 25.6 C 308.2 844 309.7 846.5 311.4 845.6 L 311.4 845.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -546.5909 259.834)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-253.4091, -859.8339)",
    d: "M 241.9 860.1 c 6 -0.4 15.4 -2.5 19.8 2.9 c 0.6 -0.8 1.2 -1.6 1.8 -2.4 c -3.9 -2.1 -8 -3.5 -12.4 -4.3 c -0.3 1 -0.5 1.9 -0.8 2.9 c 4.8 0.8 9.5 1.9 14.2 3.3 c 1.9 0.6 2.6 -2.3 0.8 -2.9 c -4.7 -1.4 -9.4 -2.5 -14.2 -3.3 c -1.9 -0.3 -2.7 2.5 -0.8 2.9 c 4.2 0.8 7.9 2.1 11.7 4 c 1.6 0.8 2.9 -1.1 1.8 -2.4 c -5.1 -6.3 -14.9 -4.2 -21.9 -3.8 C 240 857.2 240 860.2 241.9 860.1 L 241.9 860.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -456.6068 260.2155)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-343.3932, -860.2155)",
    d: "M 331.4 861.2 c -0.2 -1 12.1 -0.4 12.8 -0.3 c 4.2 0.2 8.5 0.4 12.7 0.5 c 0 -1 0 -2 0 -3 c -7.9 0.4 -15.8 0.8 -23.7 1.1 c -1.9 0.1 -1.9 2.9 0 3 c 4.4 0.2 8.8 0.3 13.2 0.2 c 1.9 0 1.9 -3 0 -3 c -4.4 0.1 -8.8 0.1 -13.2 -0.2 c 0 1 0 2 0 3 c 7.9 -0.4 15.8 -0.8 23.7 -1.1 c 1.9 -0.1 1.9 -2.9 0 -3 c -7.7 -0.3 -15.7 -1.3 -23.4 -1 c -2.9 0.1 -5.7 1.1 -4.9 4.6 C 328.9 863.9 331.8 863.1 331.4 861.2 L 331.4 861.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -304.6483 461.2034)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-495.3517, -1061.2035)",
    d: "M 452.2 1115 c 15 -18.8 29.9 -37.5 44.9 -56.3 c 13.7 -17.1 27.4 -34.3 43.4 -49.3 c 1.4 -1.3 -0.7 -3.4 -2.1 -2.1 c -16 15.1 -29.7 32.2 -43.4 49.3 c -15 18.8 -29.9 37.5 -44.9 56.3 C 448.9 1114.4 451 1116.5 452.2 1115 L 452.2 1115 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.1375 407.3)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-782.8625, -1007.3)",
    d: "M 538.4 1008.8 c 127.1 0 254.1 0 381.2 0 c 35.9 0 71.8 0 107.8 0 c 1.9 0 1.9 -3 0 -3 c -127.1 0 -254.1 0 -381.2 0 c -35.9 0 -71.8 0 -107.8 0 C 536.4 1005.8 536.4 1008.8 538.4 1008.8 L 538.4 1008.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 278.3797 466.0298)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1078.3797, -1066.0298)",
    d: "M 1026.9 1009.1 c 35.7 36.7 69.3 75.3 100.5 115.8 c 1.2 1.5 3.8 0 2.6 -1.5 c -31.4 -40.7 -65.1 -79.6 -101 -116.4 C 1027.7 1005.6 1025.5 1007.7 1026.9 1009.1 L 1026.9 1009.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -442.1 418.7)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-357.9, -1018.7)",
    d: "M 288.2 1020.2 c 46.5 0 92.9 0 139.4 0 c 1.9 0 1.9 -3 0 -3 c -46.5 0 -92.9 0 -139.4 0 C 286.3 1017.2 286.3 1020.2 288.2 1020.2 L 288.2 1020.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 73.35 358.2)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-873.35, -958.2)",
    d: "M 548.6 959.7 c 84.6 0 169.2 0 253.8 0 c 84.3 0 168.6 0 252.8 0 c 47.6 0 95.3 0 142.9 0 c 1.9 0 1.9 -3 0 -3 c -84.6 0 -169.2 0 -253.8 0 c -84.3 0 -168.6 0 -252.8 0 c -47.6 0 -95.3 0 -142.9 0 C 546.7 956.7 546.7 959.7 548.6 959.7 L 548.6 959.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 569.75 359.5)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1369.75, -959.5)",
    d: "M 1263.9 961 c 70.6 0 141.1 0 211.7 0 c 1.9 0 1.9 -3 0 -3 c -70.6 0 -141.1 0 -211.7 0 C 1262 958 1262 961 1263.9 961 L 1263.9 961 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 342.95 402.9)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1142.95, -1002.9)",
    d: "M 1085.1 1004.4 c 38.6 0 77.1 0 115.7 0 c 1.9 0 1.9 -3 0 -3 c -38.6 0 -77.1 0 -115.7 0 C 1083.2 1001.4 1083.2 1004.4 1085.1 1004.4 L 1085.1 1004.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 501.35 414.7)",
    id: "ground_grey"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1301.35, -1014.7)",
    d: "M 1257.3 1016.2 c 29.4 0 58.7 0 88.1 0 c 1.9 0 1.9 -3 0 -3 c -29.4 0 -58.7 0 -88.1 0 C 1255.4 1013.2 1255.4 1016.2 1257.3 1016.2 L 1257.3 1016.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -301.0875 356.2)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-498.9125, -956.2)",
    d: "M 444.5 957.7 c 36.3 0 72.6 0 108.9 0 c 1.9 0 1.9 -3 0 -3 c -36.3 0 -72.6 0 -108.9 0 C 442.5 954.7 442.5 957.7 444.5 957.7 L 444.5 957.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -116.95 369.2)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-683.05, -969.2)",
    d: "M 546.9 970.7 c 70.6 0 141.1 0 211.7 0 c 20.2 0 40.4 0 60.6 0 c 1.9 0 1.9 -3 0 -3 c -70.6 0 -141.1 0 -211.7 0 c -20.2 0 -40.4 0 -60.6 0 C 545 967.7 545 970.7 546.9 970.7 L 546.9 970.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 142.45 356.2)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-942.45, -956.2)",
    d: "M 758.3 957.7 c 95.6 0 191.1 0 286.7 0 c 27.2 0 54.4 0 81.6 0 c 1.9 0 1.9 -3 0 -3 c -95.6 0 -191.1 0 -286.7 0 c -27.2 0 -54.4 0 -81.6 0 C 756.4 954.7 756.4 957.7 758.3 957.7 L 758.3 957.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 456.3 375.7)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1256.3, -975.7)",
    d: "M 1126.6 977.2 c 67.2 0 134.3 0 201.5 0 c 19.3 0 38.6 0 57.9 0 c 1.9 0 1.9 -3 0 -3 c -67.2 0 -134.3 0 -201.5 0 c -19.3 0 -38.6 0 -57.9 0 C 1124.7 974.2 1124.7 977.2 1126.6 977.2 L 1126.6 977.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -485.8875 478.1)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-314.1125, -1078.1)",
    d: "M 273.3 1079.6 c 27.2 0 54.5 0 81.7 0 c 1.9 0 1.9 -3 0 -3 c -27.2 0 -54.5 0 -81.7 0 C 271.3 1076.6 271.3 1079.6 273.3 1079.6 L 273.3 1079.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 227.3625 460)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1027.3625, -1060)",
    d: "M 968.4 1061.5 c 39.3 0 78.7 0 118 0 c 1.9 0 1.9 -3 0 -3 c -39.3 0 -78.7 0 -118 0 C 966.4 1058.5 966.4 1061.5 968.4 1061.5 L 968.4 1061.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 532.75 463.8)",
    id: "ground_black"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1332.75, -1063.8)",
    d: "M 1279.6 1065.3 c 35.4 0 70.9 0 106.3 0 c 1.9 0 1.9 -3 0 -3 c -35.4 0 -70.9 0 -106.3 0 C 1277.7 1062.3 1277.7 1065.3 1279.6 1065.3 L 1279.6 1065.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -400.55 290.55)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-399.45, -890.55)",
    d: "M 386.3 701.5 c 0 127 0 254 0 380.9 c 8.8 -0.9 17.5 -1.8 26.3 -2.8 c 0 -127 0 -254 0 -380.9 C 403.9 699.6 395.1 700.5 386.3 701.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 358.9 290.85)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1158.9, -890.85)",
    d: "M 1146.8 705.6 c -0.2 124.7 -0.5 249.3 -0.7 374 c 8.5 0 17.1 0 25.6 0 c 0 -125.8 0 -251.7 0 -377.5 C 1163.5 703.3 1155.2 704.5 1146.8 705.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -299 219.5)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-501, -819.5)",
    d: "M 515.9 955.6 c -1 -53.7 -1.3 -108.7 -0.7 -164.8 c 0.4 -36.1 1.1 -71.6 2.1 -106.7 c -10.6 -0.2 -21.2 -0.5 -31.9 -0.7 c -0.2 90.3 -0.5 180.5 -0.7 270.8 C 495.1 954.7 505.5 955.2 515.9 955.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 260.6 219.6)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1060.6, -819.6)",
    d: "M 1045 689.7 c 0.2 88.2 0.5 176.4 0.7 264.6 c 9.5 -0.2 18.9 -0.5 28.4 -0.7 c 0.7 -89.6 1.4 -179.2 2.1 -268.7 C 1065.8 686.4 1055.4 688.1 1045 689.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -27.2 100.9453)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-772.8, -700.9453)",
    d: "M 343.4 693.8 c -0.2 7.4 -0.5 14.8 -0.7 22.2 c 286.7 0.5 573.5 0.9 860.2 1.4 c -0.7 -7.8 -1.4 -15.7 -2.1 -23.5 c -92.9 -4.1 -187.8 -6.9 -284.7 -8.3 C 717.5 682.6 526.4 685.8 343.4 693.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -27.85 50.5)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-772.15, -650.5)",
    d: "M 343.4 693.1 c 285.8 0.2 571.6 0.5 857.5 0.7 c -30.5 -28.9 -61 -57.7 -91.4 -86.6 c -230.6 0.2 -461.3 0.5 -691.9 0.7 C 392.8 636.3 368.1 664.7 343.4 693.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -419.3746 50.7706)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-380.6254, -650.7706)",
    d: "M 343.5 695.1 c 24.7 -29.5 50.1 -58.4 76.3 -86.6 c 1.3 -1.4 -0.8 -3.5 -2.1 -2.1 c -26.2 28.2 -51.6 57 -76.3 86.6 C 340.2 694.4 342.3 696.6 343.5 695.1 L 343.5 695.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -457.7 104.45)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-342.3, -704.45)",
    d: "M 340.8 695.1 c 0 6.2 0 12.4 0 18.7 c 0 1.9 3 1.9 3 0 c 0 -6.2 0 -12.4 0 -18.7 C 343.8 693.2 340.8 693.2 340.8 695.1 L 340.8 695.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.7375 116.3)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-773.2625, -716.3)",
    d: "M 344.8 717.8 c 111.9 0 223.7 0 335.6 0 c 111.2 0 222.4 0 333.6 0 c 62.6 0 125.2 0 187.8 0 c 1.9 0 1.9 -3 0 -3 c -111.9 0 -223.7 0 -335.6 0 c -111.2 0 -222.4 0 -333.6 0 c -62.6 0 -125.2 0 -187.8 0 C 342.8 714.8 342.8 717.8 344.8 717.8 L 344.8 717.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 403 103.8375)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1203, -703.8375)",
    d: "M 1204.5 715 c 0 -7.5 0 -14.9 0 -22.4 c 0 -1.9 -3 -1.9 -3 0 c 0 7.5 0 14.9 0 22.4 C 1201.5 717 1204.5 717 1204.5 715 L 1204.5 715 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -457.7188 116.3)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-342.2811, -716.3)",
    d: "M 342.3 717.8 c 1.9 0 1.9 -3 0 -3 C 340.4 714.8 340.3 717.8 342.3 717.8 L 342.3 717.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -28 93.9)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-772, -693.9)",
    d: "M 343.5 695.4 c 111.9 0 223.7 0 335.6 0 c 111.2 0 222.4 0 333.6 0 c 62.6 0 125.2 0 187.8 0 c 1.9 0 1.9 -3 0 -3 c -111.9 0 -223.7 0 -335.6 0 c -111.2 0 -222.4 0 -333.6 0 c -62.6 0 -125.2 0 -187.8 0 C 341.6 692.4 341.6 695.4 343.5 695.4 L 343.5 695.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -34.9 8.1)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-765.1, -608.1)",
    d: "M 420.6 609.6 c 89.9 0 179.8 0 269.6 0 c 89.2 0 178.4 0 267.6 0 c 50.6 0 101.2 0 151.8 0 c 1.9 0 1.9 -3 0 -3 c -89.9 0 -179.8 0 -269.6 0 c -89.2 0 -178.4 0 -267.6 0 c -50.6 0 -101.2 0 -151.8 0 C 418.7 606.6 418.7 609.6 420.6 609.6 L 420.6 609.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 354.65 50.85)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1154.65, -650.85)",
    d: "M 1108.1 609.7 c 30.3 28.1 60.7 56.3 91 84.4 c 1.4 1.3 3.5 -0.8 2.1 -2.1 c -30.3 -28.1 -60.7 -56.3 -91 -84.4 C 1108.8 606.3 1106.7 608.4 1108.1 609.7 L 1108.1 609.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -412.9 298.5125)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-387.1, -898.5125)",
    d: "M 385.6 716.3 c 0 94.6 0 189.2 0 283.8 c 0 26.9 0 53.8 0 80.7 c 0 1.9 3 1.9 3 0 c 0 -94.6 0 -189.2 0 -283.8 c 0 -26.9 0 -53.8 0 -80.7 C 388.6 714.3 385.6 714.3 385.6 716.3 L 385.6 716.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -386.8 298.5)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-413.2, -898.5)",
    d: "M 411.7 717.5 c 0 94 0 188 0 282 c 0 26.7 0 53.3 0 80 c 0 1.9 3 1.9 3 0 c 0 -94 0 -188 0 -282 c 0 -26.7 0 -53.3 0 -80 C 414.7 715.6 411.7 715.6 411.7 717.5 L 411.7 717.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -401.1188 481.5036)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-398.8811, -1081.5036)",
    d: "M 387.1 1083.7 c 7.9 -0.5 15.7 -1 23.6 -1.4 c 1.9 -0.1 1.9 -3.1 0 -3 c -7.9 0.5 -15.7 1 -23.6 1.4 C 385.2 1080.9 385.1 1083.9 387.1 1083.7 L 387.1 1083.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 345.8 298.5125)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1145.8, -898.5125)",
    d: "M 1144.3 716.3 c 0 94.6 0 189.2 0 283.8 c 0 26.9 0 53.8 0 80.7 c 0 1.9 3 1.9 3 0 c 0 -94.6 0 -189.2 0 -283.8 c 0 -26.9 0 -53.8 0 -80.7 C 1147.3 714.3 1144.3 714.3 1144.3 716.3 L 1144.3 716.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 371.9 298.5)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1171.9, -898.5)",
    d: "M 1170.4 717.5 c 0 94 0 188 0 282 c 0 26.7 0 53.3 0 80 c 0 1.9 3 1.9 3 0 c 0 -94 0 -188 0 -282 c 0 -26.7 0 -53.3 0 -80 C 1173.4 715.6 1170.4 715.6 1170.4 717.5 L 1170.4 717.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 358.8 479.5)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1158.8, -1079.5)",
    d: "M 1147 1081.7 c 7.9 -0.5 15.7 -1 23.6 -1.4 c 1.9 -0.1 1.9 -3.1 0 -3 c -7.9 0.5 -15.7 1 -23.6 1.4 C 1145.1 1078.8 1145.1 1081.8 1147 1081.7 L 1147 1081.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -314.3 235.45)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-485.7, -835.45)",
    d: "M 484.2 717.7 c 0 78.5 0 157 0 235.5 c 0 1.9 3 1.9 3 0 c 0 -78.5 0 -157 0 -235.5 C 487.2 715.8 484.2 715.8 484.2 717.7 L 484.2 717.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -284.4 236.15)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-515.6, -836.15)",
    d: "M 514.1 719.1 c 0 78 0 156.1 0 234.1 c 0 1.9 3 1.9 3 0 c 0 -78 0 -156.1 0 -234.1 C 517.1 717.2 514.1 717.2 514.1 719.1 L 514.1 719.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -298.7 354.6)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-501.3, -954.6)",
    d: "M 487 956.1 c 9.5 0 19.1 0 28.6 0 c 1.9 0 1.9 -3 0 -3 c -9.5 0 -19.1 0 -28.6 0 C 485.1 953.1 485.1 956.1 487 956.1 L 487 956.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 246.5 234.7812)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1046.5, -834.7811)",
    d: "M 1045 716.4 c 0 78.9 0 157.9 0 236.8 c 0 1.9 3 1.9 3 0 c 0 -78.9 0 -157.9 0 -236.8 C 1048 714.5 1045 714.4 1045 716.4 L 1045 716.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 275 236.15)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1075, -836.15)",
    d: "M 1073.5 719.1 c 0 78 0 156.1 0 234.1 c 0 1.9 3 1.9 3 0 c 0 -78 0 -156.1 0 -234.1 C 1076.5 717.2 1073.5 717.2 1073.5 719.1 L 1073.5 719.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 261.4 354.6)",
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1061.4, -954.6)",
    d: "M 1047.8 956.1 c 9.1 0 18.1 0 27.2 0 c 1.9 0 1.9 -3 0 -3 c -9.1 0 -18.1 0 -27.2 0 C 1045.9 953.1 1045.9 956.1 1047.8 956.1 L 1047.8 956.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 178.2249 23.121)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-978.2249, -623.121)",
    d: "M 945.6 590.9 c -1.7 2.2 -2.1 4.5 -2.3 6.5 c -2.2 16 -1.4 28.1 -1.4 28.1 c 0.4 6 0.8 14.9 1.1 26.3 c 4.3 4.5 8.4 6.3 11 7.2 c 7.5 2.5 14.6 0.8 28.4 -2.7 c 5.6 -1.4 10 -2.8 13 -3.8 c 2.2 -4.1 2.9 -7.6 3.1 -9.9 c 0.4 -4.9 -1.1 -7.2 0.7 -9.7 c 1.8 -2.5 4.4 -2 5.6 -4.7 c 0.7 -1.6 0.6 -4 -0.5 -4.9 c -1.9 -1.3 -5.3 2.1 -7 0.7 c -0.5 -0.4 -0.5 -0.8 -0.7 -4.5 c -0.3 -5 -0.4 -5.6 0.2 -6.1 c 0.5 -0.6 2.2 -0.6 5.4 -0.5 c 2.4 0 3.5 0 4 0.4 c 1.9 1.5 1.1 6.4 -0.7 9.9 c -2.3 4.4 -5.8 5.8 -5.4 6.7 c 0.5 0.9 4.9 0 8.5 -2.2 c 2.1 -1.3 5.2 -3.1 5.9 -6.5 c 1.2 -5 -3.6 -9.4 -4.3 -10.1 c -5.9 -5.5 -14.5 -3.7 -15.6 -3.4 c 0.1 -4.8 0.2 -9.6 0.4 -14.4 c -12.9 -5.7 -23.7 -7 -30.4 -7.2 C 950.5 585.6 946.8 589.2 945.6 590.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 142.0557 22.95)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-942.0557, -622.95)",
    d: "M 941.2 595.4 c -1.5 18.4 -1.7 36.7 -0.6 55.1 c 0.1 1.9 3.1 1.9 3 0 c -1.1 -18.4 -0.9 -36.8 0.6 -55.1 C 944.4 593.5 941.4 593.5 941.2 595.4 L 941.2 595.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 166.4027 54.9515)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-966.4028, -654.9515)",
    d: "M 940.8 651.3 c 13.4 14.8 34.3 10.2 50.6 3.9 c 1.8 -0.7 1 -3.6 -0.8 -2.9 c -15.3 5.9 -35.1 10.9 -47.7 -3.1 C 941.6 647.8 939.5 649.9 940.8 651.3 L 940.8 651.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 168.1806 -9.6468)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-968.1806, -590.3531)",
    d: "M 944.1 595.3 c 3.9 -7.1 17.1 -7.8 24.3 -7.6 c 8.6 0.2 16.8 2.5 24.4 6.6 c 1.7 0.9 3.2 -1.7 1.5 -2.6 c -8.9 -4.9 -19 -7.4 -29.2 -7 c -7.7 0.3 -19.4 1.6 -23.6 9.1 C 940.6 595.5 943.2 597 944.1 595.3 L 944.1 595.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 202.4628 24.5023)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1002.4628, -624.5023)",
    d: "M 993.1 594.6 c 0 4.5 0 9 0 13.5 c 0 1 1 1.6 1.9 1.4 c 5 -1.1 12.9 0 15.8 4.9 c 5.7 9.4 -5.4 11.4 -11.1 15.2 c -2.5 1.6 -2.9 3.3 -2.9 6.2 c 0 6.5 0 14 -6.7 17.3 c -1.7 0.9 -0.2 3.4 1.5 2.6 c 5.9 -2.9 7.8 -9 8.1 -15.2 c 0.1 -2.8 -0.8 -6 1.4 -8.3 c 1.1 -1.1 3.3 -1.6 4.7 -2.3 c 3 -1.4 5.8 -2.9 7.8 -5.6 c 3.8 -5.1 1.7 -10.4 -2.8 -14.1 c -4.7 -3.8 -10.8 -4.9 -16.6 -3.7 c 0.6 0.5 1.3 1 1.9 1.4 c 0 -4.5 0 -9 0 -13.5 C 996 592.7 993 592.7 993.1 594.6 L 993.1 594.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 197.0689 18.8307)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-997.0689, -618.8307)",
    d: "M 995.4 613.5 c -0.4 3.7 -0.2 7.4 0.6 11 c 0.4 1.9 3.3 1.1 2.9 -0.8 c -0.7 -3.4 -0.9 -6.8 -0.5 -10.2 C 998.6 611.6 995.6 611.6 995.4 613.5 L 995.4 613.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 202.099 18.5513)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1002.099, -618.5513)",
    d: "M 997.7 616.5 c 1.5 -1.3 3.7 -2.2 5.7 -1.6 c 1.9 0.6 3.4 2.8 2.5 4.8 c -1.3 2.7 -5.7 2.7 -8.3 2.7 c -1.9 0 -1.9 3 0 3 c 4.7 0.1 12.3 -1.3 11.5 -7.7 c -0.3 -2.6 -2.4 -4.9 -4.9 -5.7 c -3.1 -0.9 -6.3 0.3 -8.7 2.4 C 994.1 615.6 996.2 617.7 997.7 616.5 L 997.7 616.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 168.1367 -4.3249)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-968.1368, -595.6751)",
    d: "M 952.7 590.6 c -2 1.6 -5.3 0.8 -5.6 4.2 c -0.3 2.7 2 4.6 4.3 5.1 c 5.2 1.1 11.6 -0.2 17 -0.1 c 6.4 0.1 12.9 0.6 19.3 1.3 c 0.8 0.1 1.5 -0.8 1.5 -1.5 c 0 -1.7 0 -1.8 -0.9 -3.3 c -1 -1.6 -3.6 -0.1 -2.6 1.5 c 0.2 0.6 0.3 1.2 0.5 1.8 c 0.5 -0.5 1 -1 1.5 -1.5 c -7.7 -0.9 -15.4 -1.3 -23.1 -1.3 c -1.9 0 -3.9 0 -5.8 0.1 c -1.4 0 -4.3 0.8 -5.5 0.2 c -0.6 -0.9 -1.3 -1.8 -1.9 -2.7 c 0.5 -0.1 1.1 -0.2 1.6 -0.4 c 0.5 -0.4 1.4 -0.8 1.9 -1.2 C 956.4 591.5 954.2 589.4 952.7 590.6 L 952.7 590.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 159.225 22.5303)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.09
    },
    transform: " translate(-959.225, -622.5303)",
    d: "M 970.6 586.5 c -0.4 -1.4 -8.9 -0.8 -16.6 1.6 c -4.4 1.3 -7.9 3.1 -10.3 4.3 c -0.8 11 -1.3 22.4 -1.6 34.4 c -0.2 8.5 -0.2 16.8 0 24.9 c 2.8 2.1 9.6 6.7 19.4 7.5 c 6.6 0.5 11.9 -0.9 15 -2 c -1.7 -19.5 -3.4 -39 -5.1 -58.5 c -8 -0.1 -14.3 -0.8 -14.6 -2.8 C 956.2 592.8 971.2 588.4 970.6 586.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 152.8238 28.95)",
    id: "mug"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.11
    },
    transform: " translate(-952.8238, -628.95)",
    d: "M 944.1 598.7 c 4.2 13.3 8.6 26.8 13 40.3 c 2.2 6.8 4.5 13.5 6.7 20.2 c -2.8 -0.1 -7.3 -0.6 -12.2 -2.8 c -4.2 -1.8 -7.2 -4.2 -9.1 -5.9 c -0.6 -8.8 -0.9 -18.6 -0.4 -29.2 C 942.5 613.2 943.2 605.6 944.1 598.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 272.4998 -99.4911)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1072.4997, -500.5089)",
    d: "M 975.6 425.6 c -0.9 4.6 -2 11.4 -3.2 19.7 c -3.7 27.3 -3.6 48.5 -3.5 65 c 0.1 12.1 0.6 27.8 2.1 46.3 c 4.8 1.7 12.6 4.3 22.5 6.7 c 17.1 4.2 27.1 4.6 55.5 8.4 c 17.5 2.4 13.4 2.2 28.8 4.2 c 22.7 3 37 4.9 55.1 5.3 c 8.3 0.2 19.9 0.1 34.1 -1.1 c 2.5 -10.9 5.2 -24.7 7 -40.7 c 0.5 -4 2.4 -22.2 2.1 -47 c -0.2 -15.9 -1.4 -35.9 -4.9 -59 c -3.8 -0.9 -9.1 -2.2 -15.4 -3.5 c -7.5 -1.6 -33.7 -6.9 -69.5 -9.1 c -37.9 -2.4 -66.9 -0.1 -76.5 0.7 C 995.8 422.6 984.2 424.2 975.6 425.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -377.3 -65.85)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-422.7, -534.15)",
    d: "M 320.9 501.7 c 17.3 44.1 34.5 88.2 51.8 132.3 c 50.6 -30.7 101.2 -61.5 151.8 -92.2 c -14.6 -35.8 -29.1 -71.7 -43.7 -107.5 c -25.7 8.7 -52.8 18.9 -81.1 30.8 C 371.3 477.1 345.1 489.4 320.9 501.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -307.2 15.3)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-492.8, -615.3)",
    d: "M 371.8 635.8 c 18.8 11.4 39.7 22.9 62.9 33.8 c 14.4 6.9 28.5 12.9 41.9 18.3 c 23.1 -15.6 46.2 -31.2 69.2 -47 c 22.7 -15.6 45.4 -31.2 68 -47 c -28.8 -17.1 -57.7 -34.1 -86.5 -51.2 C 475.4 573.8 423.6 604.8 371.8 635.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -335.9 -4.2205)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-464.1, -595.7796)",
    d: "M 400 638 c 43.7 -26.4 88.1 -52.1 129.7 -81.8 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -41.6 29.7 -86 55.4 -129.7 81.8 C 396.9 636.4 398.4 639 400 638 L 400 638 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -319.3 6.0795)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-480.7, -606.0796)",
    d: "M 416.6 648.3 c 43.7 -26.4 88.1 -52.1 129.7 -81.8 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -41.6 29.7 -86 55.4 -129.7 81.8 C 413.5 646.7 415 649.3 416.6 648.3 L 416.6 648.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -299.0319 15.7795)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-500.9681, -615.7796)",
    d: "M 436.9 658 c 43.7 -26.4 88.1 -52.1 129.7 -81.8 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -41.6 29.7 -86 55.4 -129.7 81.8 C 433.7 656.4 435.2 659 436.9 658 L 436.9 658 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -282.4319 26.0795)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-517.5681, -626.0796)",
    d: "M 453.5 668.3 c 43.7 -26.4 88.1 -52.1 129.7 -81.8 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -41.6 29.7 -86 55.4 -129.7 81.8 C 450.3 666.7 451.8 669.3 453.5 668.3 L 453.5 668.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -369.1 37.75)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-430.9, -637.75)",
    d: "M 413.6 628.6 c 11 7 22.1 13.9 33.1 20.9 c 1.6 1 3.1 -1.6 1.5 -2.6 c -11 -7 -22.1 -13.9 -33.1 -20.9 C 413.5 625 412 627.6 413.6 628.6 L 413.6 628.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -352.9686 28.2)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-447.0314, -628.2)",
    d: "M 430.8 618.6 c 10.3 7.3 20.6 14.5 30.9 21.8 c 1.6 1.1 3.1 -1.5 1.5 -2.6 c -10.3 -7.3 -20.6 -14.5 -30.9 -21.8 C 430.8 614.9 429.3 617.5 430.8 618.6 L 430.8 618.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -337.134 18.4517)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-462.866, -618.4517)",
    d: "M 447.3 608.5 c 9.9 7.2 19.7 14.6 29.2 22.4 c 1.5 1.2 3.6 -0.9 2.1 -2.1 c -9.7 -7.9 -19.7 -15.5 -29.8 -22.8 C 447.2 604.7 445.7 607.3 447.3 608.5 L 447.3 608.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -320.7111 8.6716)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-479.2888, -608.6716)",
    d: "M 464.5 598.7 c 9.7 6.9 18.9 14.4 27.7 22.4 c 1.4 1.3 3.5 -0.8 2.1 -2.1 c -9 -8.2 -18.4 -15.8 -28.3 -22.9 C 464.4 595 462.9 597.6 464.5 598.7 L 464.5 598.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -306.0469 1.0017)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-493.9531, -601.0017)",
    d: "M 480.3 590.1 c 9 7.4 17.4 15.3 25.3 23.8 c 1.3 1.4 3.4 -0.7 2.1 -2.1 c -7.9 -8.5 -16.4 -16.4 -25.3 -23.8 C 481 586.8 478.8 588.9 480.3 590.1 L 480.3 590.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -292.7469 -7.9277)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-507.2531, -592.0723)",
    d: "M 492.8 580.3 c 9.8 7.7 18.7 16.2 26.9 25.5 c 1.3 1.5 3.4 -0.7 2.1 -2.1 c -8.2 -9.3 -17.1 -17.8 -26.9 -25.5 C 493.5 577 491.3 579.1 492.8 580.3 L 492.8 580.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -276.6271 -19.3746)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-523.3728, -580.6254)",
    d: "M 508.4 569.6 c 9.6 7.7 19 15.7 27.9 24.1 c 1.4 1.3 3.5 -0.8 2.1 -2.1 c -9 -8.4 -18.3 -16.5 -27.9 -24.1 C 509 566.3 506.9 568.4 508.4 569.6 L 508.4 569.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -264.1415 -26.8388)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-535.8584, -573.1612)",
    d: "M 521.6 562.2 c 5.3 3 9.5 7.8 13.9 12 c 4.3 4.1 8.5 8.2 12.8 12.3 c 1.4 1.3 3.5 -0.8 2.1 -2.1 c -4.7 -4.5 -9.4 -9.1 -14.1 -13.6 c -4.1 -4 -8.1 -8.3 -13.1 -11.2 C 521.4 558.7 519.9 561.3 521.6 562.2 L 521.6 562.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -382.9459 47.0631)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-417.054, -647.0631)",
    d: "M 398 638.2 c 11.7 7.6 23.9 14.4 36.5 20.4 c 1.7 0.8 3.3 -1.8 1.5 -2.6 c -12.6 -6 -24.7 -12.9 -36.5 -20.4 C 397.9 634.6 396.4 637.2 398 638.2 L 398 638.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -269.5185 -44.25)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-530.4815, -555.75)",
    d: "M 529.5 557 c 0.4 0.1 0.8 0.2 1.2 0.3 c 0.8 0.2 1.7 -0.2 1.8 -1 c 0.2 -0.8 -0.2 -1.6 -1 -1.8 c -0.4 -0.1 -0.8 -0.2 -1.2 -0.3 c -0.8 -0.2 -1.7 0.2 -1.8 1 C 528.2 555.9 528.7 556.8 529.5 557 L 529.5 557 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -252.2221 -34.2322)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-547.7779, -565.7678)",
    d: "M 529.2 556.8 c 12.6 5.6 23.5 14.2 35.7 20.5 c 1.7 0.9 3.2 -1.7 1.5 -2.6 c -12.2 -6.3 -23.1 -14.9 -35.7 -20.5 C 529 553.4 527.4 556 529.2 556.8 L 529.2 556.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -357.1319 62.4896)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-442.8681, -662.4896)",
    d: "M 433.2 658.5 c 6.2 3.1 12.2 6.6 17.9 10.5 c 1.6 1.1 3.1 -1.5 1.5 -2.6 c -5.8 -3.9 -11.7 -7.4 -17.9 -10.5 C 433 655 431.5 657.6 433.2 658.5 L 433.2 658.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -344.8298 54.4)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-455.1702, -654.4)",
    d: "M 447.6 650.1 c 4.6 3.4 9 7.1 13.2 11.1 c 1.4 1.3 3.5 -0.8 2.1 -2.1 c -4.3 -4.2 -8.9 -8 -13.8 -11.6 C 447.6 646.3 446.1 648.9 447.6 650.1 L 447.6 650.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -330.1561 45.9479)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-469.8439, -645.948)",
    d: "M 462 641 c 5 3.7 9.6 7.8 13.8 12.3 c 1.3 1.4 3.4 -0.7 2.1 -2.1 c -4.4 -4.7 -9.2 -9 -14.4 -12.8 C 462 637.3 460.5 639.9 462 641 L 462 641 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -315.8263 36.55)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-484.1737, -636.55)",
    d: "M 477.1 631.4 c 4.2 4 8.2 8.2 12.1 12.4 c 1.3 1.4 3.4 -0.7 2.1 -2.1 c -3.9 -4.3 -7.9 -8.4 -12.1 -12.4 C 477.8 627.9 475.7 630 477.1 631.4 L 477.1 631.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -274.1056 11.05)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-525.8944, -611.05)",
    d: "M 518.8 605 c 4 4.7 8 9.5 12.1 14.2 c 1.2 1.5 3.4 -0.7 2.1 -2.1 c -4 -4.7 -8 -9.5 -12.1 -14.2 C 519.6 601.4 517.5 603.6 518.8 605 L 518.8 605 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -256.65 -0.1294)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-543.35, -599.8706)",
    d: "M 536.5 594.4 c 4 4.2 7.8 8.6 11.6 13 c 1.3 1.5 3.4 -0.7 2.1 -2.1 c -3.8 -4.4 -7.6 -8.8 -11.6 -13 C 537.3 590.9 535.2 593 536.5 594.4 L 536.5 594.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -241.5 -10.25)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-558.5, -589.75)",
    d: "M 548.2 586.6 c 6.4 3 12.7 5.9 19.1 8.9 c 1.7 0.8 3.3 -1.8 1.5 -2.6 c -6.4 -3 -12.7 -5.9 -19.1 -8.9 C 548 583.2 546.4 585.8 548.2 586.6 L 548.2 586.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -226.0681 -19.9396)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-573.9319, -580.0604)",
    d: "M 564.6 576.5 c 5.6 3.5 11.3 6.8 17.1 9.8 c 1.7 0.9 3.2 -1.7 1.5 -2.6 c -5.8 -3 -11.5 -6.3 -17.1 -9.8 C 564.5 572.8 563 575.4 564.6 576.5 L 564.6 576.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.7689 -153.6112)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-789.231, -446.3887)",
    d: "M 654.3 372.9 c -1.2 11.1 -2.2 22.5 -2.8 34.4 c -2.5 48.6 1.6 92.5 8.4 130.3 c 21.1 -0.1 38.1 -0.4 48.8 -0.7 c 73.4 -1.8 105.2 -6.1 170.6 -6.3 c 16.6 0 29.9 0.2 37.6 0.4 c 2.6 -10.4 4.9 -21.4 6.7 -33 c 8.1 -52.8 3 -99.4 -4.9 -135.5 c -13.6 -2.6 -33.7 -5.7 -58.3 -7 c -16.1 -0.8 -20.6 -0.2 -85.3 2.8 c -46 2.1 -58.3 2.5 -79.7 6 C 678 366.9 663.8 370.3 654.3 372.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 249.915 -7.3875)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1049.915, -592.6125)",
    d: "M 1048.6 572.3 c 0.6 13.6 0.4 27.2 -0.7 40.7 c -0.1 1.9 2.9 1.9 3 0 c 1.1 -13.6 1.3 -27.1 0.7 -40.7 C 1051.5 570.3 1048.5 570.3 1048.6 572.3 L 1048.6 572.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 267.7 -5.9375)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1067.7, -594.0625)",
    d: "M 1066.2 575.2 c 0 12.6 0 25.2 0 37.8 c 0 1.9 3 1.9 3 0 c 0 -12.6 0 -25.2 0 -37.8 C 1069.2 573.2 1066.2 573.2 1066.2 575.2 L 1066.2 575.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 258.5592 17.4892)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1058.5591, -617.4891)",
    d: "M 1048.3 611.6 c -3.2 -0.2 -15.5 2 -13 7.7 c 1.1 2.6 5.5 2.8 7.7 3.2 c 5.1 0.8 10.3 1 15.4 1 c 4.9 -0.1 10 -0.1 14.9 -0.7 c 2.3 -0.3 7 -0.8 8.4 -3.1 c 3.1 -5.3 -10.7 -7.8 -13.3 -8.2 c -1.9 -0.3 -2.7 2.6 -0.8 2.9 c 2.2 0.4 4.3 0.8 6.5 1.6 c 2.9 1 5.7 1.6 2.1 3.3 c -4 1.8 -10.5 1.1 -14.8 1.2 c -5 0.1 -10.1 0.1 -15.1 -0.5 c -1.9 -0.2 -9.5 -0.1 -5.8 -3.7 c 1.8 -1.8 5.6 -1.8 7.9 -1.7 C 1050.3 614.7 1050.3 611.7 1048.3 611.6 L 1048.3 611.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 210.0552 -35.2859)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1010.0552, -564.7141)",
    d: "M 971.4 558.8 c 25.1 7.5 50.8 12.4 76.9 14.7 c 1.9 0.2 1.9 -2.8 0 -3 c -25.8 -2.2 -51.3 -7.1 -76.1 -14.5 C 970.4 555.4 969.6 558.3 971.4 558.8 L 971.4 558.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 317.2193 -22.8079)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1117.2193, -577.1921)",
    d: "M 1066.5 575.5 c 33.4 5.9 67.4 8.1 101.1 4.7 c 1.9 -0.2 1.9 -3.2 0 -3 c -33.5 3.3 -67.2 1.3 -100.3 -4.6 C 1065.4 572.3 1064.6 575.2 1066.5 575.5 L 1066.5 575.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 172.428 -108.8807)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-972.428, -491.1193)",
    d: "M 972.4 556.4 c -2.4 -43.4 -4.6 -87.3 5 -130.1 c 0.4 -1.9 -2.5 -2.7 -2.9 -0.8 c -9.6 43 -7.4 87.2 -5.1 130.9 C 969.5 558.3 972.5 558.3 972.4 556.4 L 972.4 556.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 272.9141 -173.111)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1072.9141, -426.889)",
    d: "M 976.1 427.3 c 32 -6.8 65.9 -5.9 98.5 -5.3 c 32.1 0.6 64.4 3.5 95.2 13.1 c 1.8 0.6 2.6 -2.3 0.8 -2.9 c -31.1 -9.7 -63.6 -12.6 -96 -13.2 c -32.8 -0.6 -67 -1.5 -99.3 5.4 C 973.4 424.9 974.2 427.7 976.1 427.3 L 976.1 427.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 371.8125 -93.75)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1171.8125, -506.25)",
    d: "M 1169.9 434.4 c 7.2 47.7 5.9 96.5 -3.7 143.7 c -0.4 1.9 2.5 2.7 2.9 0.8 c 9.7 -47.9 11 -97.1 3.7 -145.3 C 1172.5 431.7 1169.6 432.5 1169.9 434.4 L 1169.9 434.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -453.05 -29.75)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-346.95, -570.25)",
    d: "M 319.4 503.5 c 17.4 44.8 34.8 89.5 52.2 134.3 c 0.7 1.8 3.6 1 2.9 -0.8 c -17.4 -44.8 -34.8 -89.5 -52.2 -134.3 C 321.6 500.9 318.7 501.7 319.4 503.5 L 319.4 503.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -376.1176 63.0295)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-423.8824, -663.0295)",
    d: "M 371 638.8 c 34 18.5 68.8 35.5 104.2 51.1 c 1.8 0.8 3.3 -1.8 1.5 -2.6 c -35.4 -15.6 -70.2 -32.7 -104.2 -51.1 C 370.8 635.3 369.3 637.8 371 638.8 L 371 638.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -255.1 41.65)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-544.9, -641.65)",
    d: "M 477.2 690.1 c 45.6 -31.4 91.3 -62.9 136.9 -94.3 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -45.6 31.4 -91.3 62.9 -136.9 94.3 C 474.1 688.6 475.6 691.2 477.2 690.1 L 477.2 690.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -399.699 -132.0629)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-400.301, -467.9372)",
    d: "M 320.7 503.2 c 52 -25.9 105.6 -48.5 160.5 -67.7 c 1.8 -0.6 1 -3.5 -0.8 -2.9 c -55.1 19.3 -108.9 42 -161.2 68 C 317.4 501.5 318.9 504 320.7 503.2 L 320.7 503.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -351.35 -10.95)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-448.65, -589.05)",
    d: "M 373.6 636.7 c 50.5 -30.9 101.1 -61.8 151.6 -92.7 c 1.6 -1 0.1 -3.6 -1.5 -2.6 c -50.5 30.9 -101.1 61.8 -151.6 92.7 C 370.5 635.1 372 637.7 373.6 636.7 L 373.6 636.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -297.35 -112.1)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-502.65, -487.9)",
    d: "M 479.2 435.1 c 14.7 35.5 29.3 71 44 106.4 c 0.7 1.8 3.6 1 2.9 -0.8 c -14.7 -35.5 -29.3 -71 -44 -106.4 C 481.4 432.5 478.5 433.3 479.2 435.1 L 479.2 435.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -229.9 -32.7308)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-570.1, -567.2692)",
    d: "M 525.3 543.3 c 29.4 16.8 58.8 33.7 88.1 50.5 c 1.7 1 3.2 -1.6 1.5 -2.6 c -29.4 -16.8 -58.8 -33.7 -88.1 -50.5 C 525.1 539.8 523.6 542.4 525.3 543.3 L 525.3 543.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -144.5328 -144.75)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-655.4672, -455.25)",
    d: "M 651.5 373.6 c -4.1 54.5 1.1 109.1 6.4 163.3 c 0.2 1.9 3.2 1.9 3 0 c -5.3 -54.3 -10.5 -108.8 -6.4 -163.3 C 654.7 371.7 651.7 371.7 651.5 373.6 L 651.5 373.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.8141 -235.75)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-786.1859, -364.25)",
    d: "M 653.9 374.9 c 31.8 -11.6 66.1 -12.4 99.5 -14.4 c 34.7 -2.1 69.5 -4.8 104.2 -3.8 c 20.4 0.6 40.7 2.5 60.8 6.6 c 1.9 0.4 2.7 -2.5 0.8 -2.9 c -34.6 -7.1 -69.9 -7.7 -105 -6.3 c -35.4 1.4 -71.1 3.1 -106.3 6.5 c -18.6 1.8 -37.1 4.9 -54.8 11.3 C 651.3 372.7 652.1 375.6 653.9 374.9 L 653.9 374.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -6.2683 -149.992)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-793.7317, -450.008)",
    d: "M 918.4 362 c 10.2 55.4 9.5 112.5 -2.2 167.7 c 0.5 -0.4 1 -0.7 1.4 -1.1 c -66.8 2.2 -133.5 4.3 -200.3 6.5 c -18.9 0.6 -37.9 1.2 -56.8 1.8 c -1.9 0.1 -1.9 3.1 0 3 c 66.8 -2.2 133.5 -4.3 200.3 -6.5 c 18.9 -0.6 37.9 -1.2 56.8 -1.8 c 0.6 0 1.3 -0.4 1.4 -1.1 c 11.7 -55.7 12.5 -113.3 2.2 -169.3 C 920.9 359.3 918 360.1 918.4 362 L 918.4 362 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 258.7002 -3.0421)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1058.7002, -596.9579)",
    d: "M 1050.3 571.9 c 0 5.6 -0.1 11.3 -0.2 17 c -0.2 8 -0.4 16 -0.7 23.8 c -1.3 -0.2 -4.1 -0.4 -7.2 0.9 c -0.3 0.1 -5.9 2.5 -5.7 4.6 c 0.5 3.6 18.4 4.1 28.2 3.7 c 5.6 -0.2 15.9 -0.6 16.2 -2.8 c 0.2 -1.7 -5 -3.9 -12.4 -6.1 c -0.3 -13.2 -0.6 -26.5 -0.9 -39.7 C 1061.8 572.8 1056 572.3 1050.3 571.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 184.3107 -113.15)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-984.3108, -486.85)",
    d: "M 984.9 437.3 c -3.9 32.9 -5.1 66 -3.5 99.1 c 0.1 1.9 3.1 1.9 3 0 c -1.5 -33.1 -0.3 -66.2 3.5 -99.1 C 988.1 435.4 985.1 435.4 984.9 437.3 L 984.9 437.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 274.6967 -162.9529)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1074.6968, -437.0472)",
    d: "M 987.3 438.5 c 13.8 -5.1 28.4 -6.4 43 -6.6 c 14.4 -0.1 28.8 0.4 43.1 1.3 c 29.8 1.9 59.4 6 88.6 12 c 1.9 0.4 2.7 -2.5 0.8 -2.9 c -29.5 -6.1 -59.3 -10.2 -89.4 -12.1 c -14.9 -1 -30 -1.5 -44.9 -1.3 c -14.2 0.2 -28.5 1.7 -41.9 6.7 C 984.7 436.2 985.5 439.1 987.3 438.5 L 987.3 438.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 360.4525 -97.6)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1160.4525, -502.4)",
    d: "M 1161.8 444 c 1.5 39 -2.1 78 -6 116.8 c -0.2 1.9 2.8 1.9 3 0 c 3.9 -38.8 7.4 -77.8 6 -116.8 C 1164.7 442.1 1161.7 442.1 1161.8 444 L 1161.8 444 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 269.7193 -49.5579)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1069.7193, -550.4422)",
    d: "M 981.9 538.6 c 11.8 7 26.8 9.2 40 12.1 c 15.3 3.4 30.8 6.2 46.4 8.4 c 14.7 2.1 29.5 3.6 44.4 4.6 c 14.6 1 30.1 2.6 44.5 -0.3 c 1.9 -0.4 1.1 -3.3 -0.8 -2.9 c -14.4 3 -30.1 1.1 -44.7 0.2 c -14.9 -1 -29.8 -2.6 -44.5 -4.7 c -14.3 -2.1 -28.5 -4.6 -42.6 -7.7 c -13.5 -3 -29.1 -5.2 -41.2 -12.2 C 981.7 535 980.2 537.6 981.9 538.6 L 981.9 538.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 274.3307 -144.392)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1074.3307, -455.608)",
    d: "M 985.5 452 c 59.3 -3.6 118.6 3 177.2 11.2 c 1.9 0.3 2.7 -2.6 0.8 -2.9 c -58.9 -8.3 -118.4 -14.9 -178 -11.3 C 983.6 449.1 983.6 452.1 985.5 452 L 985.5 452 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 206.196 -158.3407)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1006.196, -441.6593)",
    d: "M 1005.8 442.1 c -0.7 -0.2 -0.7 -1.1 0 -1.3 c 0.9 -0.4 1.6 0.6 1.5 1.4 c -0.1 1.3 -1.6 0.4 -1.4 -0.3 c 0.1 -0.1 0.2 -0.2 0.3 -0.3 c -0.1 0.1 -0.2 -0.1 -0.2 -0.1 c 0.1 -0.2 0.7 -0.7 0.7 0 c 0 -1.9 -3 -1.9 -3 0 c 0 1.5 1.2 2.6 2.7 2.6 c 1.6 0 2.8 -1.4 2.5 -3 c -0.2 -1.6 -1.7 -2.7 -3.3 -2.5 c -1.7 0.3 -2.9 1.9 -2.8 3.6 c 0.3 3.7 5.7 5 7.1 1.3 c 1.2 -3 -1.4 -6.5 -4.7 -5.8 c -1.6 0.3 -3 1.7 -3 3.4 c -0.1 1.7 1.1 3.3 2.7 3.8 C 1006.8 445.5 1007.6 442.6 1005.8 442.1 L 1005.8 442.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 221.893 -160.1054)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1021.893, -439.8946)",
    d: "M 1021.8 440.2 c -0.5 -0.1 0 -0.5 0.3 -0.5 c 0.6 0.1 0.5 0.8 0 0.8 c -0.1 0 -0.1 0 -0.1 0 c 0 0 -0.1 -0.1 -0.1 -0.3 c 0 0 0 -0.2 0 -0.3 c 0 0 0 0.1 -0.1 0.1 c -0.2 0 0.2 -0.1 0.1 0 c 0.7 -0.3 -0.1 0.2 0.1 0 c 0 0 0 -0.4 0 -0.2 c 0 0 0.5 0.1 0 0 c -0.8 -0.3 -1.6 0.3 -1.8 1 c -0.2 0.8 0.3 1.6 1 1.8 c 1.3 0.5 2.8 -0.3 3.4 -1.5 c 0.7 -1.2 0.3 -2.7 -0.8 -3.5 c -2.1 -1.6 -5.2 0 -5 2.7 c 0.3 2.9 3.7 4 5.7 1.9 c 2 -2.2 0.3 -5.6 -2.6 -5.7 c -1.6 0 -3.1 1.1 -3.4 2.7 c -0.4 1.6 0.7 3.3 2.3 3.7 C 1022.9 443.6 1023.7 440.7 1021.8 440.2 L 1021.8 440.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 232.2499 -102.7568)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1032.2499, -497.2433)",
    d: "M 1051.7 479.6 c -13.5 5.6 -26.8 11.5 -40 17.6 c -1.3 0.6 -0.7 2.4 0.4 2.7 c 11.3 4 22.1 9 32.5 14.9 c 1.7 1 3.2 -1.6 1.5 -2.6 c -10.6 -6.1 -21.7 -11.1 -33.2 -15.2 c 0.1 0.9 0.2 1.8 0.4 2.7 c 13 -6 26.1 -11.8 39.3 -17.3 C 1054.3 481.7 1053.5 478.8 1051.7 479.6 L 1051.7 479.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 273.55 -102.4434)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1073.55, -497.5566)",
    d: "M 1089.4 475.1 c -11.3 14.3 -22.5 28.5 -33.8 42.8 c -1.2 1.5 0.9 3.6 2.1 2.1 c 11.3 -14.3 22.5 -28.5 33.8 -42.8 C 1092.7 475.8 1090.6 473.6 1089.4 475.1 L 1089.4 475.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 318.3326 -92.5896)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1118.3326, -507.4104)",
    d: "M 1104.5 491.7 c 9.4 6 19.2 11.3 29.3 15.9 c 0 -0.9 0 -1.7 0 -2.6 c -10.8 6.1 -21.6 12.2 -32.4 18.2 c -1.7 0.9 -0.2 3.5 1.5 2.6 c 10.8 -6.1 21.6 -12.2 32.4 -18.2 c 0.9 -0.5 1 -2.1 0 -2.6 c -10.1 -4.6 -19.9 -9.9 -29.3 -15.9 C 1104.4 488 1102.9 490.6 1104.5 491.7 L 1104.5 491.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 324.95 -45.4)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-1124.95, -554.6)",
    d: "M 1106.4 555.7 c 12.4 0.3 24.7 0.6 37.1 0.8 c 1.9 0 1.9 -3 0 -3 c -12.4 -0.3 -24.7 -0.6 -37.1 -0.8 C 1104.5 552.7 1104.5 555.7 1106.4 555.7 L 1106.4 555.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -447.665 -38.6)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-352.335, -561.4)",
    d: "M 329.2 506.2 c 15.4 36.7 29.8 73.8 43.4 111.2 c 0.7 1.8 3.6 1 2.9 -0.8 c -13.6 -37.4 -28 -74.5 -43.4 -111.2 C 331.3 503.6 328.4 504.4 329.2 506.2 L 329.2 506.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -398.2612 -125.542)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-401.7387, -474.458)",
    d: "M 331 505.4 c 47.6 -19.5 95.2 -39.1 142.5 -59.3 c 1.8 -0.8 0.2 -3.3 -1.5 -2.6 c -47.1 20.1 -94.4 39.6 -141.8 59 C 328.4 503.3 329.2 506.2 331 505.4 L 331 505.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -305.8214 -109.9333)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-494.1786, -490.0667)",
    d: "M 473.2 445.3 c 14 29.9 27 60.2 39.1 90.8 c 0.7 1.8 3.6 1 2.9 -0.8 c -12.2 -30.9 -25.3 -61.5 -39.4 -91.6 C 475 442.1 472.4 443.6 473.2 445.3 L 473.2 445.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -355.9778 -21.913)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-444.0221, -578.0869)",
    d: "M 376.2 619.5 c 23.4 -13.1 46.5 -26.5 69.4 -40.3 c 11.3 -6.8 22.6 -13.7 33.8 -20.7 c 11 -6.9 22 -13.9 33.9 -19.3 c 1.8 -0.8 0.2 -3.4 -1.5 -2.6 c -11.9 5.4 -22.9 12.4 -33.9 19.3 c -11.2 7 -22.5 13.9 -33.8 20.7 c -22.9 13.8 -46.1 27.2 -69.4 40.3 C 373 617.9 374.5 620.5 376.2 619.5 L 376.2 619.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -416.6359 -52.1894)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-383.3641, -547.8106)",
    d: "M 387.8 528.6 c -6.6 -4 -13.2 2.9 -17 7.8 c -4.6 5.9 -5.8 13 -3 20 c 2.5 6.1 8.1 12.2 15.2 11.8 c 8.4 -0.5 13.4 -7.9 17.2 -14.5 c 1 -1.7 -1.6 -3.2 -2.6 -1.5 c -2.7 4.7 -5.7 9.9 -11 12 c -6.3 2.6 -11.9 -1.2 -15 -6.7 c -2.4 -4.2 -3.2 -9.4 -1.6 -14.1 c 1.6 -4.5 10.2 -15.8 16.2 -12.2 C 387.9 532.2 389.5 529.6 387.8 528.6 L 387.8 528.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -381.4889 -70.9176)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-418.5111, -529.0824)",
    d: "M 423.4 512.3 c 0 -4.6 -4.7 -3.3 -7.2 -1.4 c -4 3 -8.8 9.8 -9.5 14.8 c -0.8 6.3 6.1 5.1 10.4 4.7 c 5.4 -0.5 13 1.5 8.8 8.7 c -2.7 4.6 -8.2 6.7 -13.2 6.9 c -1.9 0.1 -1.9 3.1 0 3 c 7.6 -0.4 21.7 -7.6 16.6 -17.4 c -2.2 -4.1 -7.1 -4.7 -11.3 -4.4 c -1.1 0.1 -4.2 0.9 -5.3 0.5 c -4 -1.5 -1.8 -4.7 -0.8 -6.6 c 0.7 -1.3 1.4 -2.7 2.3 -3.9 c 0.3 -0.4 6.1 -6.2 6.1 -5 C 420.4 514.3 423.4 514.3 423.4 512.3 L 423.4 512.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -343.2457 -91.3259)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-456.7542, -508.6741)",
    d: "M 461.6 489.7 c -4.9 -1.9 -9.3 2.3 -12.2 5.8 c -2.4 2.8 -6.7 8.5 -5.2 12.6 c 1.6 4.4 8.4 2.4 11.6 2 c 1.7 -0.2 3.6 -0.5 5.3 -0.2 c 4.5 0.6 6.1 5.2 4 8.9 c -2.5 4.4 -7.4 5.8 -12 6.4 c -1.9 0.3 -1.1 3.2 0.8 2.9 c 7.4 -1.1 20.4 -8.6 14 -17.9 c -3.1 -4.5 -9.3 -3.4 -13.8 -2.9 c -1 0.1 -4.7 1.1 -5.3 0.4 c -1.5 -1.5 -0.6 -5 0.3 -6.6 c 2 -3.4 6.9 -10.5 11.8 -8.6 C 462.6 493.3 463.4 490.4 461.6 489.7 L 461.6 489.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -325.45 -52.1296)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-474.55, -547.8704)",
    d: "M 464 556.4 c 7.5 -4.8 15.1 -9.7 22.6 -14.5 c 1.6 -1 0.1 -3.6 -1.5 -2.6 c -7.5 4.8 -15.1 9.7 -22.6 14.5 C 460.9 554.9 462.4 557.5 464 556.4 L 464 556.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -304.8721 -64.05)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-495.1279, -535.95)",
    d: "M 493 538.6 c 1.9 -0.9 3.8 -1.8 5.8 -2.7 c 1.7 -0.8 0.2 -3.4 -1.5 -2.6 c -1.9 0.9 -3.8 1.8 -5.8 2.7 C 489.7 536.8 491.3 539.4 493 538.6 L 493 538.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -351.3507 -136.9049)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-448.6493, -463.0951)",
    d: "M 446.9 463.6 C 446.9 463.6 446.9 463.6 446.9 463.6 c 0.1 -0.2 0.1 -0.4 0.2 -0.7 c 0 -0.1 0.1 -0.1 0.1 -0.2 c 0.2 -0.1 0.4 -0.3 0.7 -0.4 c -0.3 0.1 0.6 0.1 0.7 0.1 c 0.3 0.1 0.3 0.3 0.4 0.5 c 0.1 0.2 0 -0.2 0 0 c -0.1 0.3 0 -0.2 0 0 c 0 0.1 0 0.1 0 0 c 0 0 -0.1 0.1 -0.1 0.1 c -0.1 0 -0.2 0.1 -0.2 0.1 c -0.2 0.1 -0.1 -0.1 0 0 c -0.1 0 -0.2 0 -0.1 0 c 0.1 0 0.1 0 0 0 c 0 -0.1 0 0.1 0 0 c 0 0 -0.1 0 -0.1 -0.1 c -0.1 -0.1 0 -0.1 0 0.1 c 0 -0.1 0 -0.1 0 0 c 0 0 -0.1 -0.3 0 -0.3 c 0 0 -0.1 0.2 -0.1 0.3 c 0.1 -0.3 -0.1 0.1 0 -0.1 c 0 0 0.2 -0.2 0.1 -0.1 c -0.1 0.1 0.2 0 0.2 0 c 0.1 0 0.2 0 0.2 0.1 c 0.1 0 0.1 0.1 0 0 c 0 0 0.1 0.3 0.1 0.1 c 0 -0.2 0 0.3 0 0.4 c -0.1 0.3 -0.4 0.4 -0.6 0.4 c 0.2 0 0 0 -0.1 0 c 0.2 0.1 0 0 -0.1 0 c 0.2 0.1 -0.1 -0.1 -0.1 -0.1 c -0.1 -0.2 -0.1 -0.3 -0.1 -0.5 c 0 -0.3 0 -0.4 0.3 -0.6 c 0.2 -0.2 0.2 -0.2 0.1 -0.1 c 0.1 0 0.1 -0.1 0.2 -0.1 c -0.2 0 0.1 0 0.1 0 c -0.2 0 0.1 0 0.1 0 c -0.2 -0.1 0.1 0.1 0.2 0.1 c 0.2 0.1 0.4 0.5 0.4 0.7 c 0 -0.8 -0.7 -1.5 -1.5 -1.5 c -0.8 0 -1.5 0.7 -1.5 1.5 c 0 2.8 4.5 2.8 4.6 0.1 c 0.1 -2.7 -4.2 -3.2 -4.8 -0.6 c -0.3 1.3 0.6 2.7 1.9 3.1 c 1.2 0.3 2.5 -0.3 3 -1.4 c 0.6 -1.1 0.4 -2.5 -0.5 -3.4 c -0.9 -0.9 -2.4 -1.2 -3.5 -0.5 c -1.2 0.7 -1.6 2.4 -0.9 3.6 c 0.4 0.6 1.1 1.1 1.8 1.1 c 0.9 0 1.8 -0.8 1.8 -1.8 c -0.1 -0.8 -0.6 -1.5 -1.5 -1.5 C 447.7 462.1 446.9 462.8 446.9 463.6 L 446.9 463.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -338.9947 -141.6651)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-461.0052, -458.335)",
    d: "M 460.5 457.6 c 0.8 -0.2 1.1 1.1 0.3 1.2 c -0.1 0 -0.4 -0.1 -0.3 -0.1 c 0.1 0.1 -0.2 -0.2 0 0 c -0.2 -0.2 -0.1 -0.1 0 0.1 c 0 -0.1 0 -0.1 -0.1 -0.2 c 0 0.1 0 0.1 0 0 c 0 -0.1 0 -0.1 0 0 c 0 0.1 0 0.1 0 -0.1 c 0 -0.1 0.1 -0.3 0.2 -0.4 c 0.1 -0.1 0.3 -0.1 0.4 -0.2 c -0.4 0 0.3 0 0 0 c 0.1 0 0.1 0 0.2 0.1 c -0.1 -0.1 -0.1 -0.1 0 0 c 0.1 0.1 0.1 0.1 0 0 c 0 0 0.1 0.1 0.1 0.1 c -0.1 -0.3 0.1 0.3 0 0 c 0 0.1 0 0.5 0.1 0.3 c -0.3 0.3 -0.7 0.7 -1 1 c 0.2 -0.1 0.5 -0.2 0.7 -0.2 c -0.2 0 0.2 0 0 0 c -0.1 0 -0.1 0 0 0 c 0.1 0 0.1 0 0 0 c -0.1 -0.1 -0.2 -0.1 -0.3 -0.3 c 0 -0.1 -0.1 -0.4 -0.1 -0.3 c 0 0.2 0.1 -0.3 0 -0.1 c 0.1 -0.4 0.5 -0.7 0.9 -0.7 c -0.8 0 -1.5 0.7 -1.5 1.5 c 0 0.8 0.7 1.5 1.5 1.5 c 2.3 0 2.8 -3.2 0.9 -4.3 c -0.9 -0.5 -2 -0.4 -3 0 c -1.2 0.5 -1.4 1.9 -0.8 3 c 1 1.8 3.9 2 4.6 -0.2 c 0.6 -1.8 -1.1 -3.8 -3 -3.5 c -1.3 0.2 -2.2 1.7 -1.9 2.9 c 0.3 1.3 1.7 2.1 2.9 1.7 c 0.8 -0.2 1.3 -1.1 1 -1.8 C 462.1 457.9 461.3 457.4 460.5 457.6 L 460.5 457.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -134.0952 -146.1375)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-665.9048, -453.8625)",
    d: "M 660.4 378.9 c 0.8 50.1 3.4 100.1 8 150 c 0.2 1.9 3.2 1.9 3 0 c -4.5 -49.9 -7.2 -99.9 -8 -150 C 663.4 376.9 660.4 376.9 660.4 378.9 L 660.4 378.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.1948 -226.6391)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-785.8052, -373.3609)",
    d: "M 663.9 380.5 c 20.5 -3.6 41.3 -4.3 62 -5.2 c 20.1 -0.8 40.3 -1.6 60.4 -2.3 c 40.6 -1.5 81.2 -2.7 121.8 -3.8 c 1.9 0 1.9 -3 0 -3 c -41.3 1.1 -82.5 2.3 -123.8 3.8 c -20.5 0.7 -40.9 1.5 -61.4 2.4 c -20 0.8 -40 1.7 -59.8 5.2 C 661.3 377.9 662.1 380.8 663.9 380.5 L 663.9 380.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 111.9697 -159.6614)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-911.9697, -440.3386)",
    d: "M 907.6 368.5 c 5.6 10.7 5.3 23.1 5.6 34.8 c 0.3 12.2 0.4 24.4 0.3 36.6 c -0.2 24.4 -1.1 48.7 -2.8 73.1 c -0.1 1.9 2.9 1.9 3 0 c 1.7 -25.6 2.7 -51.3 2.8 -77 c 0.1 -12.5 -0.1 -25 -0.4 -37.6 c -0.3 -10.8 -0.7 -21.6 -5.9 -31.4 C 909.3 365.3 906.7 366.8 907.6 368.5 L 907.6 368.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -9.8807 -79.1811)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-790.1193, -520.8189)",
    d: "M 670.6 529.3 c 78.8 -14.6 159.8 -12.7 239.5 -14 c 1.9 0 1.9 -3 0 -3 c -80.1 1.3 -161.3 -0.5 -240.3 14.1 C 667.9 526.8 668.7 529.7 670.6 529.3 L 670.6 529.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.8849 -204.2746)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-686.1152, -395.7254)",
    d: "M 690.5 387.4 c -4 2.7 -7.8 5.7 -11.4 9 c -0.7 0.7 -0.5 1.9 0.3 2.4 c 3.6 2.2 8.9 1.7 11.7 5 c 1.2 1.5 3.3 -0.6 2.1 -2.1 c -3.1 -3.8 -8.4 -3.1 -12.3 -5.5 c 0.1 0.8 0.2 1.6 0.3 2.4 c 3.4 -3.1 7 -5.9 10.8 -8.5 C 693.6 388.9 692.1 386.3 690.5 387.4 L 690.5 387.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.863 -203.7357)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-703.1369, -396.2643)",
    d: "M 707 385.9 c -4.1 6.1 -7.5 12.4 -10.4 19.1 c -0.8 1.8 1.8 3.3 2.6 1.5 c 2.9 -6.7 6.3 -13.1 10.4 -19.1 C 710.6 385.8 708 384.3 707 385.9 L 707 385.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -80.1688 -204.1652)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-719.8311, -395.8348)",
    d: "M 712.9 397.6 c 4.6 -0.6 9.3 -0.7 13.9 -0.3 c 1.9 0.2 1.9 -2.8 0 -3 c -4.7 -0.4 -9.3 -0.3 -13.9 0.3 C 711 394.8 710.9 397.8 712.9 397.6 L 712.9 397.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -61.5251 -204.9743)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-738.4749, -395.0257)",
    d: "M 730.2 386.8 c 3.6 5 10.2 5.4 14.3 9.7 c 0.1 -0.8 0.2 -1.6 0.3 -2.4 c -4.4 2.5 -8.4 5.4 -12 8.8 c -1.4 1.3 0.7 3.4 2.1 2.1 c 3.5 -3.2 7.3 -6 11.4 -8.3 c 0.9 -0.5 1 -1.7 0.3 -2.4 c -3.9 -4 -10.6 -4.5 -13.9 -9.1 C 731.6 383.8 729 385.3 730.2 386.8 L 730.2 386.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -123.95 -178.3464)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-676.05, -421.6536)",
    d: "M 669.9 423.6 c 4.1 -0.3 8.2 -0.6 12.3 -0.9 c 1.9 -0.1 1.9 -3.1 0 -3 c -4.1 0.3 -8.2 0.6 -12.3 0.9 C 668 420.8 668 423.8 669.9 423.6 L 669.9 423.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -66.6688 -181.95)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-733.3311, -418.05)",
    d: "M 691.8 422 c 27.7 -1.6 55.4 -3.3 83.1 -4.9 c 1.9 -0.1 1.9 -3.1 0 -3 c -27.7 1.6 -55.4 3.3 -83.1 4.9 C 689.9 419.1 689.8 422.1 691.8 422 L 691.8 422 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -125.1375 -165.9)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-674.8625, -434.1)",
    d: "M 671.5 435.6 c 2.3 0 4.5 0 6.8 0 c 1.9 0 1.9 -3 0 -3 c -2.3 0 -4.5 0 -6.8 0 C 669.5 432.6 669.5 435.6 671.5 435.6 L 671.5 435.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -109.5693 -167.4484)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-690.4307, -432.5516)",
    d: "M 686.6 434.4 c 2.7 0.2 5.4 -0.1 8 -0.8 c 1.9 -0.5 1.1 -3.4 -0.8 -2.9 c -2.4 0.6 -4.7 0.8 -7.2 0.6 C 684.7 431.3 684.7 434.3 686.6 434.4 L 686.6 434.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -49.2 -170.5009)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-750.8, -429.4991)",
    d: "M 711.2 432.3 c 26.3 -2.5 52.7 -3.2 79.2 -2.1 c 1.9 0.1 1.9 -2.9 0 -3 c -26.4 -1.1 -52.8 -0.4 -79.2 2.1 C 709.3 429.4 709.3 432.4 711.2 432.3 L 711.2 432.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -124.6979 -144.6789)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-675.3021, -455.321)",
    d: "M 675.2 450.6 c -1.7 2.1 -3.5 4.2 -5.5 6.1 c -0.8 0.8 -0.4 2.2 0.7 2.5 c 3.1 0.9 6.3 1.3 9.5 1.4 c 1.9 0 1.9 -3 0 -3 c -3 0 -5.8 -0.4 -8.7 -1.3 c 0.2 0.8 0.4 1.7 0.7 2.5 c 2 -1.9 3.8 -3.9 5.5 -6.1 C 678.5 451.2 676.3 449 675.2 450.6 L 675.2 450.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -94.1448 -146.81)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-705.8552, -453.19)",
    d: "M 685.4 456.5 c 13.6 -2.6 27.4 -3.8 41.3 -3.6 c 1.9 0 1.9 -3 0 -3 c -14.2 -0.3 -28.2 1 -42.1 3.7 C 682.8 454 683.6 456.8 685.4 456.5 L 685.4 456.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -60.6812 -148.5798)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-739.3187, -451.4202)",
    d: "M 730.8 449 c 4.9 2.5 10.8 0.8 15.5 3.5 c 0.1 -0.9 0.2 -1.8 0.4 -2.7 c -2.8 0.9 -5.3 2.2 -7.7 3.9 c -1.6 1.1 -0.1 3.7 1.5 2.6 c 2.2 -1.5 4.4 -2.7 7 -3.6 c 1.2 -0.4 1.5 -2.1 0.4 -2.7 c -4.8 -2.9 -10.6 -1 -15.5 -3.5 C 730.6 445.5 729.1 448.1 730.8 449 L 730.8 449 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.8932 -203.6946)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-861.8932, -396.3053)",
    d: "M 863.2 378.8 c -2.4 0.4 -3.9 2 -4.4 4.4 c -0.3 1.6 0.2 3.2 0.5 4.7 c 1 4.4 0.4 6.6 -3.6 9 c -1.2 0.8 -0.8 2.8 0.8 2.8 c 4.2 -0.1 2.7 19.3 11.6 12.8 c 1.6 -1.1 0.1 -3.7 -1.5 -2.6 c -4.1 2.9 -3.8 -6.6 -4 -7.6 c -0.2 -1.1 -0.5 -2.1 -1 -3 c -1.2 -1.9 -2.8 -2.7 -5.1 -2.6 c 0.3 0.9 0.5 1.9 0.8 2.8 c 2.3 -1.4 4.7 -3 5.6 -5.7 c 0.8 -2.4 -2.6 -11.4 1.2 -12.1 C 865.9 381.4 865.1 378.5 863.2 378.8 L 863.2 378.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 86.6996 -205.62)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-886.6995, -394.38)",
    d: "M 882.7 380 c 3.4 -0.5 4.7 1.5 4.1 6.2 c -0.3 0.6 -0.6 1.1 -0.9 1.7 c -0.2 1 -0.6 1.7 -0.6 2.8 c 0 2.1 1.4 2.5 2.1 4.1 c 0.6 1.5 -0.1 1.3 -0.3 3.2 c -0.6 4 4.9 7.3 -0.3 10.9 c -1.6 1.1 -0.1 3.7 1.5 2.6 c 2.2 -1.5 3.8 -3.7 3.8 -6.5 c 0 -1.1 -0.5 -2.1 -0.8 -3.1 c -0.6 -2.5 -0.2 -4.3 0.5 -6.7 c 0.1 -0.5 0 -1.1 -0.4 -1.5 c -0.3 -0.2 -1.1 -0.8 -1.4 -1.1 c -2.4 -2.4 -0.8 -3.6 0.3 -6.3 c 0.6 -1.6 1.1 -2.9 0.6 -4.6 c -0.9 -3.6 -4.7 -4.8 -8 -4.7 C 880.8 377 880.8 380 882.7 380 L 882.7 380 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.05 -207.4036)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-796.95, -392.5964)",
    d: "M 773.3 396 c 15.8 -1.3 31.5 -2.5 47.3 -3.8 c 1.9 -0.2 1.9 -3.2 0 -3 c -15.8 1.3 -31.5 2.5 -47.3 3.8 C 771.4 393.1 771.4 396.1 773.3 396 L 773.3 396 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 46.4807 -210.2008)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-846.4807, -389.7992)",
    d: "M 841.3 391.2 c 3.6 0.5 7.2 0.4 10.7 -0.2 c 1.9 -0.3 1.1 -3.2 -0.8 -2.9 c -3.3 0.5 -6.6 0.5 -9.9 0.1 C 839.4 387.9 839.4 390.9 841.3 391.2 L 841.3 391.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -79.25 -126.8)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-720.75, -473.2)",
    d: "M 681 477.3 c 26.5 -1.7 53 -3.5 79.5 -5.2 c 1.9 -0.1 1.9 -3.1 0 -3 c -26.5 1.7 -53 3.5 -79.5 5.2 C 679.1 474.4 679.1 477.4 681 477.3 L 681 477.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.2 -132.9)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-792.8, -467.1)",
    d: "M 777.7 470 c 10.1 -1 20.1 -1.9 30.2 -2.8 c 1.9 -0.2 1.9 -3.2 0 -3 c -10.1 0.8 -20.2 1.8 -30.2 2.8 C 775.8 467.2 775.8 470.2 777.7 470 L 777.7 470 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 60.2 -137.5964)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-860.2, -462.4036)",
    d: "M 830.6 466.1 c 19.7 -2 39.5 -3.5 59.2 -4.4 c 1.9 -0.1 1.9 -3.1 0 -3 c -19.8 1 -39.5 2.4 -59.2 4.4 C 828.7 463.3 828.7 466.3 830.6 466.1 L 830.6 466.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -111.71 -106.444)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-688.2901, -493.5561)",
    d: "M 692.8 487.2 c -3.7 2.6 -7.5 5.3 -11.2 7.9 c -1 0.7 -1 2.4 0.4 2.7 c 3.9 1 7.8 1.8 11.8 2.4 c 1.9 0.3 2.7 -2.6 0.8 -2.9 c -4 -0.6 -7.9 -1.4 -11.8 -2.4 c 0.1 0.9 0.2 1.8 0.4 2.7 c 3.7 -2.6 7.5 -5.3 11.2 -7.9 C 695.9 488.6 694.4 486 692.8 487.2 L 692.8 487.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -96.7284 -105.7594)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-703.2716, -494.2406)",
    d: "M 708.1 485.5 c -4.3 5 -8.3 10.2 -11.9 15.8 c -1.1 1.6 1.5 3.1 2.6 1.5 c 3.4 -5.3 7.2 -10.4 11.4 -15.2 C 711.5 486.2 709.4 484 708.1 485.5 L 708.1 485.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -79.0847 -105.9719)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-720.9153, -494.0281)",
    d: "M 717 489.8 c 1.3 1 2.7 1.5 4.1 2 c 0.9 0.3 1.8 0.5 2.7 0.8 c 0.5 0.2 1.1 0.5 1.5 0.8 c -0.1 -0.7 -0.4 -0.9 -0.9 -0.6 c -1.3 -0.1 -3.8 1.5 -5 2.1 c -1.9 0.9 -3.6 2.1 -5.3 3.3 c -1.5 1.1 0 3.7 1.5 2.6 c 2.2 -1.7 4.6 -3.1 7.2 -4.2 c 1.6 -0.7 5 -1 5.5 -3.1 c 0.4 -1.8 -1.6 -2.8 -2.9 -3.4 c -2.3 -1 -4.9 -1.3 -7 -2.8 C 717 486.1 715.5 488.7 717 489.8 L 717 489.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.2875 -108.398)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-768.7125, -491.602)",
    d: "M 750.3 494 c 12.3 -1 24.6 -2.3 36.9 -1.6 c 1.9 0.1 1.9 -2.9 0 -3 c -12.4 -0.7 -24.6 0.6 -36.9 1.6 C 748.3 491.1 748.3 494.1 750.3 494 L 750.3 494 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 48.7 -113.654)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(232,232,232)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-848.7, -486.346)",
    d: "M 813.9 489.5 c 23.1 -2.7 46.3 -3.7 69.6 -3.2 c 1.9 0 1.9 -3 0 -3 c -23.2 -0.5 -46.5 0.6 -69.6 3.2 C 812 486.7 812 489.7 813.9 489.5 L 813.9 489.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 274.2 -154.6895)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 0.16
    },
    transform: " translate(-1074.2, -445.3104)",
    d: "M 985.5 436.1 c -0.5 5 -1 10.1 -1.4 15.1 c 28.9 -0.9 60.6 -0.6 94.6 1.6 c 30.1 2 58.2 5.2 83.9 9.2 c 0.6 -6.3 1.1 -12.6 1.7 -18.9 c -11.6 -2.3 -26.9 -5 -44.9 -7.5 c -23.1 -3.2 -40.7 -4.6 -50.3 -5.3 c -24.3 -1.7 -36.7 -2.5 -53.2 -0.5 C 1003 431.5 992.6 434.1 985.5 436.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -371.25 -17.95)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.12
    },
    transform: " translate(-428.75, -582.05)",
    d: "M 379.7 474.1 c -3.3 9 -7.3 22.1 -9.2 38.2 c -2.3 19.9 -8.2 70.7 18.4 86.2 c 18.2 10.6 47.2 2.2 71.7 -17.8 c 4.2 3.4 8.5 6.7 12.7 10.1 c -24.9 15.1 -49.8 30.2 -74.7 45.3 c 17.6 10.5 35.2 20.9 52.7 31.4 c 19 -11.3 37.9 -22.5 56.9 -33.8 c 9.6 4.7 19.2 9.5 28.7 14.2 c -19.9 14 -39.7 28 -59.6 42.1 c -34.7 -17.3 -69.3 -34.6 -104 -51.9 c -17.6 -45.7 -35.2 -91.5 -52.7 -137.2 C 340.4 492.1 360.1 483.1 379.7 474.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -315.1 33.5)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-484.9, -633.5)",
    d: "M 484.9 633.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 295.3055 -98.4296)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.08
    },
    transform: " translate(-1095.3055, -501.5704)",
    d: "M 1106 422.6 c 2.4 5.7 5.3 13.9 7.1 24.1 c 0.7 4.2 6.2 37.5 -8.5 66.8 c -15.7 31.4 -51.2 51.6 -91.2 53.9 c 30.5 6.6 66.2 11.8 106.2 12.9 c 16.8 0.5 32.8 0.2 47.8 -0.7 c 4.2 -17.2 7.8 -37.7 9.2 -61.1 c 2 -33.8 -1.2 -63 -5.4 -85.5 C 1149.4 429.7 1127.7 426.1 1106 422.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 40.8579 -154.2)",
    id: "compuers"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.09
    },
    transform: " translate(-840.8579, -445.8)",
    d: "M 858 355.8 c 3.5 6.5 7.9 16.3 9.7 28.8 c 4.5 30.2 -9 54.3 -18.3 70.5 c -28 48.5 -74.7 71.8 -95.5 80.7 c 43.4 -0.3 88 -1.6 133.6 -4.3 c 10.2 -0.6 20.3 -1.2 30.4 -1.9 c 4.4 -19.4 8 -42.3 9.4 -68.2 c 2 -39.6 -2.1 -73.8 -7.4 -100.1 C 899.3 359.4 878.7 357.6 858 355.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 61.2312 415.8653)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-861.2312, -1015.8653)",
    d: "M 830 992.2 c 1 6.8 1.9 13.9 2.7 21.3 c 0.9 8.5 1.4 16.7 1.8 24.5 c 0.8 1.5 2.2 3.5 4.5 5.1 c 3.6 2.5 7.5 2.5 11.7 2.4 c 12.2 -0.3 18.3 -0.4 21 -0.9 c 9.5 -1.9 18.5 -3.6 20.4 -9.6 c 1.3 -4 -1.3 -8.4 -1.5 -8.7 c -1.5 -2.5 -3.5 -3.6 -6.9 -5.4 c -2.3 -1.3 -6.2 -3.3 -11.7 -3.9 c -4.7 -0.5 -8.6 0.2 -11.1 0.9 c -1.3 -10.6 -2.6 -21.2 -3.9 -31.7 C 848 988.2 839 990.2 830 992.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.0714 288.5285)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-835.0714, -888.5285)",
    d: "M 811.9 794.3 c -8.1 8.8 -5.6 18.2 -8.9 74.9 c -1.3 22.8 -1.8 21.7 -2.2 35.4 c -1.1 31.3 0.6 52.9 1.6 63.4 c 0.7 7.9 1.6 14.5 2.2 19.1 c 5.9 3 16 7 28.4 5.7 c 7.3 -0.7 12.8 -3.1 16.9 -4.8 c 9 -3.8 15.6 -8.8 19.8 -12.4 c -1.7 -63.1 -3.4 -126.2 -5.1 -189.3 C 829.3 779.6 816.6 789.2 811.9 794.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 4.1048 293.95)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-804.1048, -893.95)",
    d: "M 805 802.6 c -5.6 60.7 -6.3 121.8 -2.1 182.7 c 0.1 1.9 3.1 1.9 3 0 c -4.2 -60.8 -3.5 -122 2.1 -182.7 C 808.2 800.7 805.2 800.7 805 802.6 L 805 802.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 37.007 384.1376)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-837.0069, -984.1377)",
    d: "M 804.4 988.2 c 22.2 11.5 47.7 4.9 65.5 -11.4 c 1.4 -1.3 -0.7 -3.4 -2.1 -2.1 c -16.8 15.4 -40.9 21.8 -61.9 11 C 804.2 984.7 802.7 987.3 804.4 988.2 L 804.4 988.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 66.2012 281.6)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-866.2012, -881.6)",
    d: "M 862.3 788.9 c 1.6 61.8 3.2 123.6 4.8 185.4 c 0.1 1.9 3.1 1.9 3 0 c -1.6 -61.8 -3.2 -123.6 -4.8 -185.4 C 865.3 787 862.3 787 862.3 788.9 L 862.3 788.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 32.4323 411.5693)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-832.4323, -1011.5693)",
    d: "M 828.7 993.5 c 2.4 12.1 3.9 24.3 4.5 36.6 c 0.1 1.9 3.1 1.9 3 0 c -0.6 -12.6 -2.1 -25.1 -4.6 -37.4 C 831.2 990.8 828.3 991.6 828.7 993.5 L 828.7 993.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.7597 405.3807)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-858.7596, -1005.3807)",
    d: "M 855.5 986 c 0.6 13.1 1.8 26.1 3.6 39.1 c 0.3 1.9 3.2 1.1 2.9 -0.8 c -1.8 -12.7 -3 -25.5 -3.5 -38.3 C 858.4 984.1 855.4 984.1 855.5 986 L 855.5 986 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 75.939 421.5906)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-875.939, -1021.5906)",
    d: "M 860.6 1018.5 c 10.8 -1.4 21.4 1.8 29.5 9.1 c 1.4 1.3 3.6 -0.8 2.1 -2.1 c -8.7 -7.8 -20 -11.5 -31.6 -10 C 858.7 1015.7 858.7 1018.7 860.6 1018.5 L 860.6 1018.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.3347 436.446)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-863.3348, -1036.446)",
    d: "M 833.2 1029 c -0.5 6.3 -0.2 13.9 6.5 16.8 c 2.6 1.1 5.9 1.2 8.7 1.4 c 4.8 0.4 9.6 0.6 14.4 0.4 c 11.5 -0.6 33.8 -5.2 30.5 -21.3 c -0.4 -1.9 -3.3 -1.1 -2.9 0.8 c 2.9 14.2 -19.9 17.3 -29.4 17.6 c -5.1 0.2 -10.2 -0.1 -15.3 -0.7 c -9 -1.1 -10.1 -7 -9.5 -14.9 C 836.3 1027.1 833.3 1027.1 833.2 1029 L 833.2 1029 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 22.6121 291.8595)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.11
    },
    transform: " translate(-822.6122, -891.8595)",
    d: "M 807 802 c 9.8 -3.5 19.6 -7 29.4 -10.4 c -1.7 32.5 -2.1 68 -0.4 106 c 1.4 32.4 4.2 62.8 7.7 90.9 c -2 0.9 -4.2 1.7 -6.6 2.3 c -13.8 3.6 -26.1 -1 -32.1 -3.9 c -2.8 -33.3 -4.2 -70.1 -3.1 -109.9 C 802.7 850.5 804.5 825.5 807 802 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.9637 298.2)",
    id: "leg_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-815.9636, -898.2)",
    d: "M 806.2 804 c 0.4 17.5 1.5 40.2 3.9 66.5 c 1.9 20.9 4 36.5 4.6 41.4 c 2.9 21.1 7.3 48.5 14.7 80.5 c -8.4 -1.9 -16.8 -3.9 -25.1 -5.8 c -1.5 -32.1 -2.2 -66.1 -1.5 -101.8 C 803.2 856.7 804.4 829.7 806.2 804 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.7 380.8171)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-803.7, -980.8171)",
    d: "M 784.9 876.6 c 0.6 3.1 1.4 7.6 2.4 13.2 c 5.9 35.6 5.8 61.2 6.4 82.8 c 0.5 18.4 1.7 44.7 5.1 77.4 c -2.1 0.9 -5.3 2.4 -9.1 4.4 c -9.4 4.9 -22 11.5 -33.8 23.7 c -3.5 3.6 -8.4 9.2 -13.2 16.9 c 15.9 1.5 34.7 2.2 55.8 0.7 c 25.9 -1.9 48.3 -6.5 66.2 -11.5 c -5.4 -4.6 -11.4 -9.2 -17.9 -13.9 c -12.4 -8.7 -24.3 -15.6 -35.1 -21 c -2.4 -23.3 -4.3 -47.8 -5.4 -73.3 c -1.7 -39.4 -1.5 -76.5 0 -110.9 C 799.1 869 792 872.8 784.9 876.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.5 224.6229)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-799.4999, -824.6228)",
    d: "M 710.9 828 c 0 -4.6 5.3 -8.5 15.9 -16.2 c 5 -3.7 18.8 -13 41.9 -18.3 c 20.3 -4.6 35.9 -3.3 54.8 -1.7 c 26.9 2.3 39.3 7.7 42.6 9.1 c 9.8 4.4 17.2 9.6 22 13.5 c -1.7 6.1 -5.1 14.7 -12.2 22.6 c -4.9 5.6 -18.3 18.4 -55.4 21.3 C 769 862.5 710.8 844.7 710.9 828 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.7908 247.0318)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-799.2091, -847.0318)",
    d: "M 713.9 822.2 c -1.3 2.8 -2.5 5.9 -3.4 9.5 c -3.4 12.9 -1.5 24.2 0.3 31.1 c 5.4 2.5 13.1 5.6 22.6 8.4 c 29.2 8.7 53 7.5 72.3 6.4 c 25.4 -1.4 41.8 -2.6 60.8 -12.5 c 10.5 -5.5 18.3 -11.9 23.3 -16.6 c -0.3 -10.9 -0.7 -21.9 -1 -32.8 c -8.3 5.5 -17.8 10.7 -28.4 14.9 C 798.4 855.4 737 832.4 713.9 822.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -90.0517 246)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-709.9483, -846)",
    d: "M 709.2 829 c -2.1 11.3 -2 22.7 0.1 34 c 0.4 1.9 3.2 1.1 2.9 -0.8 c -2 -10.8 -2.1 -21.6 -0.1 -32.4 C 712.5 827.9 709.6 827.1 709.2 829 L 709.2 829 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.5372 262.8206)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-800.5371, -862.8206)",
    d: "M 710.2 863 c 13.5 8.7 29.8 10.9 45.4 13.2 c 16.8 2.4 33.7 3.8 50.7 2.4 c 29.1 -2.4 65 -5.2 84.9 -29.5 c 1.2 -1.5 -0.9 -3.6 -2.1 -2.1 c -9.4 11.5 -22.9 18.1 -37.1 21.8 c -15.4 4 -31.7 5.8 -47.6 6.9 c -16.7 1.2 -33.4 -0.3 -49.9 -2.7 c -14.7 -2.2 -30.1 -4.3 -42.8 -12.6 C 710.1 859.4 708.6 862 710.2 863 L 710.2 863 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 89.5021 231.6193)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-889.5021, -831.6193)",
    d: "M 887 816.2 c 1.9 10.4 2.5 20.8 1.7 31.3 c -0.1 1.9 2.9 1.9 3 0 c 0.8 -10.8 0.1 -21.5 -1.8 -32.1 C 889.6 813.5 886.7 814.3 887 816.2 L 887 816.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.4117 209.4866)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-799.5882, -809.4866)",
    d: "M 712 829.3 c 15.9 -27.4 51.5 -35.4 80.9 -37.1 c 17.4 -1 34.9 0.4 51.9 4.4 c 8.1 1.9 16.2 4.2 24 7.3 c 7.4 2.9 14.6 6.8 18.3 14.2 c 0.9 1.7 3.5 0.2 2.6 -1.5 c -7.1 -14 -26.6 -18.5 -40.5 -22 c -18.3 -4.6 -37.4 -6.4 -56.2 -5.3 c -30.4 1.8 -66.9 10.2 -83.4 38.6 C 708.4 829.4 711 830.9 712 829.3 L 712 829.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.5536 363.3)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-792.4464, -963.3)",
    d: "M 784.6 877.7 c 6.3 56.9 10.5 114 12.7 171.2 c 0.1 1.9 3.1 1.9 3 0 c -2.1 -57.2 -6.3 -114.3 -12.7 -171.2 C 787.4 875.8 784.4 875.8 784.6 877.7 L 784.6 877.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8 363.85)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-808, -963.85)",
    d: "M 803.6 877.7 c 0.2 57.5 2.1 114.9 5.8 172.3 c 0.1 1.9 3.1 1.9 3 0 c -3.7 -57.4 -5.6 -114.8 -5.8 -172.3 C 806.5 875.8 803.5 875.8 803.6 877.7 L 803.6 877.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.0215 473.0347)",
    id: "chair"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-803.0215, -1073.0347)",
    d: "M 797.1 1048 c -22.4 10.3 -41.6 26.2 -56.2 46.1 c -0.5 0.7 0 2.1 0.9 2.2 c 20.7 3.4 41.6 1.7 62.3 -0.6 c 20.2 -2.2 40.6 -4.4 60.1 -10.2 c 1 -0.3 1.6 -1.8 0.7 -2.5 c -16.2 -13.6 -33.9 -25 -52.9 -34.2 c -1.7 -0.8 -3.3 1.8 -1.5 2.6 c 18.8 9 36.3 20.3 52.3 33.7 c 0.2 -0.8 0.4 -1.7 0.7 -2.5 c -19.3 5.8 -39.4 7.9 -59.3 10.1 c -20.4 2.3 -41.1 4 -61.5 0.7 c 0.3 0.7 0.6 1.5 0.9 2.2 c 14.2 -19.5 33.2 -34.9 55.1 -45 C 800.3 1049.8 798.8 1047.2 797.1 1048 L 797.1 1048 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -113.992 207.25)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-686.008, -807.25)",
    d: "M 694.6 783.1 c 2.3 9.1 4.7 18.2 7 27.3 c -12.4 -4 -23.1 -6.1 -30.9 -7.3 c -5.6 -0.8 -29.3 -4.4 -30.9 0.6 c -0.6 1.9 2.2 4.8 2.5 5.1 c 2.3 2.3 5.1 2.5 7.6 3.1 c 5.1 1.1 6.8 3 12.1 5.6 c 8 4 25.3 10.3 44.7 13.8 c 6.6 1.2 15.2 2.4 25.6 2.8 c -4.1 -17.9 -8.3 -35.8 -12.4 -53.7 C 711.5 781.2 703 782.1 694.6 783.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -30.9532 67.081)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-769.0468, -667.081)",
    d: "M 690.7 532.6 c -4.5 1.8 -8 5.4 -13.6 16.3 c -9 17.4 -11.8 29.8 -11.8 29.8 c -8.4 37.3 -12.5 56 -14 70.5 c -4.6 46 3 48 2.7 96.3 c 0 3.6 -0.1 11.4 4.5 19 c 7.3 11.9 21.4 15.3 25.3 16.3 c 11.5 2.8 22.4 0.8 31.7 -0.9 c 2.6 -0.5 4.8 -1 6.3 -1.4 c 7.2 5.7 13.8 9.6 18.5 12.2 c 9.1 4.9 17 9.2 28 10.4 c 6.8 0.8 13.4 0.2 16.3 0 c 5 -0.4 9.1 -1.2 12.2 -1.8 c 4.7 1.6 11.9 3.4 20.8 3.6 c 5.6 0.1 24 0.2 40.2 -11.8 c 14.5 -10.7 19.5 -25.1 23.1 -35.7 c 3.4 -10.2 16.4 -48.9 -3.2 -69.6 c -17 -18 -49.3 -12.8 -75.1 -8.6 c -12.4 2 -22.6 5.1 -29.8 7.7 c -11.9 -30.8 -20.7 -55.1 -26.7 -71.9 c -5.7 -15.9 -14 -30.9 -19 -47 c -4.5 -14.4 -6.9 -25.9 -17.2 -31.7 C 709.2 533.9 699.8 528.9 690.7 532.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 40.2163 151.6292)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-840.2162, -751.6291)",
    d: "M 794.8 801.7 c 26.5 6.1 56.9 2.1 75.1 -20.1 c 9.1 -11.1 12 -24.9 14.5 -38.7 c 2.5 -14.3 3.9 -28.9 -0.7 -42.9 c -0.6 -1.8 -3.5 -1 -2.9 0.8 c 4.5 13.5 3.2 27.6 0.7 41.3 c -2.3 13.2 -5 26.7 -13.7 37.4 c -17.4 21.4 -46.7 25.1 -72.2 19.3 C 793.7 798.3 792.9 801.2 794.8 801.7 L 794.8 801.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -108.3993 56.8375)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-691.6006, -656.8375)",
    d: "M 735.1 585 c -1.4 -13.4 -4.9 -27.2 -11.6 -39 c -5 -8.7 -13 -17 -23.8 -16.5 c -11.4 0.5 -19.8 9.7 -24.5 19.2 c -6.4 12.6 -10.4 26.9 -14.1 40.4 c -7.6 27.7 -11.9 56.4 -12.8 85.1 c -0.5 15.2 -0.1 30.5 1.2 45.7 c 1.2 13.7 2.2 28.6 6.1 41.8 c 3.3 11.3 18.4 18 28.9 20.7 c 12.6 3.2 25.7 2.1 37.5 -3.1 c 1.8 -0.8 0.2 -3.4 -1.5 -2.6 c -10.6 4.7 -22.5 5.7 -33.8 3.2 c -9.9 -2.2 -25 -8.3 -28.2 -18.9 c -1.7 -5.7 -2.3 -11.9 -3.2 -17.8 c -1.1 -7.1 -1.9 -14.2 -2.6 -21.4 c -1.1 -12.1 -1.7 -24.3 -1.6 -36.5 c 0.1 -25.5 2.8 -50.9 8.2 -75.8 c 2.6 -11.9 5.7 -23.7 9.5 -35.3 c 3.8 -11.6 7.4 -25.3 16.1 -34.3 c 4.9 -5 11.9 -8.5 19 -7.2 c 6.8 1.3 12 6.6 15.6 12.2 c 7.6 11.6 11.3 26.3 12.8 40 C 732.3 586.9 735.3 587 735.1 585 L 735.1 585 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -55.0795 108.1727)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-744.9205, -708.1727)",
    d: "M 682.9 614.8 c -3.4 36.5 0.4 73.6 11.2 108.7 c 5.2 16.8 11.3 35.4 21.9 49.7 c 9.4 12.7 24.1 21.1 39 25.8 c 17.2 5.5 36.1 5.8 52.4 -2.5 c 1.7 -0.9 0.2 -3.5 -1.5 -2.6 c -14.9 7.6 -32 7.6 -47.7 3 c -16.1 -4.7 -32.2 -13.9 -41.6 -28.1 c -9.2 -14 -15 -30.9 -19.8 -46.9 c -5 -16.3 -8.5 -33.1 -10.4 -50.1 c -2.1 -18.9 -2.2 -38 -0.5 -56.9 C 686.1 612.9 683.1 612.9 682.9 614.8 L 682.9 614.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -119.2223 23.3807)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-680.7776, -623.3807)",
    d: "M 676.4 604.2 c 0.6 13.1 2.5 26 5.8 38.7 c 0.5 1.9 3.4 1.1 2.9 -0.8 c -3.3 -12.4 -5.2 -25.1 -5.7 -37.9 C 679.3 602.3 676.3 602.3 676.4 604.2 L 676.4 604.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -40.5285 53.85)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-759.4715, -653.85)",
    d: "M 733 585.2 c 18.9 45.1 35.6 91.2 50.1 138 c 0.6 1.8 3.5 1.1 2.9 -0.8 c -14.4 -46.8 -31.1 -92.8 -50.1 -138 C 735.1 582.7 732.2 583.5 733 585.2 L 733 585.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -101.8618 197.6859)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-698.1382, -797.6859)",
    d: "M 692.8 784.5 c 2.6 9 5.2 18 7.8 27.1 c 0.5 1.9 3.4 1.1 2.9 -0.8 c -2.6 -9 -5.2 -18 -7.8 -27.1 C 695.1 781.9 692.2 782.7 692.8 784.5 L 692.8 784.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.0504 217.7831)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-684.9497, -817.7831)",
    d: "M 701.8 809.8 c -20 -7.9 -41.5 -10.6 -62.9 -7.8 c -0.8 0.1 -1.9 0.9 -1.4 1.9 c 2.6 6.4 9.9 8.3 15.7 10.8 c 8.3 3.6 16.6 7.1 25.1 10.1 c 17 6.1 34.7 10.3 52.8 9.8 c 1.9 0 1.9 -3 0 -3 c -16 0.4 -31.7 -2.8 -46.8 -7.9 c -7.3 -2.4 -14.4 -5.2 -21.5 -8.2 c -3.8 -1.6 -7.7 -3.2 -11.5 -4.9 c -3.9 -1.7 -9.2 -3.3 -11 -7.6 c -0.5 0.6 -1 1.3 -1.4 1.9 c 21.1 -2.8 42.3 -0.1 62.1 7.7 C 702.8 813.4 703.5 810.5 701.8 809.8 L 701.8 809.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -74.4036 206.15)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-725.5964, -806.15)",
    d: "M 718 779.1 c 2.1 18.5 10.9 35.5 12.2 54.1 c 0.1 1.9 3.1 1.9 3 0 c -1.3 -18.6 -10.1 -35.6 -12.2 -54.1 C 720.8 777.2 717.8 777.2 718 779.1 L 718 779.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -26.0919 90.9707)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-773.9081, -690.9707)",
    d: "M 688.6 780 c -3.4 -8.7 -8.1 -21.7 -12.6 -37.7 c -1.9 -6.9 -14.1 -52 -11.5 -110.4 c 0.7 -15.3 2.4 -32.2 14.6 -44.5 c 4.7 -4.7 10 -10 14.6 -8.9 c 19.2 4.5 -15.3 106.5 33 161.6 c 24.8 28.3 60.6 31.9 66.4 32.4 c 51.4 4.6 86.1 -32.3 90.5 -37.1 c 0.3 6.1 -0.1 15.6 -4.2 26.2 c -7.4 19.2 -21.8 29.1 -27.2 32.4 c -24.9 15.2 -51 8.1 -55.4 6.8 c -7.2 1.1 -16.8 1.7 -27.7 0 c -24.6 -3.8 -41.2 -16.8 -48.6 -23.5 c -3.1 1.7 -9 4.3 -16.7 4.7 C 697.1 782.5 691.8 781.1 688.6 780 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -67.4442 102.6359)",
    id: "leg_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.13
    },
    transform: " translate(-732.5559, -702.6358)",
    d: "M 680.2 603.2 c 1.3 -0.1 1.8 11.7 8.4 50.2 c 7.7 45.5 11.6 68.2 17.3 81.1 c 7.2 16.4 25.8 45.8 81.6 67.5 c -8 0.3 -21.3 -0.1 -36.6 -5.8 c -14.4 -5.3 -24.5 -13.1 -30.3 -18.3 c -6.3 1.4 -12.6 2.8 -18.8 4.2 c -3.8 -11.4 -8.5 -26.9 -12.6 -45.5 C 673.6 666.5 677.3 603.4 680.2 603.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.9246 -9.7387)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-648.0754, -590.2613)",
    d: "M 548.1 562.6 c -0.5 2.1 2.6 4.9 5.1 6.1 c 4.1 2 8 0.3 8.6 0 c 0 0 9.2 -1 17.7 4 c 2.6 1.5 5 4.7 9.6 11.1 c 8.5 11.6 9.6 15.5 15.2 19.2 c 3.9 2.6 7.7 3.6 10.1 4 c 2.4 2.7 6.1 6.9 10.6 12.1 c 16.1 18.8 17.2 22.2 24.8 28.8 c 8.2 7.2 18.1 16 29.8 14.7 c 6.2 -0.7 11.2 -4.1 19.2 -12.1 c 16.6 -16.7 28.1 -35.1 38.4 -56.1 c 11.1 -22.6 13.6 -33.6 14.7 -38.9 c 0.6 -3.3 6.5 -33.1 -2 -36.9 c -3.3 -1.5 -7.6 1.4 -14.1 6.6 c -23.5 18.8 -37.4 38.5 -38.4 39.9 c -7.4 10.7 -16.7 25.5 -25.8 44.5 c -14.3 -7.4 -28.6 -14.8 -42.9 -22.2 c -0.9 -1.9 -2 -4.9 -2 -8.6 c 0 -6.1 3.1 -8.4 5.1 -15.2 c 2.1 -7 2.4 -16.6 -1 -18.2 c -2.4 -1.1 -7 1.6 -9.1 5.1 c -2.2 3.6 -0.9 6.8 -3 8.1 c -2.7 1.7 -7.6 -1.7 -8.1 -2 c -5.4 -3.8 -4.9 -8.5 -9.1 -16.2 c -4.5 -8.3 -10.5 -12.9 -14.1 -15.7 c -5 -3.8 -10.6 -8.1 -16.2 -6.6 c -0.9 0.2 -4.6 1.3 -5.9 4.6 c -0.6 1.6 -0.4 3.1 -0.2 4 c -0.4 -0.3 -4 -2.5 -8 -1 c -2.8 1 -5.1 3.6 -5.6 6.6 c -0.2 1.3 0 2.4 0.2 3.2 c -0.5 -0.2 -4.8 -1.3 -7.8 1.3 c -0.5 0.4 -2.2 1.9 -2.2 4 c 0 1.7 1.2 3.1 3.3 4.8 c 4.5 3.7 7.9 4.6 12.1 6.9 c 2.1 1.1 4.9 3 8.1 5.9 C 559.7 558.4 548.9 558.9 548.1 562.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -91.8387 -35.1554)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-708.1613, -564.8446)",
    d: "M 672.8 610.1 c 17.5 -34.1 36.8 -70.6 72.7 -88.5 c 1.7 -0.9 0.2 -3.4 -1.5 -2.6 c -36.3 18 -56 55 -73.7 89.5 C 669.3 610.3 671.9 611.8 672.8 610.1 L 672.8 610.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -146.4611 2.1479)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-653.5388, -602.148)",
    d: "M 628.7 589.3 c 15.4 10.3 34.6 14.6 47.8 28.1 c 1.4 1.4 3.5 -0.7 2.1 -2.1 c -13.4 -13.7 -32.8 -18.1 -48.4 -28.6 C 628.6 585.6 627.1 588.2 628.7 589.3 L 628.7 589.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -115.6126 7.2906)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-684.3873, -607.2906)",
    d: "M 616.2 609.1 c 7.3 12.6 16.4 24.1 26.9 34.1 c 9.4 8.9 21.7 20.3 35.5 20.6 c 12.6 0.3 21.2 -10.2 27.9 -19.5 c 10 -13.9 19.2 -28.3 27.8 -43.1 c 8.8 -15.1 18.1 -31.1 18.5 -49 c 0 -1.9 -3 -1.9 -3 0 c -0.4 19.2 -11.4 36.4 -21 52.4 c -9.2 15.5 -18.7 32 -30.6 45.5 c -5.5 6.3 -12.6 11.5 -21.3 10.6 c -9.7 -1 -18.3 -8 -25.5 -14.1 c -13.1 -11 -24 -24.3 -32.7 -39 C 617.8 605.9 615.2 607.4 616.2 609.1 L 616.2 609.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -216.4215 -16.3814)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-583.5786, -583.6186)",
    d: "M 618.9 607.2 c -4 -1.9 -8.6 -2.5 -12.5 -4.7 c -4 -2.3 -6.8 -6.2 -9.4 -10 c -4.6 -6.8 -8.8 -13.9 -15.3 -19.1 c -3 -2.4 -6.5 -4.4 -10.3 -5.4 c -4.2 -1.2 -8 -0.5 -12.3 -0.3 c -2.7 0.1 -8.3 0.2 -8.5 -3.9 c -0.3 -4 5.3 -3.4 7.6 -3.5 c 5.1 -0.3 10 0 14.7 2 c 1.8 0.7 2.6 -2.2 0.8 -2.9 c -5.6 -2.3 -11.3 -2.4 -17.3 -2 c -2.9 0.2 -6.7 0.2 -8.3 3.1 c -1.4 2.5 -0.3 5.7 1.6 7.7 c 3.2 3.4 8 2.7 12.2 2.3 c 15 -1.5 23.9 10.5 31.3 21.8 c 2.6 4 5.3 8 9 11 c 4.5 3.6 10.1 4.1 15.1 6.6 C 619.1 610.6 620.7 608 618.9 607.2 L 618.9 607.2 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -175.1119 -32.4643)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-624.8881, -567.5358)",
    d: "M 630.9 587.9 c -5.4 -6.3 -0.4 -16.1 1.5 -22.9 c 1.4 -4.9 3.4 -11.7 0.8 -16.6 c -1.5 -2.9 -4.8 -4.7 -8 -3.5 c -1.8 0.7 -3.2 2.1 -4.2 3.7 c -1.4 2.3 -1.8 8.6 -4.6 9.3 c -1.9 0.4 -1.1 3.3 0.8 2.9 c 3.4 -0.8 4.1 -4.2 5.1 -7.1 c 0.5 -1.5 1.5 -5.4 3.4 -5.7 c 1.8 1 3.6 2 5.4 3 c 0.1 0.9 0.2 1.7 0.4 2.6 c 0.2 3.6 -0.9 7.3 -1.8 10.7 c -2.4 8.1 -7.1 18.3 -0.8 25.8 C 630 591.5 632.1 589.3 630.9 587.9 L 630.9 587.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -239.1995 -56.0408)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-560.8005, -543.9592)",
    d: "M 549.7 547 c -1.5 -0.8 -3.1 -1.7 -4.3 -2.8 c -1.7 -0.9 -2 -2.2 -0.9 -3.8 c -0.1 -2.3 1.1 -3.1 3.5 -2.7 c 4.5 -0.3 8.4 1.9 12.3 3.7 c 6.7 3.2 13.1 6.6 18.7 11.5 c 1.4 1.3 3.6 -0.8 2.1 -2.1 c -4.9 -4.3 -10.4 -7.6 -16.2 -10.5 c -5.5 -2.8 -11.4 -6.3 -17.8 -5.6 c -3.3 0.4 -7.2 1.6 -7.1 5.5 c 0.1 4.5 4.7 7.3 8.1 9.3 C 549.8 550.5 551.3 547.9 549.7 547 L 549.7 547 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -230.6748 -64.3356)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-569.3252, -535.6643)",
    d: "M 553.6 534.9 c -5.3 -4 1.6 -6.7 3.7 -7.1 c 2 -0.3 4 0.2 5.9 0.8 c 3.2 1.1 6.1 3 8.9 4.9 c 5.4 3.7 10.3 8 14.9 12.7 c 1.4 1.4 3.5 -0.7 2.1 -2.1 c -7.5 -7.6 -18.3 -18.4 -29.6 -19.4 c -7.1 -0.6 -14.8 7.1 -7.4 12.7 C 553.6 538.7 555.1 536.1 553.6 534.9 L 553.6 534.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -218.4527 -71.5917)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-581.5473, -528.4083)",
    d: "M 566.6 525.9 c -3.6 -4.5 4.5 -6.1 6.9 -5.7 c 1 0.2 1.9 0.5 2.9 0.8 c 3.2 1.1 6.1 2.9 8.7 5 c 4.7 3.7 8.6 8.4 12.2 13.2 c 1.2 1.5 3.8 0 2.6 -1.5 c -6.3 -8.3 -13.7 -17 -24.2 -20 c -3.5 -1 -8.1 -1.3 -10.9 1.6 c -2.5 2.6 -2.5 6.1 -0.3 8.7 C 565.7 529.5 567.8 527.4 566.6 525.9 L 566.6 525.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -192.186 -51.9782)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-607.814, -548.0218)",
    d: "M 596.3 537.1 c 3.7 6.3 7 13 11.2 19 c 2.6 3.7 6.4 6.4 11 4.5 c 1.8 -0.7 1 -3.6 -0.8 -2.9 c -6.1 2.4 -9.3 -6 -11.7 -10.1 c -2.4 -4 -4.7 -8.1 -7.1 -12.1 C 598 533.9 595.4 535.4 596.3 537.1 L 596.3 537.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -243.6 -47.3796)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-556.4, -552.6204)",
    d: "M 547.2 548.4 c 5.6 3.7 11.3 7.3 16.9 11 c 1.6 1.1 3.1 -1.5 1.5 -2.6 c -5.6 -3.7 -11.3 -7.3 -16.9 -11 C 547.1 544.8 545.6 547.4 547.2 548.4 L 547.2 548.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -151.6729 -2.6371)",
    id: "hand_left"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.12
    },
    transform: " translate(-648.3271, -597.3629)",
    d: "M 544.2 538.5 c 4 -1.9 10.1 3.4 13.9 6.5 c 18.5 15.1 19.4 9.8 30 20.7 c 10.8 11 10.5 17 21.3 23.6 c 5.1 3.1 9.9 4.7 13.2 5.5 c 1.9 2.7 4.7 6.7 8.4 11.3 c 13.3 16.7 20.2 25.4 31 29.4 c 0.9 0.3 18.2 6.5 32.6 -1.9 c 11.5 -6.7 11.5 -17.4 24.9 -52.3 c 16.9 -44 23.7 -49.5 28.1 -49.1 c 2.6 0.2 5 2.6 6.1 4.5 c 2.3 3.9 0.5 8.1 -1.9 17.8 c -2.3 9.2 -1.8 9.6 -3.2 15.2 c -3.9 14.8 -10.9 23 -30.7 56.5 c -3.2 5.3 -7.5 12.7 -14.9 21.3 c -6.3 7.4 -10.3 11.8 -16.5 13.9 c -10.4 3.5 -20.6 -1.9 -25.5 -4.5 c -6.6 -3.5 -11.3 -7.8 -18.7 -16.5 c -6.9 -8 -15.7 -19.3 -24.9 -33.9 c -2.1 0 -5.4 -0.4 -9 -1.9 c -3.1 -1.4 -7.1 -3.9 -16.8 -17.8 c -6.9 -9.9 -6.8 -11.3 -10.3 -13.6 c -5.5 -3.6 -12.3 -4.2 -15.8 -4.5 c -8.1 -0.8 -12.4 0.9 -14.5 -1.9 c -1.3 -1.8 -1.4 -4.8 0 -6.5 c 3.4 -4.2 15 1 15.5 -0.3 c 0.3 -0.9 -4.3 -3.3 -12.3 -8.1 c -9.5 -5.7 -12.5 -7.9 -12.3 -10.3 C 542 540.1 543.1 539 544.2 538.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 85.5886 -34.4926)",
    id: "hand_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-885.5886, -565.5073)",
    d: "M 872.5 500.4 c -5.4 1.1 -7.5 11.2 -9.6 20.7 c -2.6 12.2 -2.8 22.5 -2.5 30.3 c 0.7 21.5 5.3 42 11.1 54.1 c 3.1 6.5 5 7.3 8.6 15.7 c 1.2 2.8 2.1 5.2 4.5 7.1 c 4.6 3.5 10.6 2.2 11.1 2 c 6.2 -1.5 9.5 -6.9 11.1 -9.6 c 4.5 -7.7 4.6 -15.6 3.5 -29.3 c -1.6 -20.7 -2.4 -31 -5.6 -41.9 c -2.8 -9.7 -7.5 -21.9 -16.2 -34.4 C 883.3 507.3 877.7 499.4 872.5 500.4 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 85.5404 -33.4414)",
    id: "hand_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-885.5404, -566.5586)",
    d: "M 872.6 503.1 c 5.4 -0.6 9.3 6 12.1 9.9 c 2.5 3.5 4.8 7.2 7 10.9 c 4.3 7.7 7.8 15.8 10.4 24.2 c 5.2 16.6 7.4 34 7.2 51.4 c -0.1 9 0 20.8 -7.6 27.2 c -3.5 2.9 -8.8 4.7 -13.1 2.6 c -4.5 -2.2 -7.1 -8.2 -9.4 -12.3 c -9.2 -16.6 -15 -35 -17 -53.9 c -2.2 -20.5 -0.7 -43 10.6 -60.7 c 1 -1.6 -1.6 -3.1 -2.6 -1.5 c -11.6 18.2 -13.2 41.3 -11 62.2 c 2.2 21.6 9.3 43.1 21 61.4 c 4.3 6.7 10.3 10.7 18.3 7.6 c 8.3 -3.2 12 -11.5 13.1 -19.8 c 2.8 -19.6 0.1 -41.3 -5.2 -60.3 c -3.1 -11.1 -7.5 -21.8 -13.3 -31.8 c -2.8 -4.8 -6 -9.4 -9.4 -13.7 c -2.9 -3.6 -6.1 -7 -11 -6.5 C 870.7 500.3 870.7 503.3 872.6 503.1 L 872.6 503.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 80.275 -33.8007)",
    id: "hand_right"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.11
    },
    transform: " translate(-880.275, -566.1993)",
    d: "M 875.7 503 c -2.6 12.7 -3.9 27.4 -2.3 43.6 c 1.6 15.5 5.4 26.9 10.3 41.7 c 3.9 11.7 9.3 25.5 16.8 40.7 c -2.1 1.3 -5.4 2.8 -9 2.3 c -7.3 -1.1 -11.6 -9.6 -14.5 -16.2 c -10.6 -23.6 -15.9 -35.4 -16.8 -55.6 c -1.3 -27.7 6.1 -58.4 12.6 -58.5 C 874 501 875 502.1 875.7 503 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.0786 9.4169)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(236,97,91)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-815.0787, -609.4169)",
    d: "M 735.1 520.1 c -0.5 4.3 -1 10.4 -1.5 17.7 c -0.4 5.5 -1.4 21.6 -1 36.9 c 0.9 30.2 7.5 54.2 11.6 68.7 c 3.7 13 7.6 23.7 10.6 31.3 c 0.3 2.9 1 7 2.5 11.6 c 7.2 21.6 25.8 32.3 30.3 34.9 c 22.5 12.6 44.9 8 51.5 6.6 c 6.6 -1.5 27.9 -6.4 41.9 -25.3 c 4.6 -6.1 8.7 -14.1 12.6 -35.4 c 1.8 -9.9 6 -35.9 3 -80.3 c -3.1 -45.2 -10.4 -62.2 -14.7 -70.7 c -3.8 -7.7 -7.8 -13.7 -10.6 -17.7 c -23.3 -9.6 -42.7 -9.8 -53.6 -9.1 c -18.3 1.2 -32.3 6.7 -46 12.1 C 756.2 507.6 743.8 514.6 735.1 520.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -55.6745 0.3529)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-744.3255, -600.3529)",
    d: "M 733 522.8 c -7.4 52.8 0.5 106.9 22.6 155.4 c 0.8 1.8 3.4 0.2 2.6 -1.5 c -21.8 -47.7 -29.6 -101.2 -22.3 -153.1 C 736.1 521.7 733.2 520.9 733 522.8 L 733 522.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 21.9939 99.8276)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-821.9939, -699.8276)",
    d: "M 751.5 670.8 c 3.6 25.1 21.7 46.8 45.5 55.5 c 25.4 9.3 55.9 3.8 76.2 -14 c 10.6 -9.2 17.9 -21.6 19.3 -35.7 c 0.2 -1.9 -2.8 -1.9 -3 0 c -3.3 33.7 -40.6 52.8 -71.4 50.9 c -31.8 -1.9 -59.2 -25.8 -63.7 -57.6 C 754.1 668.1 751.2 668.9 751.5 670.8 L 751.5 670.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.3969 -94.2665)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-802.3969, -505.7334)",
    d: "M 734.8 522.8 c 39.7 -25 89.4 -42.7 135.1 -23 c 1.8 0.8 3.3 -1.8 1.5 -2.6 c -46.8 -20.2 -97.4 -2.7 -138.2 23 C 731.7 521.3 733.2 523.9 734.8 522.8 L 734.8 522.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 84.2915 -11.1114)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-884.2915, -588.8887)",
    d: "M 869.9 499.5 c 10.8 9.9 15 26.5 18.1 40.4 c 3.4 15.2 5.4 30.8 6.7 46.4 c 2.6 30.9 1.7 62.1 -4.5 92.6 c -0.4 1.9 2.5 2.7 2.9 0.8 c 6.6 -32 7.4 -64.7 4.3 -97.2 c -1.5 -15.7 -3.5 -31.6 -7.3 -47 c -3.3 -13.2 -7.7 -28.6 -18 -38.1 C 870.6 496.1 868.5 498.2 869.9 499.5 L 869.9 499.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.8389 96.7261)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-792.161, -696.7261)",
    d: "M 769.2 687.6 c 12.6 11.5 28.1 18.7 45 20.8 c 1.9 0.2 1.9 -2.8 0 -3 c -16.1 -2 -31 -9 -42.9 -20 C 769.9 684.2 767.7 686.3 769.2 687.6 L 769.2 687.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.3824 9.3719)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.15
    },
    transform: " translate(-855.3824, -609.3719)",
    d: "M 814.5 490.5 c 3.7 5.8 7.5 11.7 11.2 17.5 c 7.7 18.7 17.2 46 23.1 80.2 c 2.9 17.1 5.7 33.1 4.7 53.1 c -0.9 18 -5.5 50.6 -28.7 88.3 c 5.1 -0.1 12.5 -0.7 20.9 -3.4 c 3.5 -1.1 29.3 -9.8 41.8 -34.3 c 5.2 -10.2 6.1 -19.3 6.9 -30.3 c 4.2 -59 0.3 -97.1 -1.9 -110.2 c -1.8 -10.8 -4.4 -23.3 -11.5 -37.5 c -3.7 -7.3 -7.6 -12.9 -10.3 -16.5 c -6.9 -3 -17.2 -6.5 -30 -7.8 C 830.2 488.6 821.2 489.4 814.5 490.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.4605 24.2992)",
    id: "torso"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.11
    },
    transform: " translate(-869.4605, -624.2992)",
    d: "M 882.9 522.1 c -3.6 0.2 -5.4 21.9 -6.6 36.5 c -2.7 33.4 -0.7 57.5 -0.3 66.2 c 1.1 23.4 -4.4 57.2 -34 101.7 c 4.7 -1.2 11.7 -3.5 19.4 -7.8 c 6.6 -3.7 16 -9 22.8 -20 c 2.3 -3.8 5.9 -10.7 7.2 -20.6 c 3.2 -18.4 6.4 -44.8 5.3 -76.5 C 895.2 564 887.9 521.8 882.9 522.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -59.4168 118.8813)",
    id: "chair_support"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-740.5832, -718.8813)",
    d: "M 738.2 596.6 c 5.6 81.5 0.9 163.2 -3.8 244.6 c -0.2 3.9 5.8 3.8 6 0 c 4.8 -81.4 9.4 -163.1 3.8 -244.6 C 743.9 592.7 737.9 592.7 738.2 596.6 L 738.2 596.6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 25.55 28.0432)",
    id: "chair_support"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 2,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-825.55, -628.0432)",
    d: "M 740.3 592.9 c 29.5 1.2 61.8 1.1 96.6 -1.1 c 26.3 -1.6 51 -4.3 73.9 -7.6 c -0.5 25.4 -1.1 50.7 -1.6 76.1 c -25.3 5 -54.6 9.1 -87.4 10.8 c -29 1.5 -55.5 0.7 -78.8 -1.1 C 742.1 644.3 741.2 618.6 740.3 592.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 98.15 116.2)",
    id: "chair_support"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-898.15, -716.2)",
    d: "M 906.2 601 c -7.4 76.8 -14.7 153.6 -22.1 230.4 c -0.4 3.8 5.6 3.8 6 0 c 7.4 -76.8 14.7 -153.6 22.1 -230.4 C 912.6 597.2 906.6 597.2 906.2 601 L 906.2 601 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -34.9118 -135.6027)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-765.0882, -464.3973)",
    d: "M 725.8 432.8 c -0.7 2 0 5.9 0.8 10.9 c 0.2 1.4 0.8 4.2 2.2 8.9 c 2.5 8.2 5.4 14.2 6.1 15.6 c 7.1 14.4 15.9 23.7 18.4 26.2 c 4.2 4.2 8.1 7.4 10.9 9.5 c 8.7 -3.5 17.4 -7.1 26.2 -10.6 c 3.1 -2.3 7.9 -6.5 11.1 -13.4 c 5.8 -12.5 2.7 -26.2 -1.9 -34.2 C 783.5 417.6 729.3 423 725.8 432.8 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -54.7757 -127.7884)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-745.2243, -472.2116)",
    d: "M 724.2 440.9 c 3 13.5 8 26.5 15.2 38.4 c 3.4 5.6 7.3 10.9 11.5 15.9 c 3.7 4.4 7.6 8.7 13.5 10.1 c 1.9 0.4 2.7 -2.5 0.8 -2.9 c -6.2 -1.4 -10.4 -7.1 -14.3 -11.9 c -4 -4.9 -7.5 -10.2 -10.6 -15.6 c -6.2 -10.9 -10.6 -22.6 -13.2 -34.8 C 726.7 438.3 723.8 439.1 724.2 440.9 L 724.2 440.9 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -45.3967 -130.5945)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(22,22,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-754.6032, -469.4055)",
    d: "M 746.8 465.5 c -0.4 -8.7 10 -6 13.4 -1.5 c 4 5.2 2.9 16.4 -5.9 14.9 c -1.9 -0.3 -2.7 2.6 -0.8 2.9 c 11.3 1.9 15.1 -11.9 9.1 -19.7 c -5.2 -6.8 -19.4 -8.3 -18.8 3.3 C 743.9 467.4 746.9 467.4 746.8 465.5 L 746.8 465.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.0737 -160.0229)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(82,34,208)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-781.9263, -439.977)",
    d: "M 724.7 438.7 c -1.3 -4.6 -3.5 -12 0.4 -19.3 c 3.4 -6.2 9.3 -8.8 11.7 -9.6 c -0.1 -1.4 -0.4 -9.2 5.6 -15.7 c 6.1 -6.5 13.9 -6.8 15.3 -6.8 c 2.5 -1.9 6.1 -4.3 10.9 -6 c 1.7 -0.6 9.6 -3.4 18.9 -2 c 12.8 1.9 15 9.6 29.3 15.7 c 4.8 2 12.4 4.5 22.9 4.8 c -2.5 2.9 -5.1 5.9 -7.6 8.8 c 1.9 2.1 4.5 5.4 6.4 10 c 1 2.3 2.8 7.6 2.4 17.7 c -0.4 9.8 -2.8 17.7 -4.8 24.5 c -3.6 11.8 -5.7 15.3 -3.6 20.1 c 2.3 5.4 7.8 6.9 7.1 9.2 c -0.8 2.5 -7.8 2.8 -12.7 2.2 c -7.3 -0.9 -11.9 -4.1 -12.7 -3 c -1 1.3 5.9 5.9 4.8 8.9 c -1.3 3.9 -14.4 3.3 -23.8 1.1 c -3.2 -0.7 -8.8 -2.4 -15.4 -6.1 c -8.4 -4.7 -14 -10.5 -17.3 -14.5 c 2.5 -5.6 2.2 -11.8 -1.2 -16.1 c -0.3 -0.4 -5.3 -6.5 -11.3 -4.8 c -3.3 1 -5.1 3.9 -5.6 4.8 C 740.1 460.2 728.8 452.7 724.7 438.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -37.3196 -179.2)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.24
    },
    transform: " translate(-762.6803, -420.8)",
    d: "M 737 410.5 c 2.1 6.3 15.8 5.1 26 8.5 c 7.3 2.4 17 8.7 25.7 26.1 c -2.4 -7.8 -13.5 -40 -39.9 -47.2 c -2.5 -0.7 -5.2 -1.2 -8.3 -1.4 c -1 1.2 -3 4 -3.6 7.9 C 736.9 404.9 736.3 408.3 737 410.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.2 -203.4915)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.17
    },
    transform: " translate(-798.8, -396.5085)",
    d: "M 758.3 386.7 c 1.8 -1.4 4.4 -3.2 7.7 -4.6 c 2.6 -1.1 5 -1.7 6.9 -2.1 c 5.2 4.5 13.1 10.3 23.8 14.6 c 18.1 7.3 34.3 6.4 42.6 5.3 c -1.3 2.4 -3.6 5.8 -7.4 8.5 c -13.9 9.9 -34.7 1.4 -44.6 -2.6 C 780.4 403 769.4 397.5 758.3 386.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 15.6563 -126.2088)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.14
    },
    transform: " translate(-815.6563, -473.7913)",
    d: "M 807.5 455.5 c -1.6 0.5 0.5 11.8 1.2 15.2 c 1.6 7.8 4.1 14.1 6.2 18.3 c 3.2 1 6.4 2.1 9.5 3.1 C 812.6 461.4 808.8 455.1 807.5 455.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.3555 -121.5113)",
    id: "head"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(76,76,76)",
      fillRule: "nonzero",
      opacity: 0.12
    },
    transform: " translate(-768.6444, -478.4886)",
    d: "M 760.2 467.6 c 0.3 2.5 0.5 4.8 -0.8 6.7 c -1.6 2.3 -4.1 1.9 -6.3 5.2 c -0.8 1.2 -0.8 1.8 -0.6 2.1 c 0.5 0.9 2.6 0.5 3.6 0.5 c 5.2 0.2 8.3 5.5 11.9 8.6 c 2.9 2.6 7.9 5.3 16.9 5.5 c -4.4 -2.4 -9.5 -5.6 -14.7 -9.9 c -2.9 -2.4 -5.5 -4.9 -7.7 -7.2 c 1 -2.2 2.8 -7.1 0.9 -12.1 c -1.4 -3.8 -4.6 -6.5 -5 -6.2 C 757.9 461.1 759.7 463.4 760.2 467.6 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1332 -0.0691 0.0668 0.1288 261.7046 457.6137)",
    id: 271669
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.7333 -65.3752)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(52,122,180)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-190.2666, -190.6247)",
    d: "M 194.005 240.252 h 105.054 c 29.216 0 52.529 -24.101 52.529 -53.414 V 86.603 c 0 -28.525 -24.002 -49.871 -52.529 -54.691 c -35.214 -5.804 -73.479 -5.509 -105.054 0.097 c -44.462 7.87 -52.527 24.298 -52.527 54.693 v 21.453 H 246.63 v 31.959 H 102.032 c -30.591 0 -57.349 18.394 -65.709 53.315 c -9.64 40.035 -10.032 65.02 0 106.826 c 7.477 31.085 25.28 53.314 55.872 53.314 h 36.101 v -48.001 C 128.296 270.845 158.298 240.252 194.005 240.252 L 194.005 240.252 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -65.7095 -65.375)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(39,92,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-190.2904, -190.625)",
    d: "M 128.296 363.569 H 92.195 c -32.842 0 -56.137 -21.655 -65.595 -60.976 c -10.146 -42.276 -10.145 -69.37 0 -111.505 c 4.521 -18.885 14.243 -34.559 28.112 -45.314 c 13.21 -10.245 29.573 -15.66 47.319 -15.66 H 236.63 v -11.959 h -95.152 c -5.523 0 -10 -4.477 -10 -10 V 86.702 c 0 -13.954 1.423 -29.889 11.979 -42.278 c 9.452 -11.094 24.504 -17.96 48.806 -22.261 c 16.512 -2.932 35.127 -4.482 53.829 -4.482 c 18.655 0 37.023 1.469 54.594 4.365 c 16.345 2.762 31.383 10.299 42.385 21.229 c 11.941 11.865 18.519 27.253 18.519 43.329 v 100.235 c 0 34.967 -28.051 63.414 -62.529 63.414 H 194.005 c -29.677 0 -55.709 25.849 -55.709 55.316 v 48.001 C 138.296 359.092 133.819 363.569 128.296 363.569 z M 102.032 150.114 c -28.213 0 -49.142 17.063 -55.984 45.643 c -9.526 39.563 -9.525 62.475 -0.001 102.165 c 5.008 20.821 17.081 45.647 46.148 45.647 h 26.101 v -38.001 c 0 -19.263 8.159 -38.487 22.386 -52.743 c 14.527 -14.557 33.464 -22.573 53.323 -22.573 h 105.054 c 23.451 0 42.529 -19.476 42.529 -43.414 V 86.603 c 0 -24.529 -22.233 -41.12 -44.195 -44.831 c -16.46 -2.713 -33.733 -4.092 -51.302 -4.092 c -17.549 0 -34.956 1.444 -50.337 4.175 c -39.908 7.064 -44.275 19.689 -44.275 44.847 v 11.453 h 95.152 c 5.523 0 10 4.477 10 10 v 31.959 c 0 5.523 -4.477 10 -10 10 H 102.032 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 65.3833 64.1885)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,202,29)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-321.3833, -320.1885)",
    d: "M 474.975 209.372 c -7.575 -30.395 -21.935 -53.315 -52.527 -53.315 h -39.443 v 46.626 c 0 36.199 -30.692 66.691 -65.71 66.691 H 212.24 c -28.724 0 -52.528 24.594 -52.528 53.414 v 100.138 c 0 28.524 24.788 45.246 52.528 53.413 c 33.247 9.737 65.215 11.509 105.054 0 c 26.462 -7.675 52.529 -23.116 52.529 -53.413 v -20.997 H 264.867 v -32.417 h 157.58 c 30.593 0 41.904 -21.346 52.527 -53.314 C 485.992 283.244 485.501 251.57 474.975 209.372 L 474.975 209.372 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 65.3654 64.1885)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(191,152,22)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-321.3654, -320.1885)",
    d: "M 264.431 494.32 c -17.747 0 -35.738 -2.743 -55.001 -8.385 c -38.515 -11.339 -59.718 -33.715 -59.718 -63.01 V 322.788 c 0 -34.374 28.634 -63.414 62.528 -63.414 h 105.054 c 29.678 0 55.71 -26.491 55.71 -56.691 v -46.626 c 0 -5.523 4.478 -10 10 -10 h 39.443 c 17.276 0 31.546 6.279 42.412 18.664 c 8.734 9.955 15.217 23.77 19.818 42.232 c 11.191 44.863 11.126 78.483 -0.219 112.415 c -10.11 30.424 -23.23 60.144 -62.012 60.144 h -147.58 v 12.417 h 94.956 c 5.522 0 10 4.478 10 10 v 20.997 c 0 20.844 -10.365 48.696 -59.744 63.018 C 300.563 491.581 282.364 494.32 264.431 494.32 z M 212.24 279.374 c -23.053 0 -42.528 19.881 -42.528 43.414 v 100.138 c 0 26.51 28.415 38.834 45.353 43.82 c 17.639 5.166 33.33 7.574 49.366 7.574 c 16.028 0 32.413 -2.482 50.088 -7.589 c 30.059 -8.718 45.305 -23.457 45.305 -43.806 v -10.997 h -94.956 c -5.522 0 -10 -4.478 -10 -10 v -32.417 c 0 -5.522 4.478 -10 10 -10 h 157.58 c 21.148 0 31.204 -10.857 43.037 -46.468 c 10.189 -30.476 10.126 -59.805 -0.213 -101.252 c -7.883 -31.631 -21.09 -45.735 -42.824 -45.735 h -29.443 v 36.626 c 0 41.571 -34.671 76.691 -75.71 76.691 H 212.24 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -68.5855 -185.6175)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-187.4145, -70.3825)",
    d: "M 187.414 89.594 c -10.479 0 -18.975 -8.591 -18.975 -19.164 c 0.094 -10.668 8.496 -19.259 18.975 -19.259 c 10.386 0 18.976 8.685 18.976 19.259 C 206.39 81.003 197.894 89.594 187.414 89.594 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.908 184.8645)",
    id: "comp_x5F_267-python"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-314.908, -440.8645)",
    d: "M 314.908 460.076 c -10.479 0 -18.976 -8.591 -18.976 -19.164 c 0.095 -10.668 8.496 -19.259 18.976 -19.259 c 10.385 0 18.976 8.685 18.976 19.259 C 333.884 451.485 325.388 460.076 314.908 460.076 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1463 0 0 0.1463 332.6289 303.5324)",
    id: 877392
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -17.2343 43.32)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-238.7658, -299.32)",
    d: "M 333.283 307.117 c 8.807 -6.02 21.023 -11.23 21.023 -11.23 s -34.768 6.29 -69.357 9.165 c -42.315 3.503 -87.775 4.221 -110.595 1.167 c -53.996 -7.187 29.647 -27.044 29.647 -27.044 s -32.433 -2.154 -72.413 17.07 C 84.422 319.066 248.383 329.487 333.283 307.117 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.0967 -103.8615)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(248,152,29)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-254.9033, -152.1385)",
    d: "M 256.56 278.277 c -17.07 -38.362 -74.659 -72.054 0 -130.99 C 349.727 73.797 301.93 26 301.93 26 c 19.316 75.917 -67.92 98.917 -99.456 146.084 C 181.001 204.337 212.986 238.927 256.56 278.277 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 52.244 -48.788)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(248,152,29)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-308.2441, -207.212)",
    d: "M 359.518 119.975 c 0.09 0 -157.403 39.351 -82.205 125.958 c 22.191 25.516 -5.84 48.516 -5.84 48.516 s 56.332 -29.108 30.457 -65.495 C 277.762 194.993 259.254 178.103 359.518 119.975 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 132.791 64.0716)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-388.791, -320.0716)",
    d: "M 354.039 362.999 c -0.449 1.078 -1.797 2.247 -1.797 2.336 c 115.266 -30.277 72.861 -106.824 17.787 -87.416 c -4.852 1.707 -7.365 5.66 -7.365 5.66 s 3.053 -1.259 9.883 -2.696 C 400.396 275.044 440.377 318.168 354.039 362.999 L 354.039 362.999 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -10.1211 183.5462)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-245.8789, -439.5461)",
    d: "M 396.443 418.971 c 0 0 13.027 10.692 -14.285 19.047 c -52.018 15.722 -216.339 20.483 -261.979 0.63 c -16.441 -7.099 14.374 -17.072 24.078 -19.137 c 10.061 -2.157 15.901 -1.799 15.901 -1.799 c -18.238 -12.847 -117.963 25.247 -50.671 36.119 C 292.945 483.657 444.061 440.443 396.443 418.971 L 396.443 418.971 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -4.9663 144.7712)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-251.0337, -400.7712)",
    d: "M 195.557 381.776 c -70.706 19.766 43.035 60.555 133.055 22.011 c -14.732 -5.748 -25.334 -12.397 -25.334 -12.397 c -40.16 7.637 -58.756 8.175 -95.233 4.043 C 177.948 392.019 195.557 381.776 195.557 381.776 L 195.557 381.776 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 30.521 208.21)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-286.521, -464.21)",
    d: "M 357.092 469.103 c -70.705 13.296 -157.941 11.771 -209.602 3.233 c 0 -0.088 10.602 8.716 65.046 12.22 c 82.834 5.302 210.051 -2.966 213.016 -42.136 C 425.553 442.42 419.803 457.245 357.092 469.103 L 357.092 469.103 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -7.6578 93.9844)",
    id: "_x31_81-java"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(83,130,161)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-248.3421, -349.9844)",
    d: "M 317.922 343.144 c -53.188 10.243 -84.003 9.973 -122.904 5.93 c -30.098 -3.145 -10.422 -17.698 -10.422 -17.698 c -77.982 25.874 43.304 55.164 152.281 23.269 C 325.289 350.601 317.922 343.144 317.922 343.144 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0505 -0.0068 0.0068 0.0505 796.1875 391.7239)",
    id: 895995
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25 0 0 25 0 161.955)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 9.91557,
    y1: 35.0726,
    x2: 22.1997,
    y2: 22.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9.700000000000001%",
    style: {
      stopColor: "rgb(0,149,213)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30.099999999999998%",
    style: {
      stopColor: "rgb(35,138,217)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62.1%",
    style: {
      stopColor: "rgb(85,123,222)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.4%",
    style: {
      stopColor: "rgb(116,114,226)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(128,110,227)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_26)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -22.4782)",
    d: "M 3 28.9999 L 16.0433 15.9565 L 29 28.9999 H 3 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25 0 0 25 -161.9588 -153.125)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 4.8239,
    y1: 8.22556,
    x2: 11.9583,
    y2: 1.09116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "11.799999999999999%",
    style: {
      stopColor: "rgb(0,149,213)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41.8%",
    style: {
      stopColor: "rgb(60,131,220)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69.6%",
    style: {
      stopColor: "rgb(109,116,225)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.3%",
    style: {
      stopColor: "rgb(128,110,227)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_27)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-9.5216, -9.875)",
    d: "M 3 3 H 16.0433 L 3 16.75 V 3 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(25 0 0 25 0 0)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: -1.37753,
    y1: 26.9044,
    x2: 22.8167,
    y2: 2.71007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "10.7%",
    style: {
      stopColor: "rgb(199,87,188)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "21.4%",
    style: {
      stopColor: "rgb(208,96,154)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42.5%",
    style: {
      stopColor: "rgb(225,114,92)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60.5%",
    style: {
      stopColor: "rgb(238,126,47)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "74.3%",
    style: {
      stopColor: "rgb(245,134,19)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "82.3%",
    style: {
      stopColor: "rgb(248,137,9)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_28)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-16, -16)",
    d: "M 16.0433 3 L 3 16.7367 V 29 L 16.0433 15.9567 L 29 3 H 16.0433 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0793 0 0 0.0793 670.694 438.6708)",
    id: 215179
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9197 0 0 2.9197 -54.6185 60.5892)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(229,91,45)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-109.2935, -157.7521)",
    d: "M 145.726081 42.0651946 L 145.726081 84.1347419 L 218.586952 126.204312 L 218.586952 84.1347419 L 145.726081 42.0651946 Z M -1.98726454e-7 84.1347419 L -1.98726454e-7 126.204312 L 36.4304238 147.234755 L 36.4304238 105.169527 L -1.98726454e-7 84.1347419 Z M 109.291294 105.169527 L 72.8608701 126.204312 L 72.8608701 252.404316 L 109.291294 273.439101 L 109.291294 189.304303 L 145.726081 210.339088 L 145.726081 168.26954 L 109.291294 147.234755 L 109.291294 105.169527 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9197 0 0 2.9197 51.754 60.5892)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(237,142,36)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-145.7261, -157.7521)",
    d: "M 145.726081 42.0651946 L 36.4304238 105.169527 L 36.4304238 147.234755 L 109.291294 105.169527 L 109.291294 147.234755 L 145.726081 126.204312 L 145.726081 42.0651946 Z M 255.021717 63.0999794 L 218.586952 84.1347419 L 218.586952 126.204312 L 255.021717 105.169527 L 255.021717 63.0999794 Z M 182.156505 147.234755 L 145.726081 168.26954 L 145.726081 210.339088 L 182.156505 189.304303 L 182.156505 147.234755 Z M 145.726081 210.339088 L 109.291294 189.304303 L 109.291294 273.439101 L 145.726081 252.404316 L 145.726081 210.339088 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.9197 0 0 2.9197 -1.4292 -154.3518)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(248,191,60)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-127.5109, -84.1348)",
    d: "M 145.726081 -0.0000341864288 L -1.98726454e-7 84.1347419 L 36.4304238 105.169527 L 145.726081 42.0651946 L 218.586952 84.1347419 L 255.021717 63.0999794 L 145.726081 -0.0000341864288 Z M 145.726081 126.204312 L 109.291294 147.234755 L 145.726081 168.26954 L 182.156505 147.234755 L 145.726081 126.204312 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdev);
export default __webpack_public_path__ + "static/media/webdev.f1dd773f1b94c220db2cf3f4b2ec8804.svg";
export { ForwardRef as ReactComponent };